import { OnDestroy } from '@angular/core';
import { AiToolOffice } from './ai-tool-office';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { FormsService } from 'src/app/applicationModules/eSignature/services/forms.service';
import {
  FormAuditType,
  NAVIGATION,
  OCRType,
  ProjectTempType,
} from 'src/app/middleware/common/Enum/common.enum';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { map, startWith } from 'rxjs/operators';
import { LoaderService } from '../../shared/loader/loader.service';
import { AddAITempCategoryComponent } from '../addAITempCategory/addAITempCategory.component';
import { ToastrService } from 'ngx-toastr';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import {
  MatAutocomplete,
  MatAutocompleteSelectedEvent,
} from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { AddQuestionTempCategoryComponent } from '../addQuesTempCategory/addQuesTempCategory.component';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { FlatTreeControl } from '@angular/cdk/tree';
import {
  MatTreeFlatDataSource,
  MatTreeFlattener,
} from '@angular/material/tree';
import { Router } from '@angular/router';
import { DataSharingService } from '../resuableServices/data-sharing.service';
import { AfterViewInit } from '@angular/core';
import { PaycheckErrorComponent } from '../paycheckError/paycheckError.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { AiQuestionComponent } from '../../shared/common/ai-question/ai-question.component';
import { AddAIQualificationTemplateComponent } from '../addAIQualificationTemplate/addAIQualificationTemplate.component';
import { SaveUpdateQualifyingTemplate } from '../saveUpdateQualifyingTemplate/saveUpdateQualifyingTemplate.component';
import { ImportQualifyingTemplateComponent } from '../importQualifyingTemplate/importQualifyingTemplate.component';
import { ConfirmDialogComponent, ConfirmDialogModel } from '../reusableComponents/confirm-dialog/confirm-dialog.component';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { SaveUpdateMemoryCardTemplateComponent } from '../saveUpdateMemoryCardTemplate/saveUpdateMemoryCardTemplate.component';
import { ImportMemoryTemplateComponent } from '../importMemoryCardTemplate/importMemoryCardTemplate.component';
import { MemoryCardDetailsComponent } from '../memoryCardDetails/memoryCardDetails.component';
import { AddAIDocumentNotesComponent } from '../addAIDocumentNotes/addAIDocumentNotes.component';
import { AddAIDocumentLinksComponent } from '../addAIDocumentLinks/addAIDocumentLinks.component';

interface QueryBlock {
  nlpTemplateID: number;
  askQAquery: string;
  apiResponseTextArea: string;
  title: string;
  isNta: boolean;
  isMedication: boolean;
  isAllergy: boolean;
  isCondition: boolean;
  isImmunization: boolean;
  isObservation: boolean;
  isMedicationSaved: boolean;
  position: number;
  choosenAnswer: string;
  choosenPromptID: string;
  staticTitleForChoosenID: string;
  systemPromptID: number;
}
export interface State {
  name: string;
  fax: string;
  role: string;
  pic: string;
}

@Component({
  selector: 'app-ai-details',
  templateUrl: './ai-details.component.html',
  styleUrls: ['./ai-details.component.scss'],
})
export class AiDetailsComponent implements OnInit, OnDestroy {
  form: FormGroup;
  @ViewChild('medicationChild') private childComponent: AiQuestionComponent;
  @ViewChild('pdfscroll', { static: true }) pdfscrolls: ElementRef;
  // @ViewChild('pdfViewerContainer', { static: true }) pdfContainer: ElementRef;
  @ViewChild('pdfViewerContainer', { static: false }) pdfContainer: ElementRef;
  @ViewChild('pdfThumbnailContainer', { static: false })
  //@ViewChild('pdfThumbnailContainer', { static: true })
  pdfThumbnailContainer: ElementRef;
  @Input() pdfURL: string = '';
  // Source file was deleted in File Manager but is still served for this referral (API flag).
  isFileDeleted = false;
  @Input() documentId: any;
  @Input() aiAutomationID: number = 0;
  @Input() typeIdCCC: number = 0;
  @Input() documentName: string = '';
  @Input() cType: number = 0;
  @Input() transactionID3c: number = 0;
  @Input() docFrom: number = 0;
  @Input() parentIDForAddFiles: any;
  @Input() Name: string = '';
  @Input() Email: string = '';
  @Input() openFrom: string = '';
  @Input() froms: string = '';
  // [per-office 2026-10-04] the office the tool works for when it is not the logged-in one
  // (Referral Management > Recipients popup, a provider's line). 0 = the logged-in office.
  @Input() targetOfficeID: number = 0;
  CoreShowName: string = '';
  ContactShowName: string = '';
  CompanyShowName: string = '';
  menuModulesList: any = ([] = []);
  stateCtrlValue: string;
  objectList: any = [];

  toggleChange3c = true;


  ShowAttchedToCore: boolean = true;
  ShowAttchedToContact: boolean = false;
  ShowAttchedToCompany: boolean = false;

  checkedAttachCore: boolean = true;
  checkedAttachContact: boolean = false;
  checkedAttachCompany: boolean = false;

  attachedToSelectedCore: any = ([] = []);
  attachedToSelectedContact: any = ([] = []);
  attachedToSelectedCompany: any = ([] = []);

  attachedToCoreList: any = ([] = []);
  attachedToContactList: any = ([] = []);
  attachedToCompanyList: any = ([] = []);

  CorefolderID: number = 0;
  ContactfolderID: number = 0;
  CompanyfolderID: number = 0;
  roleIdList: any = [];

  selectedCoreId: number = 0;
  selectedContactId: number = 0;
  selectedCompanyId: number = 0;

  CreateField: boolean = true;
  Finish: boolean = true;
  fieldListFiltered: any = [];
  selectedFileArray: any = ([] = []);

  fieldListFilteredAI: any = [];

  name: string = '';
  email: string = '';

  timeout = null;

  stateCtrl = new FormControl();
  filteredStates: Observable<State[]>;

  transactionID: number = 0;
  folderID: number = 0;

  imageUrl: string = '';
  status: string = '';

  showAddCore: boolean = false;
  searchName: string = '';
  Module: string = '';

  organizationId: string;
  databaseId: string;
  responseHolder: any;
  LoggedInEmailId: string = '';
  currentUser: any;
  OfficeIDList: any = [];
  myOfficeID: any;
  typeId: any;

  feildsCtrl: FormControl;
  feildsCtrlAI: FormControl;

  filteredFeilds: any = ([] = []);
  filteredFeildsAI: any = ([] = []);

  Feildproperty: any = ([] = []);
  FeildpropertyAI: any = ([] = []);

  synonymFieldsAI: any = ([] = []);
  systemFieldsAI: any = ([] = []);
  systemFieldsAIForSearch: any = ([] = []);
  items: any = ([] = []);
  typeForAddCategory: number = 1;
  @Output() closeAIToolEmit = new EventEmitter<boolean>();
  totalNumberPages: number = 0;

  navbar = ['AI Data', 'Qualifying', 'QUESTIONS', 'Assistant'];
  currentNavigation = NAVIGATION.AIData;
  BoundingBoxKeyValueData: any;
  pdfarray: any;
  typeForRun: number = 0;
  pdfPageheight: number = 0;
  askQAquery: string = '';
  apiResponseTextArea: any;
  CurrentPage: number = 1;
  ocrData: any;
  VectorDocumentID: any = '';
  mainModuleName: string = '';
  isShare: boolean = false;
  Feilds: string[] = [];
  allTags: string[] = [];
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  @ViewChild('feildInput') feildInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;
  rolesAsssign: any[] = [];
  isOrganizationAdmin: boolean = false;
  isOfficeAdmin: boolean = false;
  isSuperAdmin: boolean = false;
  closeAllAccordian = false;
  openAllAccordian = false;
  ocrTextFileUrl: string = "";

  ShowPaycheck: boolean = false;
  ShowPointClickCare: boolean = false;
  showPCC: boolean = false;
  txtDynamic3c: string = "";
  mainModuleNameForDetails: string = "";

  private _transformer = (node: FoodNode, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      formFolderName: node.formFolderName,
      formFolderID: node.formFolderID,
      parentID: node.parentID,
      level: level,
      isShared: node.isShared,
    };
  };

  treeControl = new FlatTreeControl<ExampleFlatNode>(
    (node) => node.level,
    (node) => node.expandable
  );
  treeFlattener = new MatTreeFlattener(
    this._transformer,
    (node) => node.level,
    (node) => node.expandable,
    (node) => node.children
  );
  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;
  pdfTextFromOCR: any;
  choosenPromptID: any;
  sysPromptList: any[] = [];
  ddlsystemPromptID: number = 0;
  AIChatQuery: string = '';
  fieldsWithSynonymsArray: any = [] = [];
  // text = 'Refer to these pages: [p.2, p.3, p.5]';
  documentType: string = "pdf";
  viewer = 'google';
  showPdfViewer: boolean = true;
  isContentProcessed: boolean = false;
  isFieldProcessed: boolean = false;
  isPromptProcessed: boolean = false;
  aiAutomationProcessStatus: number = 0;
  showAIQuestionTickMark: boolean = false;
  showAIQuestionLoader: string = "";
  fileContent: any = "";
  referralID: number = 0;
  

  constructor(
    private sanitizer: DomSanitizer,
    private renderer: Renderer2,
    private statusConst: StatusConstant,
    private dialog: MatDialog,
    private formsService: FormsService,
    private reusableClass: ReusableClasses,
    private encryptionAlgo: EncryptionService,
    private loaderService: LoaderService,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private coreService: CoreService,
    private router: Router,
    private _dataSharingService: DataSharingService,
    private elRef: ElementRef) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId') ?? '';
    this.organizationId = sessionStorage.getItem('organizationID') ?? '';
    this.LoggedInEmailId = sessionStorage.getItem('email') ?? '';
    const token = this.encryptionAlgo.get(
      this.reusableClass.encryptionKey,
      encryptedtoken
    );
    this.currentUser = jwt_decode(token);
    var offices = JSON.parse(sessionStorage.getItem('officeList') || '[]');
    offices.forEach((oe: any) => {
      this.OfficeIDList.push(oe.officeID);
      if (oe.isMyoffice == true) this.myOfficeID = oe.officeID;
    });

    this.feildsCtrl = new FormControl();
    this.filteredFeilds = this.feildsCtrl.valueChanges.pipe(
      startWith(''),
      map((feilds) =>
        feilds ? this.filterFeilds(feilds) : this.Feildproperty.slice()
      )
    );

    this.stateCtrl.setValue(this.stateCtrlValue);
    this.filteredStates = this.stateCtrl.valueChanges.pipe(
      startWith(''),
      map((state) => (state ? this._filterStates(state) : this.states.slice()))
    );
  }

  trackByFn(index: number, item: any): number {
    return item.systemPromptID; // Use unique identifier
  }

  filterFeilds(name: string) {
    let arr = this.Feildproperty.filter(
      (feilds: any) =>
        feilds.fieldName.toLowerCase().indexOf(name.toLowerCase()) === 0
    );
    if (arr.length == 0) {
      this.CreateField = false;
      this.Finish = true;
    }
    return arr;
  }

  openAll() {
    this.openAllAccordian = true;
    this.closeAllAccordian = false;
  }

  closeAll() {
    this.closeAllAccordian = true;
    this.openAllAccordian = false;
  }

  states = this.objectList;

  private _filterStates(value: string): State[] {
    const filterValue = value.toLowerCase();
    return this.states.filter(
      (state: any) => state.name.toLowerCase().indexOf(filterValue) === 0
    );
  }

  ngOnDestroy(): void {
    AiToolOffice.clear();
  }

  async ngOnInit(): Promise<void> {
    // [per-office] every call of the tool, its tabs and its dialogs uses this office
    const targetOffice = Number(this.targetOfficeID) > 0 ? Number(this.targetOfficeID) : 0;
    if (targetOffice > 0) this.myOfficeID = targetOffice;
    AiToolOffice.set(targetOffice);
    //this.getLinkedText();
    //this.VectorDocumentID="6a6c8af5-99d0-4371-b5e6-6889308b6035";
    this.getQueryList(true);
    this.GetOCRJSonDataByURL();
    this.getFileManagerDetails();

    await this.loadPdfJs(
      'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.10.377/pdf.min.js'
    );

    var paychecks = sessionStorage.getItem('Paycheck');
    var PointClickCare = sessionStorage.getItem('PointClickCare');
    if (paychecks == "true") {
      this.ShowPaycheck = true;
    }
    if (PointClickCare == "true") {
      this.ShowPointClickCare = true;
    }
    if (this.openFrom == "ReferralManagement") {
      await this.navigation(NAVIGATION.Qualifying);
    }
    this.froms;

    this.deletedQuery = [];

    this.menuModulesList = JSON.parse(sessionStorage.getItem('menuModules') || '[]');
    var SelectedCore = [];
    var SelectedContact = [];
    var SelectedCompany = [];

    SelectedCore = this.menuModulesList.filter(
      (x: any) => x.mainModuleName == 'Core'
    );
    if (SelectedCore.length > 0) {
      this.CoreShowName = SelectedCore[0].orgModuleName;
      this.folderID = SelectedCore[0].folderID;
    }

    SelectedContact = this.menuModulesList.filter(
      (x: any) => x.mainModuleName == 'Contact'
    );
    if (SelectedContact.length > 0) {
      this.ContactShowName = SelectedContact[0].orgModuleName;
      this.folderID = SelectedContact[0].folderID;
    }

    SelectedCompany = this.menuModulesList.filter(
      (x: any) => x.mainModuleName == 'Company'
    );
    if (SelectedCompany.length > 0) {
      this.CompanyShowName = SelectedCompany[0].orgModuleName;
      this.folderID = SelectedCompany[0].folderID;
    }

    this.rolesAsssign = JSON.parse(sessionStorage.getItem('roles') || '[]');
    if (this.rolesAsssign.length > 0) {
      this.isOfficeAdmin =
        this.rolesAsssign.find((m: any) => m.roleName == 'Office Admin') !=
        undefined;
      this.isOrganizationAdmin =
        this.rolesAsssign.find((m: any) => m.roleName == 'Organization Admin') !=
        undefined;
      this.isSuperAdmin =
        this.rolesAsssign.find((m: any) => m.roleName == 'Super Admin') != undefined;
    }
    if (this.cType == 1) {
      this.typeForAddCategory = 1;
      this.txtDynamic3c = "Update " + this.CoreShowName;
      this.mainModuleNameForDetails = "Core";
      this.transactionID = this.transactionID3c;
      this.name = this.Name;
      this.email = this.Email;
      this.toggleChange3c = false;
      this.showCoreDetail();
      this.associatedAPIs = JSON.parse(sessionStorage.getItem("associatedAPIs") || '[]');
      if (this.associatedAPIs.length > 0) {
        var checkPayCheck = [];
        var checkPCC = [];
        checkPCC = this.associatedAPIs.filter((x: any) => x.apiName == 'PointClickCare' && x.isCoreMapped == true);
        if (checkPCC.length > 0) {
          this.showPCC = true;
        } else {
          this.showPCC = false;
        }
      }

    }
    //this.getFileManagerDetails();
    // this.getAllFieldsForAITool();
    this.getmodelAccessType();
    // this.getSystemPromptTemplateList();
  }


  getFileManagerDetails() {
    // this.getSavedChatHistory();
    var ReqModel = {
      fileManagerItemID: this.documentId,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
    };
    this.loaderService.show();
    this.formsService.GetFileManagerFileDetail(ReqModel).subscribe(async (response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.showAIQuestionLoader = "";
          this.referralID = response.data.referralID;
          this.isFileDeleted = !!response.data.isFileDeleted;

          this.isFieldProcessed = response.data.isFieldProcessed;
          this.isPromptProcessed = response.data.isPromptProcessed;
          this.isContentProcessed = response.data.isContentProcessed;
          this.aiAutomationProcessStatus = response.data.aiAutomationProcessStatus;
          //this.documentName = response.data.name;
          if (this.aiAutomationProcessStatus == 1) {
            if (this.isPromptProcessed == true) {
              this.showAIQuestionTickMark = true;
            }
            if (this.isPromptProcessed == false) {
              this.showAIQuestionTickMark = false;
              this.showAIQuestionLoader = "1";
            }
          }
          if (this.aiAutomationProcessStatus == 2) {
            if (this.isPromptProcessed == true) {
              this.showAIQuestionTickMark = true;
            }
          }

          this.documentPath = response.data.azureblobPath;
          this.fieldsWithSynonymsArray = response.data.fieldsWithSynonims ? JSON.parse(response.data.fieldsWithSynonims) : []
          this.VectorDocumentID =
            response.data.vectorFileID == null ||
              response.data.vectorFileID == undefined ||
              response.data.vectorFileID == '' ||
              response.data.vectorFileID == 0
              ? ''
              : response.data.vectorFileID;
          this.isOCR = this.responseHolder.data.isOCR;
          // this.pdfTextFromOCR =
          //   this.responseHolder.data.content != null &&
          //     this.responseHolder.data.content != undefined &&
          //     this.responseHolder.data.content != ''
          //     ? this.responseHolder.data.content
          //     : '';
          if (this.responseHolder.data.ocrTextFileUrl != null) {
            this.ocrTextFileUrl = this.responseHolder.data.ocrTextFileUrl;
          } else {
            // this.ocrTextFileUrl="";
            this.prepareOCRFiles();
          }
          if (this.responseHolder.data.documentData != null) {
            var documentdata: any;
            this.systemFeildsList = [];
            documentdata = JSON.parse(this.responseHolder.data.documentData);
            if (documentdata.length > 0) {
              documentdata.forEach((e: any) => {
                var obj = {
                  id: this.randomId(),
                  fieldID: e.FieldID,
                  fieldName: e.FieldName,
                  formFieldName: e.Key,
                  value: e.Value,
                  colorCode: e.Key ? '#47e309' : '',
                };
                this.systemFeildsList.push(obj);
              });
            }
            this.captureSystemFieldsSnapshot();
          }
          if (this.responseHolder.data.fileNote != null) {
            this.noteDescription = this.responseHolder.data.fileNote.noteDescription;
            this.noteID = this.responseHolder.data.fileNote.noteID;
            this.noteTitle = this.responseHolder.data.fileNote.noteTitle;
          } else {
            this.noteID = 0;
            this.noteDescription = "";
            this.noteTitle = "";
          }
          // if (this.responseHolder.data.allKeyValueData != null) {
          //   this.allKeyValueDataListFormFeild = this.responseHolder.data.allKeyValueData;
          //   this.allKeyValueDataListFilterForFormFeild = this.responseHolder.data.allKeyValueData;
          //   this.allKeyValueDataListFilterForFormFeildFilter = this.responseHolder.data.allKeyValueData;
          // }
          if (this.responseHolder.data.cType == 0) {
            var SelectedCore = [];
            SelectedCore = this.menuModulesList.filter(
              (x: any) => x.mainModuleName == 'Core'
            );
            if (SelectedCore.length > 0) {
              this.folderID = SelectedCore[0].folderID;
            }
          }
          if (this.responseHolder.data.cType != 0) {
            this.typeForAddCategory = this.responseHolder.data.cType;
            //== For Core====//
            if (this.typeForAddCategory == 1) {
              this.txtDynamic3c = "Update " + this.CoreShowName;
              this.mainModuleNameForDetails = "Core";
              this.showCoreDetail();
              this.associatedAPIs = JSON.parse(sessionStorage.getItem("associatedAPIs") || '[]');
              if (this.associatedAPIs.length > 0) {
                var checkPayCheck = [];
                var checkPCC = [];

                // checkPayCheck = this.associatedAPIs.filter((x:any) => x.apiName == 'Paychex' && x.isCoreMapped == true);
                // if (checkPayCheck.length > 0) {
                //   this.showPaycheck = true;
                // } else {
                //   this.showPaycheck = false;
                // }

                checkPCC = this.associatedAPIs.filter((x: any) => x.apiName == 'PointClickCare' && x.isCoreMapped == true);
                if (checkPCC.length > 0) {
                  this.showPCC = true;
                } else {
                  this.showPCC = false;
                }
              }
            }
            //== For Contact====//
            if (this.typeForAddCategory == 2) {
              this.txtDynamic3c = "Update " + this.ContactShowName;
              this.mainModuleNameForDetails = "Contact";
              this.showContactDetail();
              this.associatedAPIs = JSON.parse(sessionStorage.getItem("associatedAPIs") || '[]');
              if (this.associatedAPIs.length > 0) {
                var checkPayCheck = [];
                var checkPCC = [];

                // checkPayCheck = this.associatedAPIs.filter((x:any) => x.apiName == 'Paychex' && x.isContactMapped == true);
                // if (checkPayCheck.length > 0) {
                //   this.showPaycheck = true;
                // } else {
                //   this.showPaycheck = false;
                // }

                checkPCC = this.associatedAPIs.filter((x: any) => x.apiName == 'PointClickCare' && x.isContactMapped == true);
                if (checkPCC.length > 0) {
                  this.showPCC = true;
                } else {
                  this.showPCC = false;
                }
              }
            }
            //== For Company====//
            if (this.typeForAddCategory == 3) {
              this.txtDynamic3c = "Update " + this.CompanyShowName;
              this.mainModuleNameForDetails = "Company";
              this.showCompanyDetail();
              checkPCC = this.associatedAPIs.filter((x: any) => x.apiName == 'PointClickCare' && x.isCompanyMapped == true);
              if (checkPCC.length > 0) {
                this.showPCC = true;
              } else {
                this.showPCC = false;
              }
            }
          }
          if (this.responseHolder.data.cid != 0) {
            this.transactionID = this.responseHolder.data.cid;
          }
          if (this.responseHolder.data.ocrPerson != null) {
            this.name = this.responseHolder.data.ocrPerson.name;
            this.email = this.responseHolder.data.ocrPerson.email;
            this.TypeIdDrp = response.data.ocrPerson.personType;
            this.toggleChange3c = false;
          }
          if (this.responseHolder.data.ocrJsonFileUrl) {

            // Loop until `this.fileContent` has a value.
            while (!this.fileContent) {
              await this.delay(1000); // Wait 1 second before checking again.
            }

            this.responseHolder.data.ocrData = this.fileContent.ocrData;
            response.data.ocrData = this.fileContent.ocrData;

            response.data.allKeyValueData = this.fileContent.allKeyValueData;
            this.responseHolder.data.allKeyValueData = this.fileContent.allKeyValueData;

            response.data.content = this.fileContent.content;
            this.responseHolder.data.content = this.fileContent.content;

            response.data.jsonData = this.fileContent.jsonData;
            this.responseHolder.data.jsonData = this.fileContent.jsonData;

            this.pdfTextFromOCR =
              this.responseHolder.data.content != null &&
                this.responseHolder.data.content != undefined &&
                this.responseHolder.data.content != ''
                ? this.responseHolder.data.content
                : '';

          }

          // Now, proceed with the rest of your logic.

          if (this.responseHolder.data.ocrData != null && this.responseHolder.data.ocrData != "No url found") {
            if (this.responseHolder.data.allKeyValueData != null) {
              this.allKeyValueDataListFormFeild = this.responseHolder.data.allKeyValueData;
              this.allKeyValueDataListFilterForFormFeild = this.responseHolder.data.allKeyValueData;
              this.allKeyValueDataListFilterForFormFeildFilter = this.responseHolder.data.allKeyValueData;
            }
            this.ocrData = this.responseHolder.data.ocrData;

            // this.ocrData = response.data.ocrData;
            this.BoundingBoxKeyValueData = JSON.parse(response.data.ocrData);
            this.BoundingBoxKeyValueData = this.BoundingBoxKeyValueData.KeyValuePairs;
            await this.waitForPdfArray();
            await this.renderPDFWithBoundingBox();
            await this.renderPDFThumbnails(this.pdfarray);
          } else {
            await this.waitForPdfArray();
            await this.renderPDFByURL(this.pdfarray);
            await this.renderPDFThumbnails(this.pdfarray);
          }
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  noteDescription: string = "";
  noteID: number = 0;
  noteTitle: string = "";

  getFileManagerDetailsForNotes() {
    var ReqModel = {
      fileManagerItemID: this.documentId,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
    };
    this.loaderService.show();
    this.formsService.GetFileManagerFileDetail(ReqModel).subscribe(async (response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {

          if (this.responseHolder.data.fileNote != null) {
            this.noteDescription = this.responseHolder.data.fileNote.noteDescription;
            this.noteID = this.responseHolder.data.fileNote.noteID;
            this.noteTitle = this.responseHolder.data.fileNote.noteTitle;
          } else {
            this.noteID = 0;
            this.noteDescription = "";
            this.noteTitle = "";
          }
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  private delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  GetOCRJSonDataByURL() {
    var ReqModel = {
      fileManagerItemID: this.documentId,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
    };
    this.formsService.GetOCRJSonDataByURL(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.fileContent = this.responseHolder.data;
        } else {
        }
      } else {
      }
    });
  }

  AddVectorFileID1(vectorFileID: any) {
    var ReqModel = {
      docFrom: this.docFrom,
      documentID: this.documentId,
      vectorFileID: vectorFileID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
    };
    this.formsService.AddVectorFileID(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
        } else {
        }
      } else {
      }
    });
  }

  prepareOCRFiles() {
    var ReqModel = {
      fileID: this.documentId,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
    };
    this.formsService.prepareOCRFiles(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.ocrTextFileUrl = this.responseHolder.data;
        } else {
        }
      } else {
      }
    });
  }

  async AddVectorFileID(vectorFileID: any) {
    const ReqModel = {
      docFrom: this.docFrom,
      documentID: this.documentId,
      vectorFileID: vectorFileID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
    };

    try {
      const response = await this.formsService
        .AddVectorFileID(ReqModel)
        .toPromise();

      if (response) {
        this.responseHolder = response;
        if (this.responseHolder.status === this.statusConst.statusSuccess) {
          // Handle success
        } else {
          // Handle failure
        }
      }
    } catch (error) {
      // Handle error if necessary
    }
  }

  processDocumentToVectorDB() {
    if (this.VectorDocumentID == '') {
      const userId = this.currentUser.UID;
      const officeId = this.myOfficeID;
      const organizationId = this.organizationId;
      this.loaderService.show();
      this.formsService
        .processDocument(this.pdfURL, userId, officeId, organizationId)
        .subscribe(
          (response) => {
            if (response.success) {
              this.toastr.success('Document processed successfully');
              this.VectorDocumentID = response.message;
              this.AddVectorFileID(response.message);
              this.loaderService.hide();
              this.runAI();
            } else {
              this.loaderService.hide();
            }
          },
          (error) => {
            this.loaderService.hide();
          }
        );
    } else {
      this.runAI();
    }
  }

  processDocumentToVectorDBDialogue(block: any) {
    if (block.prompt == '' || block.prompt == null) {
      this.toastr.warning('Please add question.', '', {
        timeOut: 3000,
      });
      return;
    }
    if (this.VectorDocumentID == '') {
      const userId = this.currentUser.UID;
      const officeId = this.myOfficeID;
      const organizationId = this.organizationId;
      this.loaderService.show();
      this.formsService
        .processDocument(this.pdfURL, userId, officeId, organizationId)
        .subscribe(
          (response) => {
            if (response.success) {
              this.toastr.success('Document processed successfully');
              this.VectorDocumentID = response.message;
              this.AddVectorFileID(response.message);
              this.loaderService.hide();
              this.runAIButton(block);
            } else {
              this.loaderService.hide();
            }
          },
          (error) => {
            this.loaderService.hide();
          }
        );
    } else {
      this.runAIButton(block);
    }
  }

  runAIButton_4o(block: any) {
    if (block.prompt == '' || block.prompt == null) {
      this.toastr.warning('Please add question.', '', {
        timeOut: 3000,
      });
      return;
    }
    //this.openpanel = this.indexx;
    this.loaderService.show();
    this.formsService
      .submit_prompt_4o(
        this.pdfURL,
        block.prompt,
        block.isNta,
        this.pdfTextFromOCR
      )
      .subscribe(
        (response) => {
          if (response.success) {
            this.loaderService.hide();
            //this.formDialog.controls['title'].setValue(block.title);
            //this.formDialog.controls['prompt'].setValue(block.askQAquery);
            this.formDialog.controls['answer'].setValue(response.response);
            // this.queryBlocks[this.indexx].apiResponseTextArea = response.response;
          } else {
            this.loaderService.hide();
            //console.error('Error querying vector DB', response.message);
          }
        },
        (error) => {
          this.loaderService.hide();
          //console.error('Error querying vector DB', error.message);
        }
      );
  }

  SendDocumentTo_4o_DBDialogue(block: any) {
    if (block.prompt == '' || block.prompt == null) {
      this.toastr.warning('Please add question.', '', {
        timeOut: 3000,
      });
      return;
    }
    this.runAIButton_4o(block);
  }

  getConcatenatedEmptyFieldNames(): string {
    return this.systemFeildsList
      .filter((item: any) => !item.value)
      .map((item: any) => item.fieldName)
      .join(', ');
  }

  runAIButton_4o_Run_Gemini(index: number, block: any, isAllprompt: boolean = false) {
    if (this.ocrTextFileUrl == "") {
      if (block && (block.title == "" || block.title == null)) {
        this.toastr.warning('Please add title.', '', {
          timeOut: 3000,
        });
        return;
      }
    }

    const nlpTemplateIDs = this.queryBlocks
      .filter(block =>
        block.apiResponseTextArea === null ||
        block.apiResponseTextArea === undefined ||
        block.apiResponseTextArea === "" ||
        block.apiResponseTextArea.trim() === ""
      )
      .map(block => block.nlpTemplateID);

    if (isAllprompt && nlpTemplateIDs && nlpTemplateIDs.length == 0) {
      this.toastr.warning('All questions are already answered.', '', {
        timeOut: 3000,
      });
      return;
    }

    let requestModel = {
      "ocrTextFileUrl": this.ocrTextFileUrl,
      "promptIds": isAllprompt == true ? nlpTemplateIDs : [
        block.nlpTemplateID
      ],
      "fileID": this.documentId,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId)
    }
    this.loaderService.show();
    this.formsService.runAIButton_4o_Run_Gemini(requestModel).subscribe(response => {
      this.responseHolder = response;
      //this.loaderService.hide();
      if (this.responseHolder.status == this.statusConst.statusSuccess) {

        //block.apiResponseTextArea=response.response
        //this.queryBlocks[index].apiResponseTextArea = this.responseHolder.data.response; 

        //this.addFileAIPrompts(0,block);     
        this.getQueryList("")
      } else {
        this.loaderService.hide();
      }
    },
      error => {
        this.loaderService.hide();
      }
    );
  }

  getEmptyFieldsWithSynonyms() {
    // Return empty array if systemFieldsList is empty or undefined
    if (!this.systemFeildsList || this.systemFeildsList.length === 0) {
      return [];
    }

    // Filter systemFieldsList to include ONLY fields with null/undefined/empty values
    const emptySystemFields = this.systemFeildsList.filter(
      (field: any) => field.value === null || field.value === undefined || field.value === ""
    );

    // Early return if no empty fields exist
    if (emptySystemFields.length === 0) {
      return [];
    }

    // Match fields and build the result
    const fieldsWithSynonyms = this.fieldsWithSynonymsArray || [];

    const result = emptySystemFields.map((systemField: any) => {
      const matchedField = fieldsWithSynonyms.find(
        (field) => field.FieldID === systemField.fieldID
      );
      return {
        fieldName: systemField.fieldName,
        synonyms: matchedField?.Synonyms || '',
      };
    });

    return JSON.stringify(result);
  }

  combineDuplicateFields(dataArray: any) {
    const fieldMap = {};

    // Process each item in the array
    dataArray.forEach((item: any) => {
      const fieldName = item.f;
      const fieldValue = item.v;

      if (fieldMap.hasOwnProperty(fieldName)) {
        // If field already exists, append value with comma if not empty
        if (fieldValue) {
          fieldMap[fieldName] = fieldMap[fieldName]
            ? `${fieldMap[fieldName]}, ${fieldValue}`
            : fieldValue;
        }
      } else {
        // If field doesn't exist, add it to the map
        fieldMap[fieldName] = fieldValue;
      }
    });

    // Convert the map back to an array format
    const result = Object.keys(fieldMap).map(fieldName => ({
      f: fieldName,
      v: fieldMap[fieldName]
    }));

    return result;
  }

  parseAndSetValuesNew(response: any): void {
    try {
      let stringToJSON = response;//JSON.parse(response);

      const parsedResponse = this.combineDuplicateFields(stringToJSON);

      // Ensure the parsedResponse is an array
      if (!Array.isArray(parsedResponse)) {
        //throw new Error("Invalid response format: Expected an array.");
      }

      // Iterate over each field in the systemFieldsList
      for (let item of this.systemFeildsList) {
        const lowerCaseFieldName = item.fieldName.toLowerCase();

        // Look for a matching object in parsedResponse
        for (let fieldObject of parsedResponse) {
          if (fieldObject.f && typeof fieldObject.f === "string") {
            const lowerCaseF = fieldObject.f.toLowerCase();

            // If field matches (case-insensitive)
            if (lowerCaseFieldName === lowerCaseF) {
              const value = fieldObject.v;

              // Check if the value is usable and not an excluded value
              if (
                value !== null &&
                value !== undefined &&
                value.toString().toLowerCase() !== "n/a" &&
                value.toString().toLowerCase() !== "undefined" &&
                value.toString().trim() !== ""
              ) {
                item.value = value;
              }

              break; // Stop checking once a match is found
            }
          }
        }
      }
    } catch (error) {
      //console.error("Error parsing response or setting values:", error);
    }
  }


  // parseAndSetValuesNew(response: string): void {
  //   try {
  //     const parsedResponse = JSON.parse(response);

  //     // Assuming this.systemFeildsList contains field names that should match keys in parsedResponse
  //     for (let item of this.systemFeildsList) {
  //       const lowerCaseFieldName = item.fieldName.toLowerCase();

  //       // Loop through each object in the parsedResponse array
  //       for (let i = 0; i < parsedResponse.length; i++) {
  //         const currentObject = parsedResponse[i];

  //         // Check if the object has the field that matches
  //         for (let key in currentObject) {
  //           if (currentObject.hasOwnProperty(key)) {
  //             // Match field name (case-insensitive) with the current object key
  //             if (key.toLowerCase() === lowerCaseFieldName) {
  //               const value = currentObject[key];

  //               // Check if the value is usable and not an excluded value
  //               if (
  //                 value !== null &&
  //                 value !== undefined &&
  //                 value.toString().toLowerCase() !== 'n/a' &&
  //                 value.toString().toLowerCase() !== 'undefined' &&
  //                 value.toString().trim() !== ''
  //               ) {
  //                 item.value = value;
  //               }

  //               break;  // Exit the loop once the value is found
  //             }
  //           }
  //         }
  //       }
  //     }
  //   } catch (error) {

  //   }
  // }

  parseAndSetValues(response: string): void {
    try {
      const parsedResponse = JSON.parse(response);

      // Assuming the response object has the relevant fields matching the field names
      for (let item of this.systemFeildsList) {
        const lowerCaseFieldName = item.fieldName.toLowerCase();
        for (let key in parsedResponse) {
          if (parsedResponse.hasOwnProperty(key)) {
            if (key.toLowerCase() === lowerCaseFieldName) {
              // Check if the value is not "N/A", "null", "undefined" or any other non-usable value
              const value = parsedResponse[key];
              if (
                value !== null &&
                value !== undefined &&
                value.toString().toLowerCase() !== 'n/a' &&
                value.toString().toLowerCase() !== 'undefined' &&
                value.toString().trim() !== ''
              ) {
                item.value = value;
              }

              break;
            }
          }
        }
      }
    } catch (error) {
      this.loaderService.hide();
      this.toastr.error('Error fetching fields, Try again', 'Parsing Error', {
        timeOut: 3000,
        progressBar: true,
        closeButton: true,
      });
    }
  }

  extractNestedTextWithBrackets(input: string): string | null {
    let level = 0;
    let extract = '';
    let inBrackets = false;

    for (const char of input) {
      if (char === '{') {
        if (level === 0) {
          inBrackets = true;
          extract += char;
        }
        level++;
      } else if (char === '}') {
        level--;
        if (inBrackets) {
          extract += char;
          if (level === 0) {
            // We have closed the top level bracket pair
            break;
          }
        }
      } else if (inBrackets) {
        extract += char;
      }
    }

    return inBrackets ? extract : null;
  }

  query_vector_dbFields() {
    this.loaderService.show();
    let query = 'Find ';
    query = query + ' ' + this.getConcatenatedEmptyFieldNames();
    query = query + ' from document?';

    const attemptQuery = (retry = false) => {
      this.formsService
        .query_vector_dbFields(query, this.VectorDocumentID)
        .subscribe(
          (response) => {
            if (response.success) {
              try {
                let extractedJson = this.extractNestedTextWithBrackets(
                  response.response
                );
                const parsedResponse = JSON.parse(extractedJson);
                this.parseAndSetValues(extractedJson);
                this.loaderService.hide();
              } catch (error) {
                if (!retry) {
                  attemptQuery(true);
                } else {
                  this.loaderService.hide();
                }
              }
            } else {
              this.loaderService.hide();
            }
          },
          (error) => {
            this.loaderService.hide();
          }
        );
    };

    attemptQuery();
  }
  /**
   * Takes a text like:
   * "- The patient was admitted on 11/29/14 for an acute COPD exacerbation 
   *    - She was treated with steroids ..."
   * and turns it into an HTML bullet list.
   */
  formatClinicalText(text: any) {
    // Trim leading/trailing spaces
    text = text.trim();

    // Split the text on ' - '
    // Note: If the text always starts with a dash, you may want to remove
    // the leading dash before splitting, or handle empty items after splitting.
    const segments = text.split(' - ');

    // Build an HTML list
    let html = '<ul>';
    segments.forEach(segment => {
      // Trim each segment to remove extra spaces
      const trimmedSegment = segment.trim();

      // Skip empty segments if any (e.g., if there's a leading dash)
      if (trimmedSegment.length > 0) {
        html += `<li>${trimmedSegment}</li>`;
      }
    });
    html += '</ul>';
    let safeHtml: SafeHtml;
    safeHtml = this.sanitizer.bypassSecurityTrustHtml(html);
    return safeHtml;
  }

  formatDynamicText(text: any) {
    // Step 1: Convert headings (lines ending with ":") into <h3> tags
    text = text.replace(/(?:^|\n)-\s*(.*?):/g, '<h3>$1:</h3>');
    // Step 2: Handle single-line key-value pairs (Heading: Content)
    text = text.replace(/<h3>(.*?)<\/h3>\s*-?\s*(.+?)(?=\n|<h3>|$)/g, '<h3>$1:</h3><p>$2</p>');
    // Step 3: Convert bullet points (-) into readable text format (• without <ul>)
    text = text.replace(/(?:^|\n)-\s*(.+?)(?=\n|$)/g, '<p>• $1</p>');
    // Step 4: Properly format nested lists and separate diagnostic values into `<p>` tags
    text = text.replace(/(\s{2,})-\s*(.+?)(?=\n|$)/g, '<p>   - $2</p>');
    // Step 5: Remove extra new lines for better readability
    text = text.replace(/\n+/g, ' ');
    return text;
  }

  /**
   * Formats an AI chat answer into the bullet / dash layout used by the chat
   * panel: the direct answer and the "Conclusion" line are prefixed with "•",
   * every supporting evidence line with "–", and the answer flows as one
   * paragraph. query_vector_AIChat() asks the model for this layout; this
   * method normalises whatever actually comes back (markdown bullets, bold
   * markers, numbering, blank lines, an echoed question) so the display stays
   * consistent and HTML-safe. Only used for successful chat answers; the
   * status / error messages keep using formatDynamicText().
   */
  formatChatAnswer(text: any): string {
    if (text === null || text === undefined) {
      return '';
    }
    const escapeHtml = (value: string) =>
      value
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');

    const lines = String(text).replace(/\r\n?/g, '\n').split('\n');
    const items: string[] = [];
    for (const line of lines) {
      const content = line
        .replace(/\*\*|__|`/g, '')                 // bold / code markers
        .replace(/^\s*#+\s*/, '')                  // markdown headings
        .replace(/^\s*(?:[-–—•*]+|\d+[.)])\s*/, '') // leading bullet / number
        .replace(/^-?([^:]+):-\s*/, '$1: ')         // legacy "-Label:- value"
        .trim();
      if (!content || /^question\s*:/i.test(content)) {
        continue;
      }
      const isBullet = items.length === 0 || /^conclusion\s*:/i.test(content);
      items.push((isBullet ? '• ' : '– ') + escapeHtml(content));
    }
    return items.join(' ');
  }

  getSavedChatHistory() {
    this.loaderService.show();
    var ReqModel = {
      CreatedBy: this.currentUser.UID,
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      Type: 1,
      TypeID: this.documentId,
      DocumentId: this.documentId
    };
    this.formsService.GetAllAIChatHostory(ReqModel).subscribe((response) => {
      this.loaderService.hide();
      if (response.status == this.statusConst.statusSuccess) {
        //convert response.data to aiChatHistoryArray new ChatHistoryModel
        // check if response.data has value and is not nul undefined or empty
        if (response.data && response.data.length > 0) {
          this.aiChatHistoryArray = response.data.map((e: any) => ({
            ChatHistoryID: e.chatHistoryID,
            aiQuestion: e.userQuestion,
            Type: e.type,
            TypeID: e.typeID,
            aiAnswer: e.aiResponse,
            DocumentId: e.documentId,
            OfficeID: e.officeID,
            OrganizationID: e.organizationID
          }));
        }
      }
    });
  }

  aiChatHistoryArray = [];

  SaveAIChatHistory(chatHistory: any) {
    var ReqModel = {
      CreatedBy: this.currentUser.UID,
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      UserQuestion: chatHistory.aiQuestion,
      AIResponse: chatHistory.aiAnswer,
      Type: 1,
      TypeID: this.documentId,
      DocumentId: this.documentId
    };
    this.loaderService.show();
    this.formsService.saveAIChatHistory(ReqModel).subscribe((response) => {
      this.loaderService.hide();

      if (response.status == this.statusConst.statusSuccess) {
        this.getSavedChatHistory();
        this.toastr.success('Saved successfully.', '', {
          timeOut: 3000,
        });
      }
      else {
        this.toastr.error('Error saving.', '', {
          timeOut: 3000,
        });
      }
    });
  }

  query_vector_AIChat() {
    this.loaderService.show();
    let query = this.AIChatQuery;
    //this.AIChatQuery 
    let lengthOfArray = this.aiChatHistoryArray.length;
    this.aiChatHistoryArray.push({
      aiQuestion: this.AIChatQuery,
      aiAnswer: ""
    });
    setTimeout(function () {
      let messageContainer = document.getElementsByClassName('chat_container')[0];
      messageContainer.scrollTop = messageContainer.scrollHeight;

    }, 500); // Calls itself after 1 second
    this.AIChatQuery = "";
    if (!this.VectorDocumentID) {
      this.aiChatHistoryArray[lengthOfArray].aiAnswer = this.formatDynamicText("Your document is still being processed and indexed for AI chat. This usually takes about 1 minute. If chat is not enabled within 2 to 3 minutes, please close this window and reopen the document. Your question has not been sent — please resubmit it once chat becomes available.");
      this.loaderService.hide();
      return
    }

    // The whole text below is sent to the backend as the chat query, so the
    // clinician's question is placed first (and repeated at the end) to keep it
    // dominant, and the instructions stay short and generic: the previous
    // version buried the question under a long elopement example, which made
    // the model anchor on that topic for unrelated questions. The requested
    // layout (bullet for the answer and conclusion, dash for each evidence
    // line) is what formatChatAnswer() renders in the chat panel.
    const chatInstructions = `QUESTION: ${query}

You are a clinical documentation assistant. Answer the QUESTION above about the attached patient document (referral, face sheet, history and physical, discharge summary, medication list, nursing or therapy notes, etc.). The document may be given to you as excerpts; use every excerpt that is relevant.

ANSWER RULES:
1. Answer only from the document. Do not guess, assume or use outside knowledge. Never invent names, dates, values or diagnoses.
2. Always answer the actual question asked. Do not repeat, restate or quote the question, and do not write the word "Question". Do not reuse the wording or topic of the layout example below.
3. Yes/no questions: the first line starts with "Yes," or "No," (or "The document does not say" when it is not documented), followed by one sentence of explanation.
4. Factual lookup (a name, date, number, phone, address, provider, facility, a single value): give the direct answer line only, with the value exactly as written in the document. No evidence lines and no Conclusion line.
5. List questions (medications, diagnoses, allergies, procedures, problems, orders, vitals, labs, contacts, dates): the first line states how many items were found, then one evidence line per item written as "Item: detail" (for example "Metformin: 500 mg by mouth twice daily"). Do not merge several items into one line.
6. Assessment or risk questions (fall, elopement, skin, pain, nutrition, cognition, behavior, discharge readiness, etc.): the first line is the direct answer in one complete sentence, then one evidence line per relevant finding written as "Label: detail" where the label names the area the evidence comes from (for example Cognitive status, Behavioral history, Support system, Safety factors, Clinical notes, Medications, Diagnoses), then a Conclusion line.
7. Summary or overview requests ("summarize", "what is this document about", "give me an overview"): the first line is a two or three sentence summary, then one evidence line per key area (Patient, Diagnoses, Medications, Allergies, Care needs, Follow-up, etc.).
8. Multi-part questions: answer every part, with at least one evidence line per part, each starting with the part it answers.
9. Timeline or "when" questions: list the events in chronological order with the date on each line.
10. If the document does not contain the information: say so plainly in the first line ("The document does not mention ..."), add the closest related documented information as evidence lines only if it genuinely relates to the question, and end with a Conclusion line stating that the answer cannot be determined from the document.
11. If the question is unclear, state in the first line how you understood it and answer that interpretation.
12. If the question is unrelated to the document (general knowledge, small talk), reply in one line that you can only answer questions about this document.
13. Answer only what was asked. Do not summarise the whole document unless asked. Answer in the same language as the question.
14. Never return an empty answer and never return only a Conclusion line.

FORMAT RULES:
1. Plain text only: no markdown, no asterisks, no bold, no headings, no tables, no emoji.
2. The direct answer line (always the first line) and the Conclusion line start with "• " (bullet).
3. Every evidence line starts with "– " (en dash).
4. One item per line, with no blank lines, numbering or other symbols.

LAYOUT (replace each placeholder with content from the document):
• Direct answer to the question in one sentence.
- Label: supporting detail quoted or closely paraphrased from the document.
• Conclusion: one sentence that answers the question.`;

    // Repeat the question after the rules so the model answers it rather than
    // the layout example.
    const finalPrompt = `${chatInstructions}

Now answer this question using the rules above: ${query}`;

    const maxAttempts = 2;
    const attemptChatQuery = (attempt: number) => {
      this.formsService
        .aiChat_Query_vector_db(finalPrompt, this.VectorDocumentID)
        .subscribe(
          (response) => {
            if (response.success) {
              this.aiChatHistoryArray[lengthOfArray].aiAnswer = this.formatChatAnswer(response.response);
              setTimeout(function () {
                let messageContainer = document.getElementsByClassName('chat_container')[0];
                messageContainer.scrollTop = messageContainer.scrollHeight;
              }, 1000);
              this.loaderService.hide();
            } else if (attempt < maxAttempts) {
              attemptChatQuery(attempt + 1);
            } else {
              this.aiChatHistoryArray[lengthOfArray].aiAnswer = this.formatDynamicText("We could not get a response from the AI service after retrying. Please try sending your question again in a moment.");
              this.loaderService.hide();
            }
          },
          (error) => {
            if (attempt < maxAttempts) {
              attemptChatQuery(attempt + 1);
            } else {
              this.aiChatHistoryArray[lengthOfArray].aiAnswer = this.formatDynamicText("We could not reach the AI service after retrying. Please check your connection and try sending your question again.");
              this.loaderService.hide();
            }
          }
        );
    };
    attemptChatQuery(1);

  }


  getFieldsValuesforNLP() {
    this.loaderService.show();
    var query = "";
    query = query + ' ' + this.getEmptyFieldsWithSynonyms();
    //query = query + ' from document?';
    query = query.replace(/\s*,\s*/g, ',');
    query = query.replace(/^\s+/, '');
    const attemptQuery = (retry = false) => {
      this.formsService.runAIButton_4o_Run_Gemini_NLP({ Query: query, OcrTextFileUrl: this.ocrTextFileUrl }).subscribe(
        (response) => {
          this.responseHolder = response;
          //this.loaderService.hide();
          if (this.responseHolder.status == this.statusConst.statusSuccess) {

            try {
              // let extractedJson = this.extractNestedTextWithBrackets(
              //   response.response
              // ); 
              let extractedJson = this.responseHolder.data.response;

              //let extractedJson="[{\"f\":\"Name\",\"v\":\"MORTIMER, JULI M\"},{\"f\":\"Weight\",\"v\":\"59.09\"},{\"f\":\"Temp\",\"v\":\"98.6\"},{\"f\":\"BP\",\"v\":\"140/70\"},{\"f\":\"Pulse\",\"v\":\"56\"},{\"f\":\"Respirations\",\"v\":\"15\"},{\"f\":\"Blood Sugar\",\"v\":\"113\"},{\"f\":\"Email\",\"v\":\"\"},{\"f\":\"Phone\",\"v\":\"530-776-3064\"},{\"f\":\"Address\",\"v\":\"1586 HEMLOCK AVE ANDERSON, CA 96007\"},{\"f\":\"Fax\",\"v\":\"\"},{\"f\":\"MRN\",\"v\":\"M000374963\"},{\"f\":\"Primary Diagnosis\",\"v\":\"acute metabolic / hepatic encephalopathy\"},{\"f\":\"Diagnosis\",\"v\":\"ALOC, Mechanical Fall\"},{\"f\":\"Admission Date\",\"v\":\"09/12/24\"},{\"f\":\"SSN\",\"v\":\"555-33-5467\"},{\"f\":\"Medicare Number\",\"v\":\"7PH2829VC06\"},{\"f\":\"Insurance Company\",\"v\":\"MEDICARE A&B, PARTNERSHIP HEALTH PLAN CA\"},{\"f\":\"Policy No.\",\"v\":\"7PH2829VC06, 91535268A1\"},{\"f\":\"Doctor\",\"v\":\"PENA, LLOYD S MD, BAWA, AMIT MD\"},{\"f\":\"Medications\",\"v\":\"Aspirin EC, Cyanocobalamin, Duloxetine HCI, Folic Acid, Lactulose, Levothyroxine Sodium, Paroxetine Hcl, Propranolol Hcl, Rifaximin, Spironolactone, Thiamine HCI, Oxycodone-Acetaminophen, CefTRIAXone, normal saline, Docusate Sodium, Chlordiazepoxide HCI, Ondansetron HCI, Dextrose\"}]"    
              //const parsedResponse = JSON.parse(extractedJson);
              this.parseAndSetValuesNew(extractedJson);
              this.loaderService.hide();
            } catch (error) {
              if (!retry) {
                attemptQuery(true);
              } else {
                this.loaderService.hide();
              }
            }
          } else {
            this.loaderService.hide();
          }
        },
        (error) => {
          this.loaderService.hide();
        }
      );
    };

    attemptQuery();
  }

  askquestion: string = '';
  answer: string = '';
  indexx: number = 0;
  title: string = '';

  // Initialize the array with one QueryBlock object
  queryBlocks: QueryBlock[] = [
    {
      nlpTemplateID: 0,
      askQAquery: '',
      apiResponseTextArea: '',
      title: '',
      isNta: false,
      position: 0,
      choosenAnswer: '',
      choosenPromptID: '',
      staticTitleForChoosenID: '',
      systemPromptID: 0,
      isMedication: false,
      isAllergy: false,
      isCondition: false,
      isImmunization: false,
      isObservation: false,
      isMedicationSaved: false
    },
  ];

  formDialog: FormGroup;

  addQueryBlock(templateRef: TemplateRef<any>) {
    let group = {};
    this.ddlsystemPromptID = 0;
    this.clinicalModelLocked = false;
    this.formDialog = new FormGroup(group);
    this.formDialog.addControl('title', this.formBuilder.control(''));
    this.formDialog.addControl('prompt', this.formBuilder.control(''));
    this.formDialog.addControl('answer', this.formBuilder.control(''));
    this.formDialog.addControl('isNta', this.formBuilder.control(false));
    this.formDialog.addControl('isMedication', this.formBuilder.control(false));
    this.formDialog.addControl('isAllergy', this.formBuilder.control(false));
    this.formDialog.addControl('isCondition', this.formBuilder.control(false));
    this.formDialog.addControl('isImmunization', this.formBuilder.control(false));
    this.formDialog.addControl('isObservation', this.formBuilder.control(false));
    this.dialog.open(templateRef, {
      panelClass: 'addAiModalBox',
    });
    //this.queryBlocks.push({nlpTemplateID:0, askQAquery: '', apiResponseTextArea: '' });
  }

  addQuestions(data: any) {
    if (data.title == '' || data.title == null) {
      this.toastr.warning('Please add title.', '', {
        timeOut: 3000,
      });
      return;
    }
    if ((data.prompt == '' || data.prompt == null) && this.ddlsystemPromptID == 0) {
      this.toastr.warning('Please add question.', '', {
        timeOut: 3000,
      });
      return;
    }
    // Only one question per clinical type is allowed on a document.
    const dupClinicalLabel = this.findDuplicateClinicalType(data);
    if (dupClinicalLabel) {
      this.toastr.warning(
        'A "' + dupClinicalLabel + '" clinical question has already been added. Only one question per clinical type is allowed — please edit or remove the existing one instead.',
        '', { timeOut: 6000 });
      return;
    }
    var ReqModel = {
      documentID: this.documentId,
      promptID: 0, //this.nlpTemplateID,//this.queryBlocks[index].nlpTemplateID,
      prompt: data.prompt, //this.queryBlocks[index].askQAquery,
      reply: data.answer, //this.queryBlocks[index].apiResponseTextArea,
      title: data.title,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      isNta: data.isNta,
      isMedication: data.isMedication,
      isAllergy: data.isAllergy,
      isCondition: data.isCondition,
      isImmunization: data.isImmunization,
      isObservation: data.isObservation,
      position: this.queryBlocks.length + 1,
      ChoosenPromptID: this.choosenPromptID,
      staticTitleForChoosenID: data.title,
      systemPromptID: this.ddlsystemPromptID
    };
    this.loaderService.show();
    this.formsService.addFileAIPrompt(ReqModel).subscribe((response) => {
      this.choosenPromptID = 0;
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (
          this.responseHolder.status == this.statusConst.statusSuccess &&
          this.responseHolder.data != null
        ) {
          this.toastr.success('Question added successfully.', '', {
            timeOut: 3000,
          });
          this.getQueryList(true);
          this.close();
        } else {
          this.close();
          this.loaderService.hide();
        }
      } else {
        this.close();
        this.loaderService.hide();
      }
    });
  }

  addQuestionsListFromTemplate(data: any) {
    var ReqModel = {
      documentID: this.documentId,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      qaList: data,
      isNta: data.isNta,
    };
    this.loaderService.show();
    this.formsService.addFileAIPrompt(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (
          this.responseHolder.status == this.statusConst.statusSuccess &&
          this.responseHolder.data != null
        ) {
          this.toastr.success('Question added successfully.', '', {
            timeOut: 3000,
          });
          this.getQueryList(true);
          this.close();
        } else {
          this.close();
          this.loaderService.hide();
        }
      } else {
        this.close();
        this.loaderService.hide();
      }
    });
  }

  onCheckboxChange(selectedControl: string, event: any) {
    const controls = [
      'isNta',
      'isMedication',
      'isAllergy',
      'isImmunization',
      'isCondition',
      'isObservation'
    ];
    controls.forEach(control => {
      if (control === selectedControl) {
        // Set based on checked / unchecked
        this.formDialog.get(control)?.setValue(event.checked, { emitEvent: false });
      } else {
        // Uncheck all others only if current is checked
        if (event.checked) {
          this.formDialog.get(control)?.setValue(false, { emitEvent: false });
        }
      }
    });
  }

  // onCheckboxChange(selectedControl: string) {

  //   const controls = [
  //     'isNta',
  //     'isMedication',
  //     'isAllergy',
  //     'isImmunization',
  //     'isCondition',
  //     'isObservation'
  //   ];
  //   controls.forEach(control => {
  //     if (control === selectedControl) {
  //       this.formDialog.get(control)?.setValue(true, { emitEvent: false });
  //     } else {
  //       this.formDialog.get(control)?.setValue(false, { emitEvent: false });
  //     }
  //   });
  // }


  runAIButton(block: any) {
    if (block.prompt == '' || block.prompt == null) {
      this.toastr.warning('Please add question.', '', {
        timeOut: 3000,
      });
      return;
    }
    //this.openpanel = this.indexx;
    this.loaderService.show();
    this.formsService
      .query_vector_db(block.prompt, this.VectorDocumentID)
      .subscribe(
        (response) => {
          if (response.success) {
            this.loaderService.hide();
            //this.formDialog.controls['title'].setValue(block.title);
            //this.formDialog.controls['prompt'].setValue(block.askQAquery);
            this.formDialog.controls['answer'].setValue(response.response);
            // this.queryBlocks[this.indexx].apiResponseTextArea = response.response;
          } else {
            this.loaderService.hide();
            //console.error('Error querying vector DB', response.message);
          }
        },
        (error) => {
          this.loaderService.hide();
          //console.error('Error querying vector DB', error.message);
        }
      );
  }

  close() {
    this.dialog.closeAll();
  }

  query_vector_db(index: number) {
    this.loaderService.show();
    this.formsService
      .query_vector_db(
        this.queryBlocks[index].askQAquery,
        this.VectorDocumentID
      )
      .subscribe(
        (response) => {
          if (response.success) {
            this.loaderService.hide();
            this.queryBlocks[index].apiResponseTextArea = response.response;
          } else {
            this.loaderService.hide();
            //console.error('Error querying vector DB', response.message);
          }
        },
        (error) => {
          this.loaderService.hide();
          //console.error('Error querying vector DB', error.message);
        }
      );
  }

  async FetchDocAsync() {
    this.loaderService.show();
    var ReqModel = { url: this.pdfURL };
    this.formsService
      .FetchDocAsync(ReqModel)
      .then((response) => response.arrayBuffer())
      .then(async (arrayBuffer) => {
        // Call both render methods
        this.pdfarray = arrayBuffer;
        this.loaderService.hide();
        // await this.renderPDFByURL(arrayBuffer);
        // await this.renderPDFThumbnails(arrayBuffer);
        //this.getFileManagerDetails();
      })
      .catch((error) => {
        this.loaderService.hide();
        //console.error('Error fetching the zip file:', error);
      });
  }

  async waitForPdfArray(timeout = 10000, interval = 100): Promise<void> {
    const start = Date.now();
    while (!this.pdfarray) {
      if (Date.now() - start > timeout) {
        throw new Error('Timeout waiting for pdfarray to be loaded');
      }
      await new Promise(res => setTimeout(res, interval));
    }
  }

  async loadPdfJs(src: string) {
    const script = this.renderer.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    script.onload = async () => {
      await this.FetchDocAsync(); // Call the method here
    };
    script.onerror = () => console.error('Error loading PDF.js');
    this.renderer.appendChild(document.head, script);
  }

  // async renderPDFByURL(_arrayBuffer: any) {
  //   this.pdfarray=_arrayBuffer;
  //   const loadingTask = (window as any).pdfjsLib.getDocument({data: this.pdfarray});
  //   const pdf = await loadingTask.promise;

  //   this.totalNumberPages =pdf.numPages;

  //   for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
  //     const page = await pdf.getPage(pageNum);
  //     const viewport = page.getViewport({ scale: 1.5 });
  //     const canvas = this.renderer.createElement('canvas');
  //     const ctx = canvas.getContext('2d');

  //     const viewport1 = page.getViewport({ scale: 1 });

  //     canvas.height = viewport.height;
  //     canvas.width = viewport.width;

  //     this.pdfPageheight =viewport1.height;

  //     const renderContext = {
  //       canvasContext: ctx,
  //       viewport: viewport
  //     };

  //     await page.render(renderContext).promise;
  //     this.pdfContainer.nativeElement.appendChild(canvas);
  //   }
  // }

  async renderPDFByURL(_arrayBuffer: any) {
    //this.pdfarray = _arrayBuffer;
    const loadingTask = (window as any).pdfjsLib.getDocument({
      data: this.pdfarray,
    });
    const pdf = await loadingTask.promise;

    this.totalNumberPages = pdf.numPages;

    // Sequential processing using a loop
    for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
      await this.renderPage(pdf, pageNum, this.pdfContainer.nativeElement);
    }
  }

  async renderPage(pdf: any, pageNum: number, pdfContainer: HTMLElement) {
    const page = await pdf.getPage(pageNum);
    const viewport = page.getViewport({ scale: 1.5 });
    const canvas = this.renderer.createElement('canvas');
    const ctx = canvas.getContext('2d');

    const viewport1 = page.getViewport({ scale: 1 });
    this.pdfPageheight = viewport1.height;

    canvas.height = viewport.height;
    canvas.width = viewport.width;

    const renderContext = {
      canvasContext: ctx,
      viewport: viewport,
    };

    await page.render(renderContext).promise;
    pdfContainer.appendChild(canvas);
  }

  clearPdfViewer() {
    this.pdfContainer.nativeElement.innerHTML = '';
  }

  clearPdfThumbnailViewer() {
    this.pdfThumbnailContainer.nativeElement.innerHTML = '';
  }

  // async renderPDFThumbnails(_arrayBuffer: any) {
  //   this.pdfarray = _arrayBuffer;
  //   const loadingTask = (window as any).pdfjsLib.getDocument({ data: this.pdfarray });
  //   const pdf = await loadingTask.promise;

  //   for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
  //     const page = await pdf.getPage(pageNum);
  //     const scale = 0.5; // Scale down for thumbnails
  //     const viewport = page.getViewport({ scale: scale });
  //     const canvas = this.renderer.createElement('canvas');
  //     const ctx = canvas.getContext('2d');

  //     canvas.height = viewport.height;
  //     canvas.width = viewport.width;

  //     const renderContext = {
  //       canvasContext: ctx,
  //       viewport: viewport
  //     };

  //     await page.render(renderContext).promise;

  //     // Create outer thumb container
  //   const thumbContainer = this.renderer.createElement('div');
  //   this.renderer.addClass(thumbContainer, 'thumb');

  //   // Create thumbnail container
  //   const thumbnailContainer = this.renderer.createElement('div');
  //   this.renderer.addClass(thumbnailContainer, 'thumbnail');

  //   // Convert canvas to image
  //   const img = this.renderer.createElement('img');
  //   img.src = canvas.toDataURL();

  //   // Create span for page number
  //   const pageNumberSpan = this.renderer.createElement('span');
  //   pageNumberSpan.textContent = `${pageNum}`;

  //   this.renderer.listen(img, 'click', () => this.onImageClick(pageNum));

  //   // Append image to the thumbnail container
  //   this.renderer.appendChild(thumbnailContainer, img);

  //   // Append thumbnail container and span to the outer thumb container
  //   this.renderer.appendChild(thumbContainer, thumbnailContainer);
  //   this.renderer.appendChild(thumbContainer, pageNumberSpan);

  //   // Append the outer thumb container to the PDF thumbnail container
  //   this.pdfThumbnailContainer.nativeElement.appendChild(thumbContainer);
  //   }
  // }

  async renderPDFThumbnails(_arrayBuffer: any) {
    //this.pdfarray = _arrayBuffer;
    this.clearPdfThumbnailViewer();
    const loadingTask = (window as any).pdfjsLib.getDocument({
      data: this.pdfarray,
    });
    const pdf = await loadingTask.promise;


    for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
      await this.renderThumbnail(
        pdf,
        pageNum,
        this.pdfThumbnailContainer.nativeElement
      );
    }


  }

  async renderThumbnail(
    pdf: any,
    pageNum: number,
    pdfThumbnailContainer: HTMLElement
  ) {
    const page = await pdf.getPage(pageNum);
    const scale = 0.5; // Scale down for thumbnails
    const viewport = page.getViewport({ scale: scale });
    const canvas = this.renderer.createElement('canvas');
    const ctx = canvas.getContext('2d');

    canvas.height = viewport.height;
    canvas.width = viewport.width;

    const renderContext = {
      canvasContext: ctx,
      viewport: viewport,
    };

    await page.render(renderContext).promise;

    // Create outer thumb container
    const thumbContainer = this.renderer.createElement('div');
    this.renderer.addClass(thumbContainer, 'thumb');

    // Create thumbnail container
    const thumbnailContainer = this.renderer.createElement('div');
    this.renderer.addClass(thumbnailContainer, 'thumbnail');

    // Convert canvas to image
    const img = this.renderer.createElement('img');
    img.src = canvas.toDataURL();

    // Create span for page number
    const pageNumberSpan = this.renderer.createElement('span');
    pageNumberSpan.textContent = `${pageNum}`;

    this.renderer.listen(img, 'click', () => this.onImageClick(pageNum));

    // Append image to the thumbnail container
    this.renderer.appendChild(thumbnailContainer, img);

    // Append thumbnail container and span to the outer thumb container
    this.renderer.appendChild(thumbContainer, thumbnailContainer);
    this.renderer.appendChild(thumbContainer, pageNumberSpan);

    // Append the outer thumb container to the PDF thumbnail container
    this.renderer.appendChild(pdfThumbnailContainer, thumbContainer);
  }

  // async renderPDFWithBoundingBox() {

  //   this.loaderService.hide();
  // // Use PDF.js to load the PDF document
  // const loadingTask = (window as any).pdfjsLib.getDocument({data: this.pdfarray});

  //   //const loadingTask = (window as any).pdfjsLib.getDocument(pdfURL);
  //   const pdf = await loadingTask.promise;
  //   this.clearPdfViewer();
  //   for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
  //     const page = await pdf.getPage(pageNum);
  //     const viewport = page.getViewport({ scale: 1.5 });
  //     const canvas = this.renderer.createElement('canvas');
  //     const ctx = canvas.getContext('2d');

  //     canvas.height = viewport.height;
  //     canvas.width = viewport.width;

  //     const renderContext = {
  //       canvasContext: ctx,
  //       viewport: viewport
  //     };

  //     await page.render(renderContext).promise;
  //     this.pdfContainer.nativeElement.appendChild(canvas);

  //     // Fetch and draw polygons
  //     let polygons:any;
  //     polygons=this.fetchJsonData(pageNum,viewport);
  //     polygons.forEach(pair => {
  //       const color = this.getRandomColor(); // Generate a unique color for each pair
  //       pair.forEach(polygon => this.drawBoundingBox(ctx, polygon.coords, color));
  //     });
  //   }
  // }

  async renderPDFWithBoundingBox() {
    // ⬇️ ADD THIS CHECK ⬇️
    if (!this.pdfarray) {
      console.error("Cannot render PDF because this.pdfarray is empty.");
      this.isRendering = false; // Reset rendering flag
      return; // Exit the function to prevent the error
    }

    this.isRendering = true; // 🔒 Disable the toggle

    // This code will now only run if this.pdfarray has data
    const loadingTask = (window as any).pdfjsLib.getDocument({
      data: this.pdfarray,
    });
    const pdf = await loadingTask.promise;
    this.clearPdfViewer();
    this.totalNumberPages = pdf.numPages;

    // Sequential processing using a loop
    for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
      await this.renderPageWithBoundingBox(pdf, pageNum);
    }

    this.isRendering = false; // ✅ Enable the toggle after rendering completes
  }

  async renderPageWithBoundingBox(pdf: any, pageNum: number) {

    const page = await pdf.getPage(pageNum);
    const viewport = page.getViewport({ scale: 1.5 });
    const canvas = this.renderer.createElement('canvas');
    const ctx = canvas.getContext('2d');

    canvas.height = viewport.height;
    canvas.width = viewport.width;

    const viewport1 = page.getViewport({ scale: 1 });
    this.pdfPageheight = viewport1.height;

    const renderContext = {
      canvasContext: ctx,
      viewport: viewport,
    };

    await page.render(renderContext).promise;
    this.pdfContainer.nativeElement.appendChild(canvas);

    if (this.showpdfbox == true) {
      // Fetch and draw polygons
      let polygons: any;
      polygons = await this.fetchJsonData(pageNum, viewport);
      polygons.forEach((pair: any) => {
        const color = this.getRandomColor(); // Generate a unique color for each pair
        pair.forEach((polygon: any) =>
          this.drawBoundingBox(ctx, polygon.coords, color)
        );
      });
    }

  }

  fetchJsonData(pageNumber: number, viewport: any) {
    // Fetch or define your JSON structure here
    // This is a placeholder; replace it with actual data fetching logic or static data
    const jsonData = {
      keyValuePairs: this.BoundingBoxKeyValueData,
    };
    // Filter key-value pairs by pageNumber, and check for undefined key and value
    return jsonData.keyValuePairs
      .filter(
        (pair: any) =>
          pair.Key &&
          pair.Value &&
          pair.Key.BoundingRegions.some(
            (region: any) => region.PageNumber === pageNumber
          ) &&
          pair.Value.BoundingRegions.some(
            (region: any) => region.PageNumber === pageNumber
          )
      )
      .map((pair: any) => [
        {
          coords: this.convertInchesToPixels(
            pair.Key.BoundingRegions[0].BoundingPolygon,
            viewport
          ),
        },
        {
          coords: this.convertInchesToPixels(
            pair.Value.BoundingRegions[0].BoundingPolygon,
            viewport
          ),
        },
      ]);
  }

  convertInchesToPixels(polygon: any, viewport: any) {
    const widthInPixels = 918; // Example width in pixels
    const heightInPixels = 1188; // Example height in pixels
    const widthInInches = 8.5; // Example width in inches
    const heightInInches = 11; // Example height in inches
    const xFactor = widthInPixels / widthInInches;
    const yFactor = heightInPixels / heightInInches;

    let flattenedArray = polygon.reduce((acc: any, point: any) => {
      if (!point.IsEmpty) {
        acc.push(point.X, point.Y);
      }
      return acc;
    }, []);

    return flattenedArray.map((value: any, index: any) =>
      index % 2 === 0 ? value * xFactor : value * yFactor
    );
  }

  getRandomColor() {
    // Generate each color component in the range of 0 to 192 rather than 0 to 255
    // This change restricts the maximum brightness of the colors
    let r = Math.floor(Math.random() * 193);
    let g = Math.floor(Math.random() * 193);
    let b = Math.floor(Math.random() * 193);

    // Ensure at least one of the color components is less than 128 to generally keep colors darker
    const lowestValue = Math.floor(Math.random() * 3);
    if (lowestValue === 0) {
      r = Math.floor(Math.random() * 129);
    } else if (lowestValue === 1) {
      g = Math.floor(Math.random() * 129);
    } else {
      b = Math.floor(Math.random() * 129);
    }

    return `rgb(${r},${g},${b})`; // Return RGB color string
  }

  drawBoundingBox(
    ctx: CanvasRenderingContext2D,
    coords: number[],
    color: string
  ) {
    ctx.beginPath();
    ctx.lineWidth = 2;
    ctx.strokeStyle = color; // Use the passed color
    ctx.moveTo(coords[0], coords[1]);
    for (let i = 2; i < coords.length; i += 2) {
      ctx.lineTo(coords[i], coords[i + 1]);
    }
    ctx.closePath();
    ctx.stroke();
  }

  async navigation(navigation: string): Promise<void> {
    if (navigation === NAVIGATION.AIData) {
      this.currentNavigation = NAVIGATION.AIData;
      this.searchKeyValueData = "";
      this.allKeyValueDataListFilterForFormFeild = this.allKeyValueDataListFilterForFormFeildFilter;
    }
    if (navigation === NAVIGATION.Qualifying) {
      this.currentNavigation = NAVIGATION.Qualifying;
      // this.currentNavigation = NAVIGATION.KeyValueData;
      //this.getQueryList(true);
      if (
        this.pdfTextFromOCR == '' ||
        this.pdfTextFromOCR == null ||
        this.pdfTextFromOCR == undefined
      ) {
        // await this.runAIQuestions();
      }
      if (this.VectorDocumentID === '') {
        // await this.processDocumentvectorDB();
        // await this.AddVectorFileID(this.VectorDocumentID);
      }
      this.searchKeyValueData = "";
      this.allKeyValueDataListFilterForFormFeild = this.allKeyValueDataListFilterForFormFeildFilter;
    }
    if (navigation === NAVIGATION.QUESTIONS) {
      this.currentNavigation = NAVIGATION.QUESTIONS;
      this.getSystemPromptTemplateList();
      await this.getQueryList(true);
      if (
        this.pdfTextFromOCR == '' ||
        this.pdfTextFromOCR == null ||
        this.pdfTextFromOCR == undefined
      ) {
        await this.runAIQuestions();
      }
    }
    if (navigation == NAVIGATION.AICHAT) {
      this.currentNavigation = NAVIGATION.AICHAT;
      this.getSavedChatHistory();
      if (this.VectorDocumentID === '') {
        this.isButtonEnabled = false;
        const maxAttempts = 2;
        for (let attempt = 1; attempt <= maxAttempts; attempt++) {
          try {
            await this.processDocumentvectorDB();
          } catch (e) {
            this.loaderService.hide();
          }
          if (this.VectorDocumentID) {
            break;
          }
          if (attempt === maxAttempts) {
            this.toastr.error('Unable to process the document for AI chat. Please close this window and try again.', '', { timeOut: 5000 });
          }
        }
        await this.AddVectorFileID(this.VectorDocumentID);
      }
      else {
        this.isButtonEnabled = true;
      }
    }
  }

  isButtonEnabled: any = false;
  async processDocumentvectorDB() {
    if (this.VectorDocumentID == '') {
      const userId = this.currentUser.UID;
      const officeId = this.myOfficeID;
      const organizationId = this.organizationId;
      this.loaderService.show();
      this.toastr.info('Please wait document is being processed.');
      try {
        const response = await this.formsService
          .processDocument(
            this.pdfURL,
            userId,
            officeId,
            organizationId,
            this.responseHolder.data.content
          )
          .toPromise();

        if (response.success) {
          this.isButtonEnabled = true;
          this.loaderService.hide();
          this.toastr.success('Document processed successfully');
          this.VectorDocumentID = response.message;
          return this.VectorDocumentID;
        }
        else
          this.loaderService.hide();
      } catch (error) {
        this.loaderService.hide();
        // handle error if necessary
      } finally {
        //this.loaderService.hide();
      }
    }
  }

  ChangeCore() {
    // this.transactionID = 0;
    this.toggleChange3c = true;
    this.show3cCancel = true;
    if (this.typeForAddCategory == 1) {
      this.ShowAttchedToCore = true;
    }
    if (this.typeForAddCategory == 2) {
      this.ShowAttchedToContact = true;
    }
    if (this.typeForAddCategory == 3) {
      this.ShowAttchedToCompany = true;
    }
  }

  showCoreDetail() {
    this.typeForAddCategory = 1;

    this.ShowAttchedToCore = true;
    this.ShowAttchedToContact = false;
    this.ShowAttchedToCompany = false;

    this.checkedAttachCore = true;
    this.checkedAttachContact = false;
    this.checkedAttachCompany = false;
    var SelectedCore = [];

    SelectedCore = this.menuModulesList.filter((x: any) => x.mainModuleName == 'Core');
    if (SelectedCore.length > 0) {
      this.folderID = SelectedCore[0].folderID;
    }

    // if(this.transactionID>0){
    //   var reqModels={
    //     databaseID : Number(this.databaseId),
    //     organizationID : Number(this.organizationId),
    //     coreID : Number(this.transactionID),
    //     folderId : Number(this.folderID),
    //     subFolderID : Number(this.typeIdCCC),
    //     userID: this.currentUser.UID,
    //     officeID:this.myOfficeID,
    //     officeIDList:this.OfficeIDList
    //   }
    //   this.coreService.getCoreUserDetails(reqModels).subscribe((response) => {
    //     if (response != undefined) {
    //       this.responseHolder = response;
    //       if (this.responseHolder.status == this.statusConst.statusSuccess) {

    //       } else {

    //       }
    //     }else{

    //     }
    //   });
    // }
  }

  showContactDetail() {
    this.typeForAddCategory = 2;
    this.ShowAttchedToCore = false;
    this.ShowAttchedToContact = true;
    this.ShowAttchedToCompany = false;

    this.checkedAttachCore = false;
    this.checkedAttachContact = true;
    this.checkedAttachCompany = false;

    var SelectedContact = [];

    SelectedContact = this.menuModulesList.filter(
      (x: any) => x.mainModuleName == 'Contact'
    );
    if (SelectedContact.length > 0) {
      this.folderID = SelectedContact[0].folderID;
    }
  }

  showCompanyDetail() {
    this.typeForAddCategory = 3;

    this.ShowAttchedToCore = false;
    this.ShowAttchedToContact = false;
    this.ShowAttchedToCompany = true;

    this.checkedAttachCore = false;
    this.checkedAttachContact = false;
    this.checkedAttachCompany = true;

    var SelectedCompany = [];

    SelectedCompany = this.menuModulesList.filter(
      (x: any) => x.mainModuleName == 'Company'
    );
    if (SelectedCompany.length > 0) {
      this.folderID = SelectedCompany[0].folderID;
    }
  }

  selectSysPrompt(event: any) {
    this.ddlsystemPromptID = Number(event.value);
    var check = this.sysPromptList.filter((x: any) => x.systemPromptID == Number(event.value));
    if (check.length > 0) {
      if (!this.formDialog.controls['title'].value || this.formDialog.controls['title'].value.trim() === '') {
        this.formDialog.controls['title'].setValue(check[0].systemPromptTitle);
      }
      // Clinical category is now derived from the selected model's type (super-admin managed).
      this.applyClinicalTypeFromModel(check[0].type);
    } else {
      this.applyClinicalTypeFromModel(0);
    }

    this.formDialog.markAsDirty();
  }

  // Predefined model type -> clinical flag mapping (PromptType enum on the API):
  // 1=Allergy, 2=Medication, 3=Condition/Diagnosis, 4=Immunization, 5=Observation, 6=NTA.
  // 0=Normal and 7=Nursing are free-text (no flag, editable question).
  clinicalModelLocked: boolean = false;

  // Returns the clinical-type label if a question of the same clinical type already
  // exists in the current list; otherwise ''. (One question per clinical type.)
  findDuplicateClinicalType(data: any, excludeBlock: any = null): string {
    const flags: { key: string; label: string }[] = [
      { key: 'isAllergy', label: 'Allergy' },
      { key: 'isMedication', label: 'Medication' },
      { key: 'isCondition', label: 'Diagnosis' },
      { key: 'isImmunization', label: 'Immunization' },
      { key: 'isObservation', label: 'Observation' },
      { key: 'isNta', label: 'NTA' },
    ];
    const selected = flags.find((f) => data[f.key] === true);
    if (!selected) {
      return '';
    }
    const exists = (this.queryBlocks || []).some(
      (b: any) => b && b !== excludeBlock && b[selected.key] === true
    );
    return exists ? selected.label : '';
  }

  // Friendly clinical-type label shown as a highlighted badge in the model dropdown.
  clinicalTypeLabel(type: any): string {
    const labelByType: { [key: number]: string } = {
      1: 'Allergy', 2: 'Medication', 3: 'Diagnosis',
      4: 'Immunization', 5: 'Observation', 6: 'NTA',
    };
    return labelByType[Number(type)] || '';
  }

  applyClinicalTypeFromModel(type: any) {
    const t = Number(type);
    const flagByType: { [key: number]: string } = {
      1: 'isAllergy',
      2: 'isMedication',
      3: 'isCondition',
      4: 'isImmunization',
      5: 'isObservation',
      6: 'isNta',
    };
    const allFlags = ['isNta', 'isMedication', 'isAllergy', 'isCondition', 'isImmunization', 'isObservation'];
    allFlags.forEach((f) => {
      if (this.formDialog.controls[f]) {
        this.formDialog.controls[f].setValue(false);
      }
    });

    const selectedFlag = flagByType[t];
    this.clinicalModelLocked = !!selectedFlag;
    if (selectedFlag && this.formDialog.controls[selectedFlag]) {
      this.formDialog.controls[selectedFlag].setValue(true);
      // Question comes from the predefined model — wipe any manually typed prompt.
      if (this.formDialog.controls['prompt']) {
        this.formDialog.controls['prompt'].setValue('');
      }
    }
  }

  selectCCC(event: any) {
    this.stateCtrl.reset();
    // this.transactionID = 0;

    if (event.target.value === '1') {
      this.typeForAddCategory = 1;

      this.ShowAttchedToCore = true;
      this.ShowAttchedToContact = false;
      this.ShowAttchedToCompany = false;

      this.checkedAttachCore = true;
      this.checkedAttachContact = false;
      this.checkedAttachCompany = false;
      var SelectedCore = [];

      SelectedCore = this.menuModulesList.filter(
        (x: any) => x.mainModuleName == 'Core'
      );
      if (SelectedCore.length > 0) {
        this.folderID = SelectedCore[0].folderID;
      }
    }
    if (event.target.value === '2') {
      this.typeForAddCategory = 2;
      this.ShowAttchedToCore = false;
      this.ShowAttchedToContact = true;
      this.ShowAttchedToCompany = false;

      this.checkedAttachCore = false;
      this.checkedAttachContact = true;
      this.checkedAttachCompany = false;

      var SelectedContact = [];

      SelectedContact = this.menuModulesList.filter(
        (x: any) => x.mainModuleName == 'Contact'
      );
      if (SelectedContact.length > 0) {
        this.folderID = SelectedContact[0].folderID;
      }
    }
    if (event.target.value === '3') {
      this.typeForAddCategory = 3;

      this.ShowAttchedToCore = false;
      this.ShowAttchedToContact = false;
      this.ShowAttchedToCompany = true;

      this.checkedAttachCore = false;
      this.checkedAttachContact = false;
      this.checkedAttachCompany = true;

      var SelectedCompany = [];

      SelectedCompany = this.menuModulesList.filter(
        (x: any) => x.mainModuleName == 'Company'
      );
      if (SelectedCompany.length > 0) {
        this.folderID = SelectedCompany[0].folderID;
      }
    }
    this.attachedToSelectedCore = [];
    this.attachedToSelectedContact = [];
    this.attachedToSelectedCompany = [];
  }

  //======Add New Record 3C===========//

  // [per-office 2026-10-04] Opened from Referral Management: the resident linked here is also recorded
  // as the resident of THIS office on the referral, so the referral and the AI tool never disagree.
  // The API ignores a document that is not a referral document.
  private recordResidentOnReferral(coreID: any) {
    if (this.froms !== 'ReferralManagement' || !(Number(coreID) > 0) || !(Number(this.documentId) > 0)) return;
    const req = {
      documentID: Number(this.documentId),
      coreID: Number(coreID),
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID
    };
    this.formsService.setReferralResidentFromAITool(req).subscribe({
      next: (response: any) => {
        if (response && response.status != this.statusConst.statusSuccess && response.message) {
          this.toastr.warning(response.message, '', { timeOut: 6000 });
        }
      },
      error: () => { }
    });
  }

  getselectedTransactionId(result: any) {
    if (result.FromModuleName == 'Core') {
      this.menuModulesList = JSON.parse(sessionStorage.getItem('menuModules') || '[]');
      var SelectedCore = [];
      SelectedCore = this.menuModulesList.filter(
        (x: any) => x.mainModuleName == 'Core'
      );
      if (SelectedCore.length > 0) {
        this.CoreShowName = SelectedCore[0].orgModuleName;
        this.folderID = SelectedCore[0].folderID;
      }

      this.transactionID = result.transactionId;
      this.imageUrl = result.imageUrl;
      this.status = result.status;
      this.typeId = result.typeID;
      this.childComponent.GetEmitTOSendMedication(this.transactionID);
      //this._dataSharingService.sendsaveMedicationToEntity(this.transactionID.toString());
      this.TypeIdDrp = result.typeID;

      this.name = result.name;
      this.email = result.email;

      this.selectedCoreId = this.transactionID;

      var shortName = '';
      shortName = result.name.match(/\b(\w)/g).join('');
      var ReqModel = {
        coreID: this.transactionID,
        email: result.email,
        name: result.name,
        transactionID: this.transactionID,
        img: result.imageUrl,
        shortName: shortName,
      };
      this.attachedToSelectedCore.unshift(ReqModel);
      if (this.attachedToSelectedCore.length > 0) {
        this.toggleChange3c = false;
        this.ShowAttchedToCore = false;
        this.attachedToSelectedCore = [];
        this.addMappedKeyValueDatas(event);
        this.pushMergedDocumentsTo3C();
        this.recordResidentOnReferral(this.transactionID);   // [per-office]
      } else {
      }
    }

    if (result.FromModuleName == 'Contact') {
      this.menuModulesList = JSON.parse(sessionStorage.getItem('menuModules') || '[]');
      var SelectedContact = [];
      SelectedContact = this.menuModulesList.filter(
        (x: any) => x.mainModuleName == 'Contact'
      );
      if (SelectedContact.length > 0) {
        this.ContactShowName = SelectedContact[0].orgModuleName;
        this.folderID = SelectedContact[0].folderID;
      }

      this.transactionID = result.transactionId;
      this.imageUrl = result.imageUrl;
      this.status = result.status;
      this.typeId = result.typeID;

      this.name = result.name;
      this.email = result.email;

      this.selectedContactId = this.transactionID;

      var shortName = '';
      shortName = result.name.match(/\b(\w)/g).join('');
      var ReqModelContact = {
        contactID: this.transactionID,
        email: result.email,
        name: result.name,
        transactionID: this.transactionID,
        img: result.imageUrl,
        shortName: shortName,
      };
      this.attachedToSelectedContact.unshift(ReqModelContact);
      if (this.attachedToSelectedContact.length > 0) {
        this.toggleChange3c = false;
        this.ShowAttchedToContact = false;
        this.attachedToSelectedContact = [];
        this.addMappedKeyValueDatas(event);
        this.pushMergedDocumentsTo3C();
      } else {
      }
    }

    if (result.FromModuleName == 'Company') {
      this.menuModulesList = JSON.parse(sessionStorage.getItem('menuModules') || '[]');
      var SelectedCompany = [];
      SelectedCompany = this.menuModulesList.filter(
        (x: any) => x.mainModuleName == 'Company'
      );
      if (SelectedCompany.length > 0) {
        this.CompanyShowName = SelectedCompany[0].orgModuleName;
        this.folderID = SelectedCompany[0].folderID;
      }

      this.transactionID = result.transactionId;
      this.imageUrl = result.imageUrl;
      this.status = result.status;
      this.typeId = result.typeID;

      this.name = result.name;
      this.email = result.email;

      this.selectedCompanyId = this.transactionID;

      var shortName = '';
      shortName = result.name.match(/\b(\w)/g).join('');
      var ReqModelCompany = {
        companyID: this.transactionID,
        email: result.email,
        name: result.name,
        transactionID: this.transactionID,
        img: result.imageUrl,
        shortName: shortName,
      };
      this.attachedToSelectedCompany.unshift(ReqModelCompany);
      if (this.attachedToSelectedCompany.length > 0) {
        this.toggleChange3c = false;
        this.ShowAttchedToCompany = false;
        this.attachedToSelectedCompany = [];
        this.addMappedKeyValueDatas(event);
        this.pushMergedDocumentsTo3C();
      } else {
      }
    }
  }

  addNew(module: any) {
    this.mainModuleName = module;
    var menuModulesList = JSON.parse(sessionStorage.getItem('menuModules') || '[]');
    var Module = menuModulesList.filter((x: any) => x.mainModuleName == module);
    var Modulename = Module[0].orgModuleName;
    this.Module = Modulename;
    this.showAddCore = !this.showAddCore;
  }

  getClose(message: any) {
    this.showAddCore = message;
  }

  //======================Core============================//

  searchCore(val: any) {
    if (val.length >= 2) {
      this.attachedToCoreList = [];
      if (val != '') {
        this.searchName = val;
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.getsearchCore(val);
        }, 500);
      } else {
        this.attachedToCoreList = [];
      }
    }
  }

  getsearchCore(searchValue: any) {
    var SelectedCCC = [];
    SelectedCCC = this.menuModulesList.filter(
      (x: any) => x.mainModuleName == 'Core'
    );
    if (SelectedCCC.length > 0) {
      this.CorefolderID = SelectedCCC[0].folderID;
    }
    this.roleIdList = [];
    let roles = sessionStorage.getItem('roleIDList').split(',');
    roles.forEach((e) => {
      this.roleIdList.push(Number(e));
    });

    var ReqModel = {
      roleIDList: this.roleIdList,
      searchKey: searchValue,
      userContactID: Number(sessionStorage.getItem('userContactID')),
      folderID: this.CorefolderID,
      databaseID: Number(this.databaseId),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList,
    };
    this.formsService.searchCore(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.attachedToCoreList = response.data;
          this.attachedToCoreList.push({
            coreID: 0,
            name: 'Create New',
            email: '',
            imageUrl: '',
            isShared: false,
            coreContactUserMapID: 0,
            trasactionalRoleIds: [],
            shortName: '',
          });
        } else {
          this.attachedToCoreList = [];
        }
      }
    });
  }

  attchedToCoreSelected(coreSelected: any) {
    this.mainModuleNameForDetails = "Core";
    this.associatedAPIs = JSON.parse(sessionStorage.getItem("associatedAPIs") || '[]');
    if (this.associatedAPIs.length > 0) {
      var checkPayCheck = [];
      var checkPCC = [];

      // checkPayCheck = this.associatedAPIs.filter((x:any) => x.apiName == 'Paychex' && x.isCoreMapped == true);
      // if (checkPayCheck.length > 0) {
      //   this.showPaycheck = true;
      // } else {
      //   this.showPaycheck = false;
      // }

      checkPCC = this.associatedAPIs.filter((x: any) => x.apiName == 'PointClickCare' && x.isCoreMapped == true);
      if (checkPCC.length > 0) {
        this.showPCC = true;
      } else {
        this.showPCC = false;
      }
    }

    if (coreSelected.coreID == 0) {
      this.searchName;
      this.systemFeildsList;
      if (this.systemFeildsList.length > 0) {
        var checkName = [];
        checkName = this.systemFeildsList.filter((x: any) => x.fieldName == "Name");
        if (checkName.length > 0) {
          var Names = checkName[0].value;
          if (Names != "") {
            this.searchName = Names;
          }
        }
      }
      this.stateCtrl.reset();
      this.dialog.closeAll();
      this.transactionID = 0;
      this.addNew('Core');
      return;
    }

    var checkCore = [];
    this.stateCtrl.setValue('');
    checkCore = this.attachedToSelectedCore;
    if (checkCore.length == 0) {
      this.mainModuleNameForDetails = "Core";
      this.transactionID = coreSelected.coreID;
      this.childComponent.GetEmitTOSendMedication(this.transactionID);
      //this._dataSharingService.sendsaveMedicationToEntity(this.transactionID.toString());
      this.imageUrl = coreSelected.imageUrl;
      this.status = coreSelected.status;
      this.typeId = coreSelected.typeID;

      this.TypeIdDrp = coreSelected.typeID;

      this.name = coreSelected.name;
      this.email = coreSelected.email;

      this.selectedCoreId = coreSelected.coreID;

      var shortName = '';
      shortName = coreSelected.name.match(/\b(\w)/g).join('');
      var ReqModel = {
        coreID: coreSelected.coreID,
        email: coreSelected.email,
        name: coreSelected.name,
        transactionID: coreSelected.transactionID,
        img: coreSelected.imageUrl,
        shortName: shortName,
        typeId: coreSelected.typeID
      };
      this.attachedToSelectedCore.unshift(ReqModel);
      this.stateCtrl.reset();
      if (this.attachedToSelectedCore.length > 0) {
        this.toggleChange3c = false;
        this.ShowAttchedToCore = false;
        this.attachedToSelectedCore = [];
        this.show3cCancel = false;
        this.addMappedKeyValueDatas(event);
        this.pushMergedDocumentsTo3C();
        this.recordResidentOnReferral(this.transactionID);   // [per-office]
      } else {
      }
    }
  }

  //======================Contact============================//

  searchContacts(val: any) {
    if (val.length >= 2) {
      this.attachedToContactList = [];
      if (val != '') {
        this.searchName = val;
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.getsearchContact(val);
        }, 500);
      } else {
        this.attachedToContactList = [];
      }
    }
  }

  getsearchContact(searchValue: any) {
    var SelectedCCC = [];
    SelectedCCC = this.menuModulesList.filter(
      (x: any) => x.mainModuleName == 'Contact'
    );
    if (SelectedCCC.length > 0) {
      this.ContactfolderID = SelectedCCC[0].folderID;
    }
    this.roleIdList = [];
    let roles = sessionStorage.getItem('roleIDList').split(',');
    roles.forEach((e: any) => {
      this.roleIdList.push(Number(e));
    });

    var ReqModel = {
      roleIDList: this.roleIdList,
      searchKey: searchValue,
      userContactID: Number(sessionStorage.getItem('userContactID')),
      folderID: this.ContactfolderID,
      databaseID: Number(this.databaseId),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList,
    };
    this.formsService.searchContact(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.attachedToContactList = response.data;
          this.attachedToContactList.push({
            contactID: 0,
            name: 'Create New',
            email: '',
            imageUrl: '',
            isShared: false,
            //"contactContactUserMapID":0,
            //"trasactionalRoleIds":[],
            //"contactContactRoleMappingModels":[],
            shortName: '',
          });
        } else {
          this.attachedToContactList = [];
        }
      }
    });
  }

  attchedToContactSelected(contactSelected: any) {
    this.mainModuleNameForDetails = "Contact";
    this.associatedAPIs = JSON.parse(sessionStorage.getItem("associatedAPIs") || '[]');
    if (this.associatedAPIs.length > 0) {
      var checkPayCheck = [];
      var checkPCC = [];

      // checkPayCheck = this.associatedAPIs.filter((x:any) => x.apiName == 'Paychex' && x.isContactMapped == true);
      // if (checkPayCheck.length > 0) {
      //   this.showPaycheck = true;
      // } else {
      //   this.showPaycheck = false;
      // }

      checkPCC = this.associatedAPIs.filter((x: any) => x.apiName == 'PointClickCare' && x.isContactMapped == true);
      if (checkPCC.length > 0) {
        this.showPCC = true;
      } else {
        this.showPCC = false;
      }
    }

    if (contactSelected.contactID == 0) {
      this.searchName;
      this.systemFeildsList;
      if (this.systemFeildsList.length > 0) {
        var checkName = [];
        checkName = this.systemFeildsList.filter((x: any) => x.fieldName == "Name");
        if (checkName.length > 0) {
          var Names = checkName[0].value;
          if (Names != "") {
            this.searchName = Names;
          }
        }
      }
      this.stateCtrl.reset();
      this.dialog.closeAll();
      this.transactionID = 0;
      this.addNew('Contact');
      return;
    }
    var checkContact = [];
    this.stateCtrl.setValue('');
    checkContact = this.attachedToSelectedContact;
    if (checkContact.length == 0) {

      this.mainModuleNameForDetails = "Contact";

      this.transactionID = contactSelected.contactID;
      this.imageUrl = contactSelected.imageUrl;
      this.status = contactSelected.status;
      this.typeId = contactSelected.typeID;

      this.TypeIdDrp = contactSelected.typeID;

      this.name = contactSelected.name;
      this.email = contactSelected.email;

      this.selectedContactId = contactSelected.contactID;
      var shortName = '';
      shortName = contactSelected.name.match(/\b(\w)/g).join('');
      var ReqModel = {
        contactID: contactSelected.contactID,
        email: contactSelected.email,
        name: contactSelected.name,
        transactionID: contactSelected.transactionID,
        img: contactSelected.imageUrl,
        shortName: shortName,
      };
      this.attachedToSelectedContact.unshift(ReqModel);
      this.stateCtrl.reset();
      if (this.attachedToSelectedContact.length > 0) {
        this.toggleChange3c = false;
        this.ShowAttchedToContact = false;
        this.attachedToSelectedContact = [];
        this.show3cCancel = false;
        this.addMappedKeyValueDatas(event);
        this.pushMergedDocumentsTo3C();
      } else {
      }
    }
  }

  //======================Company============================//

  searchCompany(val: any) {
    if (val.length >= 2) {
      this.attachedToCompanyList = [];
      if (val != '') {
        this.searchName = val;
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.getsearchCompany(val);
        }, 500);
      } else {
        this.attachedToCompanyList = [];
      }
    }
  }

  getsearchCompany(searchValue: any) {
    var SelectedCCC = [];
    SelectedCCC = this.menuModulesList.filter(
      (x: any) => x.mainModuleName == 'Company'
    );
    if (SelectedCCC.length > 0) {
      this.CompanyfolderID = SelectedCCC[0].folderID;
    }

    this.roleIdList = [];

    let roles = sessionStorage.getItem('roleIDList').split(',');
    roles.forEach((e) => {
      this.roleIdList.push(Number(e));
    });

    var ReqModel = {
      roleIDList: this.roleIdList,
      searchKey: searchValue,
      userContactID: Number(sessionStorage.getItem('userContactID')),
      folderID: this.CompanyfolderID,
      databaseID: Number(this.databaseId),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList,
    };
    this.formsService.searchCompany(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.attachedToCompanyList = response.data;
          this.attachedToCompanyList.push({
            companyID: 0,
            name: 'Create New',
            email: '',
            imageUrl: '',
            isShared: false,
            //"contactContactUserMapID":0,
            //"trasactionalRoleIds":[],
            //"contactContactRoleMappingModels":[],
            shortName: '',
          });
        } else {
          this.attachedToCompanyList = [];
        }
      }
    });
  }

  attchedToCompanySelected(companySelected: any) {
    this.mainModuleNameForDetails = "Company";
    this.associatedAPIs = JSON.parse(sessionStorage.getItem("associatedAPIs") || '[]');

    if (this.associatedAPIs.length > 0) {
      var checkPayCheck = [];
      var checkPCC = [];

      // checkPayCheck = this.associatedAPIs.filter((x:any) => x.apiName == 'Paychex' && x.isCompanyMapped == true);
      // if (checkPayCheck.length > 0) {
      //   this.showPaycheck = true;
      // } else {
      //   this.showPaycheck = false;
      // }

      checkPCC = this.associatedAPIs.filter((x: any) => x.apiName == 'PointClickCare' && x.isCompanyMapped == true);
      if (checkPCC.length > 0) {
        this.showPCC = true;
      } else {
        this.showPCC = false;
      }
    }

    if (companySelected.companyID == 0) {
      this.searchName;
      this.systemFeildsList;
      if (this.systemFeildsList.length > 0) {
        var checkName = [];
        checkName = this.systemFeildsList.filter((x: any) => x.fieldName == "Name");
        if (checkName.length > 0) {
          var Names = checkName[0].value;
          if (Names != "") {
            this.searchName = Names;
          }
        }
      }
      this.stateCtrl.reset();
      this.dialog.closeAll();
      this.transactionID = 0;
      this.addNew('Company');
      return;
    }
    var checkCompany = [];
    this.stateCtrl.setValue('');
    checkCompany = this.attachedToSelectedCompany;
    if (checkCompany.length == 0) {

      this.mainModuleNameForDetails = "Company";

      this.transactionID = companySelected.companyID;
      this.imageUrl = companySelected.imageUrl;
      this.status = companySelected.status;
      this.typeId = companySelected.typeID;

      this.TypeIdDrp = companySelected.typeID;

      this.name = companySelected.name;
      this.email = companySelected.email;

      this.selectedCompanyId = companySelected.companyID;
      var shortName = '';
      shortName = companySelected.name.match(/\b(\w)/g).join('');
      var ReqModel = {
        companyID: companySelected.companyID,
        email: companySelected.email,
        name: companySelected.name,
        transactionID: companySelected.transactionID,
        img: companySelected.imageUrl,
        shortName: shortName,
      };
      this.attachedToSelectedCompany.unshift(ReqModel);
      this.stateCtrl.reset();
      if (this.attachedToSelectedCompany.length > 0) {
        this.toggleChange3c = false;
        this.ShowAttchedToCompany = false;
        this.attachedToSelectedCompany = [];
        this.show3cCancel = false;
        this.addMappedKeyValueDatas(event);
        this.pushMergedDocumentsTo3C();
      } else {
      }
    }
  }

  //////////=== For System Fields ===========/////

  showSystemFieldMapping: boolean = false;

  openSystemFields() {
    //  const dialogRef = this.dialog.open(templateRef, {
    //   panelClass: 'synoniumModal'
    //  });

    this.fieldName = '';
    this.showAddField = false;
    this.ShowAddFieldButton = false;

    this.showSystemFieldMapping = true;
    this.ShowAddCustomFeildButton = false;
    this.systemFieldsAI = [];
    this.selectedSystemFeilds = [];
    this.checkedAll = false;
    this.getAllFieldsForAITool();
  }

  getAllFieldsForAITool() {
    var ReqModel = {
      //  searchKey: '',
      folderID: this.folderID,
      //  isSearch: false,
      //  isReturnSynonyms: false,
      userId: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      subFolderID: 0,
      fieldID: 0,
      requestFrom: 0, //
    };
    this.formsService.getAllFieldsForAITool(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.systemFieldsAI = this.responseHolder.data;
          this.systemFieldsAI = this.systemFieldsAI.filter(
            (x: any) => x.fieldName != 'Type'
          );
          this.systemFieldsAI.forEach((e: any) => {
            e.isDeleted = false;
          });

          if (this.systemFeildsList.length > 0) {
            this.systemFieldsAI.forEach((e: any) => {
              var data: any = ([] = []);
              data = this.systemFeildsList.filter(
                (itm: any) => itm.fieldID === e.fieldID
              );
              if (data.length > 0) {
                e.isDeleted = true;
              }
            });
          }
          this.systemFieldsAI = this.systemFieldsAI.filter(
            (x: any) => x.isDeleted == false
          );
          if (this.systemFieldsAI.length > 0) {
            this.systemFieldsAI.forEach((e: any) => {
              e.isChecked = false;
            });
          }
          this.systemFieldsAIForSearch = this.systemFieldsAI;
          if (this.systemFieldsAI == null) {
            this.systemFieldsAI = [];
          }
        } else {
          this.systemFieldsAI = [];
        }
      } else {
        this.systemFieldsAI = [];
      }
    });
  }

  closeAI() {
    this.showSystemFieldMapping = false;
    this.showAddField = false;
    this.systemFieldsAI = [];
    this.ShowAddCustomFeildButton = false;
    this.selectedSystemFeilds = [];
    this.dialog.closeAll();
  }

  //============ Create Field ===================//

  showAddField: boolean = false;
  fieldName: string = '';
  ShowAddFieldButton: boolean = false;

  openAddFields() {
    this.fieldName = '';
    this.showAddField = true;
    this.ShowAddFieldButton = false;

    this.CreateFeild = false;
    this.ImportFeild = false;
    this.FieldNameListFiltered = [];
    this.Feilds = [];
    //this.feildInput.nativeElement.value = '';
  }

  closeAddField() {
    this.fieldName = '';
    this.showAddField = false;
    this.ShowAddFieldButton = false;
  }

  AddFields() {
    var selectedFolder: any = ([] = []);
    this.ShowAddFieldButton = false;
    var obj = {
      folderID: this.folderID,
      position: 1,
      subFolderID: 0,
      viewOrder: 1,
    };
    selectedFolder.push(obj);
    var ReqModel = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId),
      fieldName: this.fieldName,
      fieldTypeID: 1, // For Textbox
      defaultValue: '',
      fieldCategotyTypeID: Number(2), // 2-Global, 3-Custom
      availableOn: Number(1), //1-Selected Tabs Only
      selectedFolders: selectedFolder,
      placeholder: '',
      permission: 0,
      position: 1,
      rolePermissions: [],
    };
    this.formsService.addField(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (
          this.responseHolder.status == this.statusConst.statusSuccess &&
          this.responseHolder.data != null
        ) {
          this.closeAddField();
          this.getAllFieldsForAITool();
        } else {
          this.toastr.error('This field is already exist.', '', {
            timeOut: 4000,
          });
        }
      } else {
      }
    });
  }

  ImportFields() {
    var selectedFolder: any = ([] = []);
    this.ShowAddFieldButton = false;
    var rolePermissions: any = ([] = []);
    var obj = {
      folderID: this.folderID,
      position: 1,
      subFolderID: 0,
      viewOrder: 1,
    };
    selectedFolder.push(obj);
    this.selectedRoleList.forEach((e: any) => {
      rolePermissions.push({
        roleID: e.roleID,
        permission: e.permission,
      });
    });
    var ReqModel = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      //databaseID: Number(this.databaseId),
      fieldID: this.fieldData.fieldID,
      //fieldName: this.fieldName,
      //fieldTypeID: this.fieldTypeID, // For Textbox
      //defaultValue:"",
      fieldCategotyTypeID: this.fieldCategotyTypeID, // 2-Global, 3-Custom
      // availableOn: Number(1),  //1-Selected Tabs Only
      selectedFolders: selectedFolder,
      // placeholder:"",
      // permission:0,
      //position:1,
      rolePermissions: rolePermissions,
    };
    this.loaderService.show();
    this.formsService.AddFieldFolderMappingForExistingField(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.toastr.success('Field imported successfully.', '', {
            timeOut: 3000,
          });
          this.closeAddField();
          this.getAllFieldsForAITool();
        } else {
          this.loaderService.hide();
          this.toastr.error('This field is already exist.', '', {
            timeOut: 4000,
          });
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  onFieldNameChange(searchValue: string): void {
    if (searchValue != '') {
      this.fieldName = searchValue;
      this.ShowAddFieldButton = true;
    } else {
      this.ShowAddFieldButton = false;
    }
  }

  ShowAddCustomFeildButton: boolean = false;
  selectedSystemFeilds: any = ([] = []);
  systemFeildsList: any = ([] = []);
  checkedAll: boolean = false;

  //Checkbox Change detecting function
  getCheckboxValues(event: any, item: any) {
    this.ShowAddCustomFeildButton = true;
    this.showSystemFieldMapping = true;
    if (event.checked) {
      this.systemFieldsAI.forEach((e: any) => {
        if (e.fieldID == item.fieldID) {
          e.isChecked = true;
        }
      });
      this.selectedSystemFeilds.push(item);
    } else {
      let removeIndex = this.selectedSystemFeilds.findIndex(
        (itm: any) => itm.fieldID === item.fieldID
      );
      if (removeIndex !== -1) this.selectedSystemFeilds.splice(removeIndex, 1);
      this.systemFieldsAI.forEach((e: any) => {
        if (e.fieldID == item.fieldID) {
          e.isChecked = false;
        }
      });
    }
    var CheckIsImport = [];
    CheckIsImport = this.systemFieldsAI.filter((x: any) => x.isChecked == false);
    if (CheckIsImport.length > 0) {
      this.checkedAll = false;
    } else {
      this.checkedAll = true;
    }
    if (this.selectedSystemFeilds.length == 0) {
      this.ShowAddCustomFeildButton = false;
    }
  }

  getAllCheckboxValues(event: any) {
    this.ShowAddCustomFeildButton = true;
    this.showSystemFieldMapping = true;
    if (event.checked) {
      this.selectedSystemFeilds = [];
      if (this.systemFieldsAI.length > 0) {
        this.checkedAll = true;
        this.systemFieldsAI.forEach((e: any) => {
          e.isChecked = true;
          var obj = {
            id: this.randomId(),
            fieldID: e.fieldID,
            fieldName: e.fieldName,
            formFieldName: '',
            value: '',
            colorCode: '',
          };
          this.selectedSystemFeilds.push(obj);
        });
      }
      //this.selectedSystemFeilds.push(item);
    } else {
      if (this.systemFieldsAI.length > 0) {
        this.checkedAll = false;
        this.systemFieldsAI.forEach((e: any) => {
          e.isChecked = false;
        });
        this.selectedSystemFeilds = [];
      }
      //let removeIndex = this.selectedSystemFeilds.findIndex((itm) => itm.fieldID === item.fieldID);
      //if (removeIndex !== -1) this.selectedSystemFeilds.splice(removeIndex, 1);
    }
    if (this.selectedSystemFeilds.length == 0) {
      this.ShowAddCustomFeildButton = false;
    }
  }

  searchSystemFields(val: any) {
    if (val.length >= 2) {
      if (val != '') {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.systemFieldsAI = this.systemFieldsAIForSearch.filter(
            (i: any) =>
              i.fieldName.toLowerCase().indexOf(val.toLocaleLowerCase()) !== -1
          );
        }, 500);
      } else {
      }
    } else {
      this.systemFieldsAI = this.systemFieldsAIForSearch;
    }
  }

  AddSystemFields() {
    if (this.selectedSystemFeilds.length > 0) {
      this.selectedSystemFeilds.forEach((e: any) => {
        var obj = {
          id: this.randomId(),
          fieldID: e.fieldID,
          fieldName: e.fieldName,
          formFieldName: '',
          value: '',
          colorCode: '',
        };
        this.systemFeildsList.push(obj);
      });
      this.markSystemFieldsDirty();
    }
    this.showSystemFieldMapping = false;
    this.dialog.closeAll();
  }

  removesystemField(item: any) {
    let removeIndex = this.systemFeildsList.findIndex(
      (itm: any) => itm.fieldID === item.fieldID
    );
    if (removeIndex !== -1) {
      this.systemFeildsList.splice(removeIndex, 1);
      this.markSystemFieldsDirty();
    }
  }

  //========= AI Data fields grid (system fields) =========//
  systemFieldsDirty: Boolean = false;
  systemFieldsSnapshot: any = ([] = []);

  // Keeps a copy of the saved state so Cancel can roll edits back.
  captureSystemFieldsSnapshot() {
    this.systemFieldsSnapshot = JSON.parse(
      JSON.stringify(this.systemFeildsList || [])
    );
    this.systemFieldsDirty = false;
  }

  markSystemFieldsDirty() {
    this.systemFieldsDirty = true;
  }

  // Orange colour code marks a mapping the user typed but never confirmed.
  isNeedsReview(item: any) {
    return item.needsReview === true || item.colorCode == '#cc570e';
  }

  needsReviewCount() {
    if (!this.systemFeildsList || this.systemFeildsList.length == 0) return 0;
    return this.systemFeildsList.filter((item: any) => this.isNeedsReview(item))
      .length;
  }

  cancelSystemFieldChanges() {
    this.systemFeildsList = JSON.parse(
      JSON.stringify(this.systemFieldsSnapshot || [])
    );
    this.systemFieldsDirty = false;
  }

  //==============For Add Template =============//
  addTemplateForm: FormGroup;
  filteredTaskCategoryList: any = ([] = []);
  ShowNoRecordFoundTaskTemplates: Boolean = false;
  TaskTemplatesList: any = ([] = []);
  spinner: Boolean = false;
  taslTemplateID: number = 0;
  tempCategoryList: any = ([] = []);
  showSaveTemplate: Boolean = false;
  QuestionTemplateID: number = 0;

  SaveAsTemplate(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef, {
      panelClass: 'saveTemplatePopup',
    });
    let group = {};
    this.categoryType = 0;
    this.addTemplateForm = new FormGroup(group);
    this.createSaveAsTaskTemplate();
    this.getActiveTemplateCategoriesAfterAdd();
    this.showSaveTemplate = true;
    this.showNewSaveFieldTemplate = true;
    this.updateSelectedField = false;
    this.ShowExistingSaveFieldTemplate = false;
  }

  createSaveAsTaskTemplate(): void {
    this.addTemplateForm = this.formBuilder.group({
      taskTemplateName: ['', [Validators.required]],
      folderID: ['', [Validators.required]],
    });
  }

  closeSaveAsTemplate() {
    this.showSaveTemplate = false;
    this.addTemplateForm.reset();
    this.dialog.closeAll();
  }

  openDialogAddWithRef() {
    const dialogRef = this.dialog.open(AddAITempCategoryComponent, {
      data: {
        categoryType: this.categoryType //Number(OCRType.MyTemplate),
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result != null && result != undefined) {
        this.getActiveTemplateCategoriesAfterAdd();
      }
    });
  }

  getActiveTemplateCategoriesAfterAdd() {
    var ReqModel = {
      type: this.categoryType,//Number(OCRType.MyTemplate),
      isCategoriesOnly: true,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId),
    };
    this.formsService.getOCRTemplateCategories(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.filteredTempCategoryList = response.data;
        } else {
          this.filteredTempCategoryList = [];
        }
      } else {
        this.filteredTempCategoryList = [];
      }
    });
  }

  AddTemplate(data: any) {
    if (this.systemFeildsList.length == 0) {
      this.toastr.warning('Please add system fields.', '', {
        timeOut: 3000,
      });
      return;
    }
    var systemFeilds = [];
    if (this.systemFeildsList.length > 0) {
      for (let i = 0; i < this.systemFeildsList.length; i++) {
        var obj = {
          position: i + 1,
          // fieldName: this.systemFeildsList[i].fieldName,
          fieldID: this.systemFeildsList[i].fieldID,
        };
        systemFeilds.push(obj);
      }
    }
    this.loaderService.show();
    var ReqModel = {
      templateID: 0,
      templateName: data.taskTemplateName,
      templateType: this.categoryType, // For My Template
      cType: this.typeForAddCategory,
      categoryID: data.folderID,
      templateFields: systemFeilds,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
    };
    this.spinner = true;
    this.addTemplateForm.markAsPristine();
    this.formsService.addOcrTemplates(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.spinner = false;
          this.loaderService.hide();
          this.toastr.success('Template added successfully.', '', {
            timeOut: 3000,
          });
          this.closeSaveAsTemplate();
        } else {
          this.toastr.error('Template add failed.', '', {
            timeOut: 3000,
          });
          this.spinner = false;
          this.loaderService.hide();
        }
      } else {
        this.toastr.error('Template add failed.', '', {
          timeOut: 3000,
        });
        this.spinner = false;
        this.loaderService.hide();
      }
    });
  }

  //================ Import Templates ===========================//

  currentIndex: number = 0;
  selectedTemplate: any = ([] = []);
  filteredTempCategoryList: any = ([] = []);
  searchTemplateName: string = '';
  ShowNoRecordFoundTemplates: boolean = false;
  ImportTemplatesList: any = ([] = []);
  TemplateIDImportTask: number = 0;
  selectedcategoryIDForImportTemp: number = 0;
  showImportTemplate: boolean = false;

  OpenImportTemplate(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef, {
      panelClass: 'saveTemplatePopup',
    });
    this.categoryType = 0;
    this.getActiveTemplateCategoriesAfterAdd();
    this.selectedcategoryIDForImportTemp = 0;
    this.TemplateIDImportTask = 0;
    this.currentIndex = 0;
    this.getOCRTemplate();
    this.showImportTemplate = true;
  }

  getTaskListThroughCategoryForImport(e: any, i: any) {
    this.updateSelectedField = false;
    this.TemplateIDImportTask = 0;
    this.selectedTemplate = [];
    this.currentIndex = i;
    this.selectedcategoryIDForImportTemp = e;
    this.getOCRTemplate();
  }

  searchTemplateForSingleTask(val: any) {
    if (val.length >= 2) {
      if (val != '') {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.selectedTemplate = [];
          this.filteredTempCategoryList = this.filteredTempCategoryList.filter(
            (i: any) =>
              i.ocrTemplateCategoryName
                .toLowerCase()
                .indexOf(val.toLocaleLowerCase()) !== -1
          );
        }, 500);
      } else {
      }
    } else {
      this.selectedTemplate = [];
      this.searchTemplateName = '';
    }
  }

  officeIdForImportFieldTemp: number = 0;
  organizationIdForImportFieldTemp: number = 0;

  SelectTemplate(data: any) {
    this.officeIdForImportFieldTemp = data.officeID;
    this.organizationIdForImportFieldTemp = data.organizationID;
    this.TemplateIDImportTask = data.templateID;
  }

  getOCRTemplate() {
    var ReqModel = {
      cType: this.typeForAddCategory,
      templateType: this.categoryType,
      categoryID: this.selectedcategoryIDForImportTemp,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId),
    };
    this.formsService.getOCRTemplates(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (
          this.responseHolder.status == this.statusConst.statusSuccess &&
          this.responseHolder.data != null
        ) {
          this.ImportTemplatesList = response.data;
          if (this.ImportTemplatesList.length > 0) {
            this.ShowNoRecordFoundTemplates = false;
          } else {
            this.ShowNoRecordFoundTemplates = true;
          }
        } else {
          this.ImportTemplatesList = [];
          this.ShowNoRecordFoundTemplates = true;
        }
      } else {
        this.ImportTemplatesList = [];
        this.ShowNoRecordFoundTemplates = true;
      }
    });
  }

  importTemplates() {
    var ReqModel = {
      ocrTemplateID: this.TemplateIDImportTask,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationIdForImportFieldTemp),
      // organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.officeIdForImportFieldTemp,
      // officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
    };
    this.loaderService.show();
    this.formsService.getOCRTemplateFields(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.loaderService.hide();
          if (this.responseHolder.data.length > 0) {
            this.responseHolder.data.forEach((e: any) => {
              var obj = {
                id: this.randomId(),
                fieldID: e.fieldID,
                fieldName: e.fieldName,
                formFieldName: '',
                value: '',
                colorCode: '',
              };
              this.systemFeildsList.push(obj);
            });
            this.markSystemFieldsDirty();
          }
          this.toastr.success('Template Import successfully.', '', {
            timeOut: 3000,
          });
          this.closeImportTaskTemplate();
        } else {
          this.toastr.error('Template Import failed.', '', {
            timeOut: 3000,
          });
          this.loaderService.hide();
        }
      } else {
        this.toastr.error('Template Import failed.', '', {
          timeOut: 3000,
        });
        this.loaderService.hide();
      }
    });
  }

  closeImportTaskTemplate() {
    this.showImportTemplate = false;
    this.dialog.closeAll();
  }

  closeDetail(closeDetail: boolean) {
    this.closeAIToolEmit.emit(closeDetail);
  }

  //==============Model Access Type =============//
  modelAccessTypeList: any = ([] = []);
  modelId: string = 'prebuilt-document';
  isOCR: boolean = false;

  getmodelAccessType() {
    var ReqModel = {
      modelAccessType: 2,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId),
    };
    this.formsService.getOCRModels(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (
          this.responseHolder.status == this.statusConst.statusSuccess &&
          this.responseHolder.data != null
        ) {
          this.modelAccessTypeList = response.data;
          if (this.modelAccessTypeList.length > 0) {
            this.modelAccessTypeList.forEach((e: any) => {
              e.modelType = e.name;
            });
          }
        } else {
          this.modelAccessTypeList = [];
        }
      } else {
        this.modelAccessTypeList = [];
      }
    });
  }

  selectModelAccess(event: any) {
    this.modelId = event.target.value; //event.value;
    if (this.modelId == 'prebuilt-document') {
      this.typeForRun = 0;
    }
    if (this.modelId == 'custom-care-model') {
      this.typeForRun = 2;
    }
  }

  //================ Run AI ================//

  allKeyValueDataListFilterForFormFeild: any = ([] = []);

  allKeyValueDataListFilterForFormFeildFilter: any = ([] = []);

  allKeyValueDataListFormFeild: any = ([] = []);

  randomId() {
    return Math.random();
  }


  runAI() {
    this.runAIOCR();
  }

  runAIOCR() {
    if (this.isOCR == false) {
      var systemFeilds = [];
      if (this.systemFeildsList.length > 0) {
        for (let i = 0; i < this.systemFeildsList.length; i++) {
          var obj = {
            fieldName: this.systemFeildsList[i].fieldName,
            fieldID: this.systemFeildsList[i].fieldID,
          };
          systemFeilds.push(obj);
        }
      }
    }

    if (this.isOCR == true) {
      var systemFeilds = [];
      if (this.systemFeildsList.length > 0) {
        for (let i = 0; i < this.systemFeildsList.length; i++) {
          if (this.systemFeildsList[i].value == '') {
            var obj = {
              fieldName: this.systemFeildsList[i].fieldName,
              fieldID: this.systemFeildsList[i].fieldID,
            };
            systemFeilds.push(obj);
          }
        }
      }
    }
    let isNLPProcessed = false;
    if (this.ocrTextFileUrl == "" && this.VectorDocumentID) {
      isNLPProcessed = true;
      this.query_vector_dbFields();
    } else if (this.ocrTextFileUrl != "") {
      isNLPProcessed = true;
      if (!this.systemFeildsList || this.systemFeildsList.length === 0) {
        this.toastr.warning('Please add system fields to to map fields via NLP.');
      }
      else
        this.getFieldsValuesforNLP();
    }
    var ReqModel = {
      type: Number(this.typeForRun),
      cType: this.typeForAddCategory,
      cid: this.transactionID,
      docFrom: this.docFrom,
      isOCRExist: this.isOCR,
      documentID: this.documentId,
      modelId: this.modelId,
      url: this.pdfURL, //"https://ecmstorageaccount.blob.core.windows.net/ecmfilemanager/Care_Plan_Example.pdf",
      fields: systemFeilds,
      useSynonymous: true,
      cFolderID: this.folderID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId),
    };
    this.loaderService.show();
    this.formsService.extractDataWithFields(ReqModel).subscribe(async (response) => {
      if (response != undefined) {
        this.responseHolder = response;
        //this.loaderService.hide();
        if (
          this.responseHolder.status == this.statusConst.statusSuccess &&
          this.responseHolder.data != null
        ) {
          if (this.systemFeildsList.length > 0) {
            if (this.responseHolder.data.specificFieldKeyValue.length > 0) {
              this.systemFeildsList.forEach((e: any) => {
                if (e.formFieldName == '' || e.value == '') {
                  var data = [];
                  data =
                    this.responseHolder.data.specificFieldKeyValue.filter(
                      (x: any) => x.fieldID == e.fieldID
                    );
                  if (data.length > 0) {
                    e.value = data[0].value;
                    e.formFieldName = data[0].key;
                    e.colorCode = '#47e309';
                  } else {
                    e.value = '';
                    e.formFieldName = '';
                    e.colorCode = '';
                  }
                }
              });
            }
          }

          this.isOCR = true;
          this.pdfTextFromOCR = this.responseHolder.data.content;

          if (this.VectorDocumentID === '') {
            await this.processDocumentvectorDB();
            await this.AddVectorFileID(this.VectorDocumentID);
          }

          if (response.data.jsonData) {
            this.ocrData = this.responseHolder.data.jsonData;
            this.BoundingBoxKeyValueData = JSON.parse(
              response.data.jsonData
            );
            await this.renderPDFWithBoundingBox();
            await this.renderPDFThumbnails(this.pdfarray);
          } else {
            await this.renderPDFByURL(this.pdfarray);
            await this.renderPDFThumbnails(this.pdfarray);
          }
          this.allKeyValueDataListFormFeild = this.responseHolder.data.allKeyValueData;
          this.allKeyValueDataListFilterForFormFeild = this.responseHolder.data.allKeyValueData;
          this.allKeyValueDataListFilterForFormFeildFilter = this.responseHolder.data.allKeyValueData;
          // Run NLP
          if (this.ocrTextFileUrl == "" && isNLPProcessed == false) {
            this.query_vector_dbFields();
          } else if (this.ocrTextFileUrl != "" && isNLPProcessed == false) {
            this.getFieldsValuesforNLP();
          }
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }


  // runAI() {
  //   if (this.currentNavigation == NAVIGATION.OCR) {
  //     if (this.isOCR == false) {
  //       var systemFeilds = [];
  //       if (this.systemFeildsList.length > 0) {
  //         for (let i = 0; i < this.systemFeildsList.length; i++) {
  //           var obj = {
  //             fieldName: this.systemFeildsList[i].fieldName,
  //             fieldID: this.systemFeildsList[i].fieldID,
  //           };
  //           systemFeilds.push(obj);
  //         }
  //       }
  //     }

  //     if (this.isOCR == true) {
  //       var systemFeilds = [];
  //       if (this.systemFeildsList.length > 0) {
  //         for (let i = 0; i < this.systemFeildsList.length; i++) {
  //           if (this.systemFeildsList[i].value == '') {
  //             var obj = {
  //               fieldName: this.systemFeildsList[i].fieldName,
  //               fieldID: this.systemFeildsList[i].fieldID,
  //             };
  //             systemFeilds.push(obj);
  //           }
  //         }
  //       }
  //     }

  //     var ReqModel = {
  //       type: Number(this.typeForRun),
  //       cType: this.typeForAddCategory,
  //       cid: this.transactionID,
  //       docFrom: this.docFrom, 
  //       isOCRExist: this.isOCR,
  //       documentID: this.documentId,
  //       modelId: this.modelId,
  //       url: this.pdfURL, //"https://ecmstorageaccount.blob.core.windows.net/ecmfilemanager/Care_Plan_Example.pdf",
  //       fields: systemFeilds,
  //       useSynonymous: true,
  //       cFolderID: this.folderID,
  //       userID: this.currentUser.UID,
  //       organizationID: Number(this.organizationId),
  //       officeID: this.myOfficeID,
  //       officeIDList: this.OfficeIDList,
  //       databaseID: Number(this.databaseId),
  //     };
  //     this.loaderService.show();
  //     this.formsService
  //       .extractDataWithFields(ReqModel)
  //       .subscribe(async (response) => {
  //         if (response != undefined) {
  //           this.responseHolder = response;
  //           this.loaderService.hide();
  //           if (
  //             this.responseHolder.status == this.statusConst.statusSuccess &&
  //             this.responseHolder.data != null
  //           ) {
  //             if (this.systemFeildsList.length > 0) {
  //               if (this.responseHolder.data.specificFieldKeyValue.length > 0) {
  //                 this.systemFeildsList.forEach((e) => {
  //                   if (e.formFieldName == '' || e.value == '') {
  //                     var data = [];
  //                     data =
  //                       this.responseHolder.data.specificFieldKeyValue.filter(
  //                         (x) => x.fieldID == e.fieldID
  //                       );
  //                     if (data.length > 0) {
  //                       e.value = data[0].value;
  //                       e.formFieldName = data[0].key;
  //                       e.colorCode = '#47e309';
  //                     } else {
  //                       e.value = '';
  //                       e.formFieldName = '';
  //                       e.colorCode = '';
  //                     }
  //                   }
  //                 });
  //               }
  //             }

  //             this.isOCR = true;
  //             this.pdfTextFromOCR = this.responseHolder.data.content;

  //             if (this.VectorDocumentID === '') {
  //               await this.processDocumentvectorDB();
  //               await this.AddVectorFileID(this.VectorDocumentID);
  //             }

  //             if (response.data.jsonData) {
  //               this.ocrData = this.responseHolder.data.jsonData;
  //               this.BoundingBoxKeyValueData = JSON.parse(
  //                 response.data.jsonData
  //               );
  //               await this.renderPDFWithBoundingBox();
  //               await this.renderPDFThumbnails(this.pdfarray);
  //             } else {
  //               await this.renderPDFByURL(this.pdfarray);
  //               await this.renderPDFThumbnails(this.pdfarray);
  //             }
  //             this.allKeyValueDataListFormFeild = this.responseHolder.data.allKeyValueData;
  //             this.allKeyValueDataListFilterForFormFeild =this.responseHolder.data.allKeyValueData;              
  //           } else {
  //             this.loaderService.hide();
  //           }
  //         } else {
  //           this.loaderService.hide();
  //         }
  //       });
  //   } else if (this.currentNavigation == NAVIGATION.NLP) {
  //     if (this.ocrTextFileUrl == "") {
  //       this.query_vector_dbFields();
  //     } else {
  //       this.getFieldsValuesforNLP();
  //     }

  //   }
  // }

  runAIQuestions1() {
    if (this.currentNavigation == NAVIGATION.QUESTIONS) {
      if (this.isOCR == false) {
        var systemFeilds = [];
        if (this.systemFeildsList.length > 0) {
          for (let i = 0; i < this.systemFeildsList.length; i++) {
            var obj = {
              fieldName: this.systemFeildsList[i].fieldName,
              fieldID: this.systemFeildsList[i].fieldID,
            };
            systemFeilds.push(obj);
          }
        }
      }

      if (this.isOCR == true) {
        var systemFeilds = [];
        if (this.systemFeildsList.length > 0) {
          for (let i = 0; i < this.systemFeildsList.length; i++) {
            if (this.systemFeildsList[i].value == '') {
              var obj = {
                fieldName: this.systemFeildsList[i].fieldName,
                fieldID: this.systemFeildsList[i].fieldID,
              };
              systemFeilds.push(obj);
            }
          }
        }
      }

      var ReqModel = {
        type: Number(this.typeForRun),
        cType: this.typeForAddCategory,
        cid: this.transactionID,
        docFrom: this.docFrom,
        isOCRExist: this.isOCR,
        documentID: this.documentId,
        modelId: this.modelId,
        url: this.pdfURL, //"https://ecmstorageaccount.blob.core.windows.net/ecmfilemanager/Care_Plan_Example.pdf",
        fields: systemFeilds,
        useSynonymous: true,
        cFolderID: this.folderID,
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        officeID: this.myOfficeID,
        officeIDList: this.OfficeIDList,
        databaseID: Number(this.databaseId),
      };
      this.loaderService.show();
      this.formsService
        .extractDataWithFields(ReqModel)
        .subscribe(async (response) => {
          if (response != undefined) {
            this.responseHolder = response;
            this.loaderService.hide();
            if (
              this.responseHolder.status == this.statusConst.statusSuccess &&
              this.responseHolder.data != null
            ) {
              this.pdfTextFromOCR = this.responseHolder.data.content;
              // //
              // if(this.VectorDocumentID=="")
              //   {
              //   const userId = this.currentUser.UID;
              //   const officeId = this.myOfficeID;
              //   const organizationId = this.organizationId;
              //   this.loaderService.show();
              //   this.formsService.processDocument(this.pdfURL, userId, officeId, organizationId,this.responseHolder.data.content)
              //   .subscribe(
              //     response => {
              //       if (response.success) {
              //         this.toastr.success('Document processed successfully')
              //         this.VectorDocumentID=response.message;
              //         this.AddVectorFileID(response.message);
              //         this.loaderService.hide();
              //       } else {
              //         this.loaderService.hide();
              //       }
              //     },
              //     error => {
              //       this.loaderService.hide();
              //     }
              //   );
              //  }
              //  //
            } else {
              this.loaderService.hide();
            }
          } else {
            this.loaderService.hide();
          }
        });
    }
  }

  async runAIQuestions() {
    const ReqModel = {
      type: Number(this.typeForRun),
      cType: this.typeForAddCategory,
      cid: this.transactionID,
      docFrom: this.docFrom,
      isOCRExist: this.isOCR,
      documentID: this.documentId,
      modelId: this.modelId,
      url: this.pdfURL,
      fields: [],
      useSynonymous: true,
      cFolderID: this.folderID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId),
    };

    this.loaderService.show();

    try {
      const response = await this.formsService
        .extractDataWithFields(ReqModel)
        .toPromise();
      if (response) {
        this.responseHolder = response;
        this.loaderService.hide();

        if (
          this.responseHolder.status === this.statusConst.statusSuccess &&
          this.responseHolder.data != null
        ) {
          this.pdfTextFromOCR = this.responseHolder.data.content;
          this.isOCR = true;
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    } catch (error) {
      console.error('Error in runAIQuestions:', error);
      this.loaderService.hide();
    }
  }

  formfieldValueSelectedAI(value: any, items: any) {
    this.systemFeildsList.find((item: any) => item.id == items.id).formFieldName =
      value.key;
    this.systemFeildsList.find((item: any) => item.id == items.id).value =
      value.value;
    this.systemFeildsList.find((item: any) => item.id == items.id).colorCode =
      '#47e309';

    this.allKeyValueDataListFormFeild = this.allKeyValueDataListFilterForFormFeild;
  }

  // The options list is shared by every row; restore the full list when a
  // row's map input gains focus so a stale filter can't leave the panel empty.
  resetFormFieldOptions() {
    this.allKeyValueDataListFormFeild = this.allKeyValueDataListFilterForFormFeild;
  }

  searchAllKeyValueFormFields(val: any, items: any) {
    if (val !== undefined && val !== '') {
      this.allKeyValueDataListFormFeild =
        this.allKeyValueDataListFilterForFormFeild.filter((m: any) =>
          m.key.toLowerCase().includes(val.toLowerCase())
        );
      this.systemFeildsList.find((item: any) => item.id == items.id).colorCode =
        '#cc570e';
    } else {
      this.systemFeildsList.find((item: any) => item.id == items.id).colorCode = '';
      this.allKeyValueDataListFormFeild =
        this.allKeyValueDataListFilterForFormFeild;
    }
  }

  //=====  Open Form Field Mapping =========//
  selectedSystemFieldItem: any;
  showFiledMapping = false;

  openFormFieldMapping(item: any) {
    this.selectedSystemFieldItem = item;
    this.showFiledMapping = true;
  }

  closeMappingPopUp() {
    this.dialog.closeAll();
  }

  fieldValueSelectedForMapping(value: any) {
    // var check=[];
    // check= this.systemFeildsList.filter(x=>x.fieldID==value.fieldID);
    // if(check.length>0){
    //   this.toastr.warning('Selected field allready mapped,Choose another field.', '', {
    //     timeOut: 3000,
    //   });
    //   return;
    // }

    this.systemFeildsList.find(
      (item: any) => item.id == this.selectedSystemFieldItem.id
    ).value = value.value;
    this.systemFeildsList.find(
      (item: any) => item.id == this.selectedSystemFieldItem.id
    ).formFieldName = value.key;
    this.systemFeildsList.find(
      (item: any) => item.id == this.selectedSystemFieldItem.id
    ).colorCode = '#47e309';
    this.markSystemFieldsDirty();
    this.showFiledMapping = false;

    if (this.ocrData != null) {
      var checks: any;
      checks = JSON.parse(this.ocrData);
      if (checks.KeyValuePairs == undefined) {
        var data = checks.filter(
          (pair: any) => pair.Key.Content.replace(/:$/, '') == value.key
        );
        if (data.length > 0) {
          this.CurrentPage = data[0].Key.BoundingRegions[0].PageNumber;
          this.ChangePage(this.CurrentPage);
        }
      }
      if (checks.KeyValuePairs != undefined) {
        var data = checks.KeyValuePairs.filter(
          (pair: any) => pair.Key.Content.replace(/:$/, '') == value.key
        );
        if (data.length > 0) {
          this.CurrentPage = data[0].Key.BoundingRegions[0].PageNumber;
          this.ChangePage(this.CurrentPage);
        }
      }
    }
  }

  // Pin icon on a key/value row (Qualifying + form-field tables): locate by OCR key.
  fieldValueSelectedGotoPage(value: any) {
    this.locateFieldInDocument(value, value?.key, value?.key);
  }

  // Pin icon on a system-field row (AI Data table): locate by the mapped form field.
  fieldValueSelectedGotoPage1(value: any) {
    this.locateFieldInDocument(value, value?.formFieldName, value?.fieldName || value?.formFieldName);
  }

  // ── "Locate in document" spotlight ────────────────────────────────────────
  // Row (object identity) currently being located → mirrored accent in the table.
  locatingRow: any = null;
  private locateTimer: any = null;
  private locateRowTimer: any = null;

  // Cycle state: the same key clicked again steps to its next occurrence.
  private locateCycle = { key: '', index: -1 };

  // ALL occurrences of a key in the OCR output, in reading order (page, then top→down).
  private findOcrPairs(matchKey: string): any[] {
    if (this.ocrData == null || !matchKey) return [];
    let checks: any = JSON.parse(this.ocrData);
    const pairs: any[] = checks.KeyValuePairs != undefined ? checks.KeyValuePairs : checks;
    if (!Array.isArray(pairs)) return [];
    const key = String(matchKey).replace(/:$/, '').trim().toLowerCase();
    const posOf = (pair: any) => {
      const r = pair.Key.BoundingRegions && pair.Key.BoundingRegions[0];
      const pts = (r && r.BoundingPolygon) || [];
      const y = pts.length ? Math.min(...pts.map((p: any) => Number(p.Y) || 0)) : 0;
      return { page: r ? Number(r.PageNumber) || 0 : 0, y };
    };
    return pairs
      .filter((pair: any) => pair && pair.Key && pair.Key.Content &&
        String(pair.Key.Content).replace(/:$/, '').trim().toLowerCase() == key)
      .sort((a: any, b: any) => {
        const pa = posOf(a), pb = posOf(b);
        return pa.page - pb.page || pa.y - pb.y;
      });
  }

  private ocrValueText(pair: any): string {
    return pair && pair.Value && pair.Value.Content ? String(pair.Value.Content).trim() : '';
  }

  /**
   * Switch to Field View (the canvas pages), scroll so the located VALUE sits in
   * the middle of the viewer and paint a pulsing spotlight over it. The other
   * OCR boxes are untouched — the spotlight is a DOM overlay above the canvas,
   * so nothing is re-rendered and it can be removed without redrawing the PDF.
   *
   * A key that occurs several times in the document (e.g. "Phone:" under
   * Employment, Primary and Secondary insurance) is CYCLED: the first click
   * lands on the occurrence whose value matches the row's extracted value
   * (else the first one), every further click on the same pin moves to the
   * next occurrence, wrapping around, and the tag shows "Phone · 2/4".
   */
  locateFieldInDocument(row: any, matchKey: string, label: string) {
    const pairs = this.findOcrPairs(matchKey);
    if (!pairs.length) {
      this.toastr.info('Could not find this value in the document.', '', { timeOut: 2500 });
      return;
    }
    const cycleKey = String(matchKey).replace(/:$/, '').trim().toLowerCase();
    let index: number;
    if (this.locateCycle.key === cycleKey && this.locateCycle.index >= 0) {
      index = (this.locateCycle.index + 1) % pairs.length;          // next occurrence
    } else {
      const rowValue = row && row.value != null ? String(row.value).trim().toLowerCase() : '';
      index = rowValue ? pairs.findIndex((p: any) => this.ocrValueText(p).toLowerCase() === rowValue) : -1;
      if (index < 0) index = 0;
    }
    this.locateCycle = { key: cycleKey, index };

    const pair = pairs[index];
    const valueText = this.ocrValueText(pair);
    // Empty value (e.g. a blank "Phone:") → spotlight the key itself.
    const region = (valueText && pair.Value.BoundingRegions && pair.Value.BoundingRegions[0])
      || (pair.Key && pair.Key.BoundingRegions && pair.Key.BoundingRegions[0]);
    if (!region || !region.BoundingPolygon) return;
    if (pairs.length > 1) {
      label = `${label || matchKey} · ${index + 1}/${pairs.length}${valueText ? '' : ' (empty)'}`;
    } else if (!valueText) {
      label = `${label || matchKey} (empty)`;
    }

    const wasZoomView = this.showPdfViewer;
    this.showPdfViewer = false;
    this.TitleDocs = "Field View";
    this.CurrentPage = region.PageNumber;
    this.ChangePage(this.CurrentPage);

    // Mirror in the table for the same few seconds as the spotlight.
    this.locatingRow = row;
    if (this.locateRowTimer) clearTimeout(this.locateRowTimer);
    this.locateRowTimer = setTimeout(() => { this.locatingRow = null; }, 4000);

    // Field View may have been display:none until this tick — canvases need a
    // layout pass before their on-screen size can be measured.
    const coords = this.convertInchesToPixels(region.BoundingPolygon, null);
    setTimeout(() => this.spotlightValue(region.PageNumber, coords, label), wasZoomView ? 120 : 30);
  }

  private spotlightValue(pageNumber: number, coords: number[], label: string) {
    const container: HTMLElement = this.pdfContainer?.nativeElement;
    const scroller: HTMLElement = this.pdfscrolls?.nativeElement;
    if (!container || !scroller) return;
    const canvases = container.querySelectorAll('canvas');
    const canvas = canvases[pageNumber - 1] as HTMLCanvasElement;
    if (!canvas || !canvas.width || !coords || coords.length < 4) return;

    // Polygon coords are in canvas pixels (scale 1.5); the canvas is CSS-scaled to 100% width.
    const ratio = canvas.clientWidth / canvas.width;
    let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
    for (let i = 0; i < coords.length; i += 2) {
      minX = Math.min(minX, coords[i]); maxX = Math.max(maxX, coords[i]);
      minY = Math.min(minY, coords[i + 1]); maxY = Math.max(maxY, coords[i + 1]);
    }
    const pad = 4;
    const left = canvas.offsetLeft + minX * ratio - pad;
    const top = canvas.offsetTop + minY * ratio - pad;
    const width = (maxX - minX) * ratio + pad * 2;
    const height = (maxY - minY) * ratio + pad * 2;

    this.clearSpotlight();
    const spot = this.renderer.createElement('div');
    this.renderer.addClass(spot, 'locate-spot');
    this.renderer.setStyle(spot, 'left', `${left}px`);
    this.renderer.setStyle(spot, 'top', `${top}px`);
    this.renderer.setStyle(spot, 'width', `${width}px`);
    this.renderer.setStyle(spot, 'height', `${height}px`);
    if (label) {
      const tag = this.renderer.createElement('span');
      this.renderer.addClass(tag, 'tag');
      this.renderer.appendChild(tag, this.renderer.createText(label));
      this.renderer.appendChild(spot, tag);
    }
    this.renderer.appendChild(container, spot);

    // Centre the box vertically in the viewer (not the page top).
    const containerTop = container.getBoundingClientRect().top - scroller.getBoundingClientRect().top + scroller.scrollTop;
    const target = containerTop + top + height / 2 - scroller.clientHeight / 2;
    scroller.scrollTop = Math.max(0, target);

    // Fade out, then remove.
    this.locateTimer = setTimeout(() => {
      this.renderer.addClass(spot, 'fade');
      this.locateTimer = setTimeout(() => this.clearSpotlight(), 450);
    }, 3500);
  }

  private clearSpotlight() {
    if (this.locateTimer) { clearTimeout(this.locateTimer); this.locateTimer = null; }
    const container: HTMLElement = this.pdfContainer?.nativeElement;
    if (!container) return;
    container.querySelectorAll('.locate-spot').forEach((el: Element) => el.remove());
  }
  //========== Add OCR Save data=============//

  addMappedKeyValueDatas($event: any) {
    $event.stopPropagation();
    // ===  Save OCR Data =====//
    if (
      this.currentNavigation == NAVIGATION.AIData ||
      this.currentNavigation == NAVIGATION.Qualifying ||
      this.currentNavigation == NAVIGATION.QUESTIONS
    ) {
      this.saveMappedKeyValueData();

    }

    // ===  Save NLP Data =====//
    //  else if(this.currentNavigation == NAVIGATION.NLP){

    //   }
  }

  // === For addMappedKeyValueData ====//
  saveMappedKeyValueData() {
    var keyValueData: any = [];
    this.systemFeildsList.forEach((e: any) => {
      var obj = {
        keyID: 0,
        key: e.formFieldName,
        fieldName: e.fieldName,
        fieldID: e.fieldID,
        value: e.value,
      };
      keyValueData.push(obj);
    });
    var ReqModel = {
      cid: this.transactionID,
      cType: this.typeForAddCategory,
      documentID: this.documentId,
      keyValueData: keyValueData,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId),
    };
    this.loaderService.show();
    this.formsService.addMappedKeyValueData(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (
          this.responseHolder.status == this.statusConst.statusSuccess &&
          this.responseHolder.data != null
        ) {
          this.captureSystemFieldsSnapshot();
          this.toastr.success('Record saved successfully.', '', {
            timeOut: 3000,
          });
        } else {
          this.loaderService.hide();
          this.toastr.error(this.responseHolder.message, '', {
            timeOut: 3000,
          });
        }
      } else {
        this.loaderService.hide();
        this.toastr.error(this.responseHolder.message, '', {
          timeOut: 3000,
        });
      }
    });
  }

  //========Get Core User Details====//
  TypeIdDrp: any;

  getCoreUserDetailsforSubFolderId() {
    var reqModels = {
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      coreID: Number(this.transactionID),
      folderId: Number(this.folderID),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
    };
    this.coreService.getCoreUserDetails(reqModels).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          var TypeData = response.data.fields.filter((e: any) => e.fieldTypeName == 'Dropdown' && e.fieldName == 'Type');

          if (TypeData.length > 0 && TypeData != undefined) {
            if (TypeData[0].fieldValue != "") {
              let id: string = TypeData[0].fieldValue.toString();
              this.TypeIdDrp = parseInt(id);
            }
            else {
              this.TypeIdDrp = "0";
            }
          }
          else {
            this.TypeIdDrp = "0";
          }
          //this.getCoreUserDetail();
        }
      }
    });
  }

  getCoreUserDetail() {
    var reqModels = {
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      coreID: Number(this.transactionID),
      folderId: Number(this.folderID),
      subFolderID: Number(this.TypeIdDrp),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
    };
    this.coreService.getCoreUserDetails(reqModels).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          var userDetailsForCore = [];
          this.status = response.data.status;
          this.imageUrl = response.data.imageUrl;
          userDetailsForCore = response.data.fields;
          this.FieldcheckForCore(userDetailsForCore);
        } else {
        }
      } else {
      }
    });
  }

  FieldcheckForCore(userDetails: any) {
    if (this.typeForAddCategory == 1 && this.transactionID > 0) {
      var check: any = [];
      var newFields: any = [];
      check = this.systemFeildsList.filter(
        (x: any) => x.fieldID > 0 && x.value != ''
      );
      if (check.length > 0) {
        for (let i = 0; i < check.length; i++) {
          var fieldName;
          if (check[i].fieldID > 0) {
            var data = [];
            data = this.systemFeildsList.filter(
              (x: any) => x.fieldID == check[i].fieldID
            );
            if (data.length > 0) {
              fieldName = data[0].fieldName;
            }
          } else {
            fieldName = check[i].fieldName;
          }

          var record = [];
          record = userDetails.filter((x: any) => x.fieldID == check[i].fieldID);
          if (record.length > 0) {
            var obj = {
              childFields: [],
              fieldNameID: null,
              fieldName: fieldName,
              fieldID: check[i].fieldID,
              fieldValue: check[i].value,
              subFolderID: 0,
              id: record[0].id,
            };
            newFields.push(obj);
          }
        }
      }

      var reqModel = {
        coreID: this.transactionID,
        fields: newFields,
        imageUrl: this.imageUrl,
        officeIDList: this.OfficeIDList,
        officeID: this.myOfficeID,
        databaseID: Number(this.databaseId),
        status: this.status,
        typeID: Number(this.TypeIdDrp) > 0 ? Number(this.TypeIdDrp) : 0,
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
      };
      this.loaderService.show();
      this.coreService.saveCoreUserDetails(reqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          this.loaderService.hide();
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.loaderService.hide();
            this.toastr.success('Record update successfully.', '', {
              timeOut: 3000,
            });
          } else {
            this.loaderService.hide();
          }
        } else {
          this.loaderService.hide();
        }
      });
    }
  }

  //========Get Contact User Details======//

  getContactUserDetail() {
    var reqModels = {
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      contactID: Number(this.transactionID),
      folderId: Number(this.folderID),
      subFolderID: Number(this.typeIdCCC),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
    };
    this.coreService.getContactUserDetails(reqModels).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          var userDetailsForContact = [];
          this.status = response.data.status;
          this.imageUrl = response.data.imageUrl;
          userDetailsForContact = response.data.fields;
          this.FieldcheckForContact(userDetailsForContact);
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  FieldcheckForContact(userDetails: any) {
    if (this.typeForAddCategory == 2 && this.transactionID > 0) {
      var check: any = [];
      var newFields = [];
      check = this.systemFeildsList.filter(
        (x: any) => x.fieldID > 0 && x.value != ''
      );
      if (check.length > 0) {
        for (let i = 0; i < check.length; i++) {
          var fieldName;
          if (check[i].fieldID > 0) {
            var data = [];
            data = this.systemFeildsList.filter(
              (x: any) => x.fieldID == check[i].fieldID
            );
            if (data.length > 0) {
              fieldName = data[0].fieldName;
            }
          } else {
            fieldName = check[i].fieldName;
          }

          var record = [];
          record = userDetails.filter((x: any) => x.fieldID == check[i].fieldID);
          if (record.length > 0) {
            var obj = {
              childFields: [],
              fieldNameID: null,
              fieldName: fieldName,
              fieldID: check[i].fieldID,
              fieldValue: check[i].value,
              subFolderID: 0,
              id: record[0].id,
            };
            newFields.push(obj);
          }
        }
      }

      var reqModel = {
        contactID: this.transactionID,
        fields: newFields,
        imageUrl: this.imageUrl,
        officeIDList: this.OfficeIDList,
        officeID: this.myOfficeID,
        databaseID: Number(this.databaseId),
        status: this.status,
        typeID: Number(this.typeIdCCC) > 0 ? Number(this.typeIdCCC) : 0,
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
      };
      //return;
      this.loaderService.show();
      this.coreService
        .saveContactUserDetails(reqModel)
        .subscribe((response) => {
          if (response != undefined) {
            this.responseHolder = response;
            this.loaderService.hide();
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.loaderService.hide();
              this.toastr.success('Record update successfully.', '', {
                timeOut: 3000,
              });
            } else {
              this.loaderService.hide();
            }
          } else {
            this.loaderService.hide();
          }
        });
    }
  }

  //========Get Company User Details======//

  getCompanyUserDetail() {
    var reqModels = {
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      companyID: Number(this.transactionID),
      folderId: Number(this.folderID),
      subFolderID: Number(this.typeIdCCC),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
    };
    this.coreService.getCompanyUserDetails(reqModels).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          var userDetailsForCompany = [];
          this.status = response.data.status;
          this.imageUrl = response.data.imageUrl;
          userDetailsForCompany = response.data.fields;
          this.FieldcheckForCompany(userDetailsForCompany);
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  FieldcheckForCompany(userDetails: any) {
    if (this.typeForAddCategory == 3 && this.transactionID > 0) {
      var check: any = [];
      var newFields: any = [];
      check = this.systemFeildsList.filter(
        (x: any) => x.fieldID > 0 && x.value != ''
      );
      if (check.length > 0) {
        for (let i = 0; i < check.length; i++) {
          var fieldName;
          if (check[i].fieldID > 0) {
            var data = [];
            data = this.systemFeildsList.filter(
              (x: any) => x.fieldID == check[i].fieldID
            );
            if (data.length > 0) {
              fieldName = data[0].fieldName;
            }
          } else {
            fieldName = check[i].fieldName;
          }

          var record = [];
          record = userDetails.filter((x: any) => x.fieldID == check[i].fieldID);
          if (record.length > 0) {
            var obj = {
              childFields: [],
              fieldNameID: null,
              fieldName: fieldName,
              fieldID: check[i].fieldID,
              fieldValue: check[i].value,
              subFolderID: 0,
              id: record[0].id,
            };
            newFields.push(obj);
          }
        }
      }

      var reqModel = {
        companyID: this.transactionID,
        fields: newFields,
        imageUrl: this.imageUrl,
        officeIDList: this.OfficeIDList,
        officeID: this.myOfficeID,
        databaseID: Number(this.databaseId),
        status: this.status,
        typeID: Number(this.typeIdCCC) > 0 ? Number(this.typeIdCCC) : 0,
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
      };
      this.loaderService.show();
      this.coreService
        .saveCompanyUserDetails(reqModel)
        .subscribe((response) => {
          if (response != undefined) {
            this.responseHolder = response;
            this.loaderService.hide();
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.loaderService.hide();
              this.toastr.success('Record update successfully.', '', {
                timeOut: 3000,
              });
            } else {
              this.loaderService.hide();
            }
          } else {
            this.loaderService.hide();
          }
        });
    }
  }

  scrollToPage() {
    var pagenumber = 2;
    this.pdfPageheight;
    const scrollPosition = (pagenumber - 1) * this.pdfPageheight;
    this.pdfscrolls.nativeElement.scrollTop = scrollPosition;
  }

  ChangePage(val: any) {
    if (Number(val) == 0) {
      this.toastr.warning('Please enter valid page number.', '', {
        timeOut: 5000,
      });
      return;
    }
    if (Number(val) > this.totalNumberPages) {
      this.toastr.warning('Please enter valid page number.', '', {
        timeOut: 5000,
      });
      return;
    }
    var pagenumber = Number(val);
    this.CurrentPage = Number(val);
    this.pdfPageheight;
    const scrollPosition = (pagenumber - 1) * this.pdfPageheight;
    this.pdfscrolls.nativeElement.scrollTop = scrollPosition;
  }


  numberOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  onImageClick(val: any) {
    this.CurrentPage = Number(val);
    var pagenumber = Number(val);
    this.pdfPageheight;
    const scrollPosition = (pagenumber - 1) * this.pdfPageheight;
    this.pdfscrolls.nativeElement.scrollTop = scrollPosition;
  }

  showPdfInMobile = false;

  showPDF() {
    this.showPdfInMobile = true;
  }
  closeShowPDF() {
    this.showPdfInMobile = false;
  }

  FieldNameListFiltered: any = ([] = []);

  remove(fruit: string): void {
    const index = this.Feilds.indexOf(fruit);

    if (index >= 0) {
      this.Feilds.splice(index, 1);
    }
    // this.updateCustomfieldForm.reset();
    this.CreateFeild = false;
    this.ImportFeild = false;
    this.FieldNameListFiltered = [];
    // this.corevaluesDropdown=[];
    // this.contactvaluesDropdown=[];
    // this.companyvaluesDropdown=[];

    // this.selectedGlobalPermission="0";

    // this.addCreatefieldForm.reset();
    // this.addCreatefieldForm.controls['fieldCategoty'].setValue('2');
    // this.showFieldVategoryTypeGlobal = true;
    // this.showFieldVategoryTypecustom = false;
    // this.clear();
    // this.folderIdCheck = true;
    this.selectedRoleList = [];

    // this.addCreatefieldForm.controls['fieldName'].setValue("");
    // this.showFieldVategoryTypeGlobal = true;

    // this.folderIdCheckbox = [];
    // this.folderIdCheckbox.push(this.folderId);
    // var checkArray :FormArray;
    // checkArray = this.addCreatefieldForm.get('checkArray') as FormArray;
    // checkArray.push(new FormControl(this.folderId));

    // checkArray = this.updateCustomfieldForm.get('checkArray') as FormArray;
    // checkArray.clear();
    // checkArray.push(new FormControl(this.folderId));
    // this.spinner=false;
  }

  searchFeildName(val: any) {
    this.FieldNameListFiltered = [];
    if (val != '') {
      this.fieldName = val;
      this.ShowAddFieldButton = true;
    } else {
      this.ShowAddFieldButton = false;
    }
    if (val && val.length > 2) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.getSearchFieldName(val);
      }, 500);
    } else {
      this.FieldNameListFiltered = [];
    }
  }

  getSearchFieldName(searchValue: any) {
    if (searchValue == '' || searchValue == null || searchValue == undefined) {
      this.FieldNameListFiltered = [];
      return;
    }
    var ReqModel = {
      fieldName: searchValue.trim(),
      userID: this.currentUser.UID,
      isSearch: true,
      organizationID: Number(sessionStorage.getItem('organizationID')),
      officeID: this.myOfficeID,
    };

    this.formsService.SearchFieldName(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.CreateFeild = true;
        this.ShowAddFieldButton = true;
        this.ImportFeild = false;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.FieldNameListFiltered = this.responseHolder.data;
          this.loaderService.hide();
        } else {
          // this.showFieldVategoryTypeGlobal;
          // this.showFieldVategoryTypecustom;

          // this.updateCustomfieldForm.reset();
          // this.addCreatefieldForm.reset();

          // if(this.showFieldVategoryTypecustom==true){
          //   this.showFieldVategoryTypecustom = true;
          //   this.showFieldVategoryTypeGlobal = false;
          //   this.addCreatefieldForm.controls['fieldCategoty'].setValue('3');
          // }
          // if(this.showFieldVategoryTypeGlobal==true){
          //   this.showFieldVategoryTypecustom = false;
          //   this.showFieldVategoryTypeGlobal = true;
          //  this.addCreatefieldForm.controls['fieldCategoty'].setValue('2');
          // }

          // this.CreateFeild=true;
          // this.ImportFeild=false;

          // this.selectedGlobalPermission="0";
          // this.addCreatefieldForm.controls['fieldName'].setValue(searchValue);

          // this.FieldNameListFiltered=[];
          // this.folderIdCheckbox = [];
          // this.folderIdCheckbox.push(this.folderId);
          // var checkArray :FormArray;
          // checkArray = this.addCreatefieldForm.get('checkArray') as FormArray;
          // checkArray.clear();
          // checkArray.push(new FormControl(this.folderId));

          // checkArray = this.updateCustomfieldForm.get('checkArray') as FormArray;
          // checkArray.clear();
          // checkArray.push(new FormControl(this.folderId));
          // this.spinner=false;

          this.loaderService.hide();
        }
      } else {
        this.FieldNameListFiltered = [];
        this.loaderService.hide();
      }
    });
  }

  getFieldsListResponseHolder: any = ([] = []);
  CreateFeild: boolean = true;
  ImportFeild: boolean = false;

  FeildSelected(obj: any) {
    if (obj.fieldTypeName == "Textbox" || obj.fieldTypeName == "Textarea" || obj.fieldTypeName == "Date" ||
      obj.fieldTypeName == "Dropdown") {
      this.CreateFeild = false;
      this.ImportFeild = true;
      this.FieldNameListFiltered = [];
      this.selectedRoleList = [];
      this.getGlobalFieldDetails(obj);
    } else {
      this.CreateFeild = false;
      this.ImportFeild = false;
      this.fieldName = "";
      this.Feilds = [];
      //this.feildInput.nativeElement.value = '';
      this.toastr.warning('You can import Texbox/Texarea/Date field only.', '', {
        timeOut: 3000,
      });
      return;
    }

  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.Feilds = this.Feilds.map(function (el) {
      return el.trim();
    });
    const index = this.Feilds.indexOf(event.option.viewValue);

    if (index >= 0) {
      this.feildInput.nativeElement.value = '';
    } else {
      this.Feilds.push(event.option.viewValue);
      this.feildInput.nativeElement.value = '';
    }
  }

  add(event: MatChipInputEvent): void { }

  fieldCategotyTypeID: string = '';
  fieldDetailsList: any = ([] = []);
  selectedRoleList: any = [];
  fieldTypeID: number = 0;
  fieldData: any;

  getGlobalFieldDetails(obj: any) {
    this.fieldDetailsList = [];
    this.selectedRoleList = [];
    var ReqModel = {
      databaseID: parseInt(sessionStorage.getItem('databaseId')),
      organizationID: parseInt(sessionStorage.getItem('organizationID')),
      userID: this.currentUser.UID,
      folderID: 0,
      fieldID: obj.fieldID,
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList,
    };
    this.loaderService.show();
    this.formsService.getCustomdetails(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.loaderService.hide();
        this.getFieldsListResponseHolder = response;
        if (
          this.getFieldsListResponseHolder.status ==
          this.statusConst.statusSuccess
        ) {
          // this.updateFieldmodel.availableonForms= this.getFieldsListResponseHolder.data.availableOnForms;
          this.fieldDetailsList = this.getFieldsListResponseHolder.data;
          this.fieldName = this.fieldDetailsList.fieldName;
          this.fieldTypeID = this.fieldDetailsList.fieldTypeID;
          this.fieldCategotyTypeID = String(
            this.fieldDetailsList.fieldCategoryID
          );
          this.fieldData = this.fieldDetailsList;
          // this.folderIdCheck = true;
          if (this.getFieldsListResponseHolder.data.persmission)
            if (this.getFieldsListResponseHolder.data.rolePermissions) {
              // this.selectedGlobalPermission= String(this.getFieldsListResponseHolder.data.persmission);
              this.getFieldsListResponseHolder.data.rolePermissions.forEach(
                (e: any) => {
                  this.selectedRoleList.push({
                    isDeleted: false,
                    name: e.roleName,
                    roleID: e.roleID,
                    permission: e.permission,
                    fieldPermissionID: e.fieldPermissionID,
                    action: 0,
                  });
                }
              );
            }
          // this.updateFieldmodel.fieldCategotyTypeID = String(this.fieldDetailsList.fieldCategoryID);
          // this.updateFieldmodel.fieldName = this.fieldDetailsList.fieldName;
          // this.updateFieldmodel.fieldTypeID = this.fieldDetailsList.fieldTypeID;
          // if (this.updateFieldmodel.fieldCategotyTypeID == '2') {
          //   this.showFieldVategoryTypeGlobal = true;
          //   this.showFieldVategoryTypecustom = false;
          //   this.glbalDisable = false;
          //   this.customDisable = true;
          //   const checkArray: FormArray = this.updateCustomfieldForm.get('checkArray') as FormArray;
          //   //&& e.folderName!='Task'
          //   var availableOn = this.fieldDetailsList.availableOn.filter((e) => e.folderName != 'Forms');

          //   availableOn.forEach((element) => {
          //     if (element.isChecked == true) {
          //       this.folderIdCheckbox.push(element.folderID);
          //       checkArray.push(new FormControl(element.folderID));
          //     }
          //   });
          // } else {
          //   this.showFieldVategoryTypecustom = true;
          //   this.showFieldVategoryTypeGlobal = false;
          //   this.glbalDisable = true;
          //   this.customDisable = false;
          //   this.folderIdCheck = false;
          //   this.fieldDetailsList.availableOn.forEach((element) => {
          //     if (element.subFolders.length > 0) {
          //       if (element.folderName == CCCName.Company) {
          //         element.subFolders.forEach((e) => {
          //           if (e.isChecked == true) {
          //             this.companyvaluesDropdown.push(e.subFolderID);
          //           }
          //         });
          //       } else if (element.folderName == CCCName.Contact) {
          //         element.subFolders.forEach((e) => {
          //           if (e.isChecked == true) {
          //             this.contactvaluesDropdown.push(e.subFolderID);
          //           }
          //         });
          //       } else if (element.folderName == CCCName.Core) {
          //         element.subFolders.forEach((e) => {
          //           if (e.isChecked == true) {
          //             this.corevaluesDropdown.push(e.subFolderID);
          //           }
          //         });
          //       }
          //     }
          //   });
          // }
          // this.fieldData = this.fieldDetailsList;
          // this.bindDataForEdit(this.fieldData);
        } else {
          this.loaderService.hide();
        }
      }
      this.loaderService.hide();
    });
  }

  //======= For Save Update Question Template ====================//

  filteredQuestionCategoryList: any = ([] = []);
  updateQuestionTemplateButton: boolean = false;
  showNew: boolean = false;
  showExisting: boolean = false;
  ShowNoRecordFoundQuestionTemplate: boolean = false;
  TemplatesListForQuestion: any = ([] = []);
  updateQuestionTemplateTasksButton: boolean = false;
  QuestioncategoryType: number = 0;
  QuestionCategoryList: any = ([] = []);
  NLPTemplatesList: any = ([] = []);
  selectedcategoryIDForQuestion: number = 0;
  nlpTemplateID: number = 0;
  QuestionTemplateIDImportTask: number = 0;
  selectedCategory: number = 0;
  deletedQuery: any = ([] = []);
  selectedcategoryIDForUpdate: number = 0;
  NLPTemplatesListFilter: any = ([] = []);
  searchTemplateQuestion: string = '';
  categoryType: number = 0;

  openQuestionTemplate(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef, {
      panelClass: 'saveTemplatePopup',
    });
    this.categoryType = 0;
    this.showNew = true;
    this.showExisting = false;
    let group = {};
    this.addTemplateForm = new FormGroup(group);
    this.createSaveAsTaskTemplate();
    this.getActiveQuestionTemplateAfterAdd('');
  }

  OnCategoryChange(categoryTypeValue: number) {
    this.TaskTemplatesList = [];
    this.QuestionCategoryList = [];
    this.filteredQuestionCategoryList = [];
    // this.NLPTemplatesList=[];
    this.categoryType = categoryTypeValue;
    this.getActiveQuestionTemplateAfterAdd('');
  }

  OnCategoryChangeFieldTemp(categoryTypeValue: number) {
    this.TaskTemplatesList = [];
    this.QuestionCategoryList = [];
    this.filteredTempCategoryList = [];
    this.filteredQuestionCategoryList = [];
    this.categoryType = categoryTypeValue;
    this.getActiveTemplateCategoriesAfterAdd();
  }

  closeSaveAsTemplateForQuestionTemplate() {
    this.selectedcategoryIDForUpdate = 0;
    this.addTemplateForm.reset();
    this.dialog.closeAll();
  }

  getTabDetailsQuestionTemplate(event: any) {
    this.searchTemplateQuestion = '';
    this.selectedcategoryIDForQuestion = 0;
    this.selectedcategoryIDForUpdate = 0;
    this.nlpTemplateID = 0;
    this.showNew = true;
    this.showExisting = false;
    this.updateQuestionTemplateButton = false;
    //this.filteredQuestionCategoryList=[];
    this.createSaveAsTaskTemplate();
    // this.NLPTemplatesList=[];
    if (event.tab.textLabel == 'New' || event.index == 0) {
      this.showNew = true;
      this.showExisting = false;
    }
    if (event.tab.textLabel == 'Update Existing' || event.index == 1) {
      this.selectedCategory = 0;
      this.showNew = false;
      this.showExisting = true;
      this.getNLPTemplates();
    }
  }

  openDialogAddQuestionTemplate() {
    const dialogRef = this.dialog.open(AddQuestionTempCategoryComponent, {
      data: {
        categoryType: Number(this.categoryType),
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result != null && result != undefined) {
        this.getActiveQuestionTemplateAfterAdd(result);
      }
    });
  }

  getActiveQuestionTemplateAfterAdd(categoryName: string) {
    var ReqModel = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      isCategoriesOnly: true,
      isAll: false,
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId),
      type: this.categoryType > 0 ? this.categoryType : 0,
    };
    this.formsService.getNLPTemplateCategories(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.QuestionCategoryList = response.data;
          this.filteredQuestionCategoryList = this.QuestionCategoryList.filter((m: any) => m.type == this.categoryType);
          if (categoryName != '') {
            var check = [];
            check = this.QuestionCategoryList.filter((x: any) => x.nlpTemplateCategoryName.toLowerCase() == categoryName.toLowerCase());
            if (check.length > 0) {
              this.addTemplateForm.controls['folderID'].setValue(check[0].nlpTemplateCategoryID);
            }
          }
        } else {
          this.QuestionCategoryList = [];
          this.filteredQuestionCategoryList = [];
        }
      } else {
        this.QuestionCategoryList = [];
        this.filteredQuestionCategoryList = [];
      }
    });
  }

  getSelectQuestionTemplate(e: any) {
    this.searchTemplateQuestion = '';
    this.selectedcategoryIDForQuestion = e.value;
    this.updateQuestionTemplateButton = false;
    this.getNLPTemplates();
  }

  searchTemplateForQuestion(val: any) {
    if (val.length >= 2) {
      if (val != '') {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.updateQuestionTemplateButton = false;
          this.NLPTemplatesList = this.NLPTemplatesListFilter.filter(
            (i: any) =>
              i.tempalteName.toLowerCase().indexOf(val.toLocaleLowerCase()) !==
              -1
          );
          if (this.NLPTemplatesList.length > 0) {
            this.ShowNoRecordFoundQuestionTemplate = false;
          } else {
            this.ShowNoRecordFoundQuestionTemplate = true;
          }
        }, 500);
      } else {
      }
    } else {
      this.updateQuestionTemplateButton = false;
      this.NLPTemplatesList = this.NLPTemplatesListFilter;
      //this.getTaskTemplatesForSingleTask();
    }
  }

  SelectTemplateForQuestionTemplate(temp: any) {
    this.nlpTemplateID = temp.templateID;
    this.selectedcategoryIDForUpdate = temp.categoryID;
    this.updateQuestionTemplateButton = true;
  }

  //========For Question Template ==================//

  AddQuestionTemplate(data: any) {
    if (this.queryBlocks.length == 0) {
      this.toastr.warning('Please add question.', '', {
        timeOut: 3000,
      });
      return;
    }
    var checkquestion = [];
    checkquestion = this.queryBlocks.filter((x: any) => x.askQAquery != '' || x.systemPromptID > 0);
    if (checkquestion.length == 0) {
      this.toastr.warning('Please add question.', '', {
        timeOut: 3000,
      });
      return;
    }
    var questionQuery = [];
    if (this.queryBlocks.length > 0) {
      for (let i = 0; i < this.queryBlocks.length; i++) {
        var obj = {
          queryID: this.queryBlocks[i].nlpTemplateID,
          title: this.queryBlocks[i].title,
          query: this.queryBlocks[i].askQAquery,
          isNTA: this.queryBlocks[i].isNta,
          isMedication: this.queryBlocks[i].isMedication,
          isAllergy: this.queryBlocks[i].isAllergy,
          isImmunization: this.queryBlocks[i].isImmunization,
          isCondition: this.queryBlocks[i].isCondition,
          isObservation: this.queryBlocks[i].isObservation,
          position: this.queryBlocks[i].position,
          isMedicationSaved: this.queryBlocks[i].isMedicationSaved,
          ChoosenPromptID: this.queryBlocks[i].choosenPromptID,
          staticTitleForChoosenID: this.queryBlocks[i].staticTitleForChoosenID ? this.queryBlocks[i].staticTitleForChoosenID : this.queryBlocks[i].title,
          //systemPromptID:this.queryBlocks[i].systemPromptID
          systemPromptID: this.queryBlocks[i].systemPromptID != undefined ? this.queryBlocks[i].systemPromptID : 0

        };
        questionQuery.push(obj);
      }
    }
    this.loaderService.show();
    var ReqModel = {
      templateName: data.taskTemplateName,
      templateType: this.categoryType, // For My Template
      categoryID: data.folderID,
      templateQueries: questionQuery,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
    };
    this.spinner = true;
    this.addTemplateForm.markAsPristine();
    this.formsService.addNLPTemplate(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.spinner = false;
          this.loaderService.hide();
          this.toastr.success('Template added successfully.', '', {
            timeOut: 3000,
          });
          this.closeSaveAsTemplate();
        } else {
          this.toastr.error('Template add failed.', '', {
            timeOut: 3000,
          });
          this.spinner = false;
          this.loaderService.hide();
        }
      } else {
        this.toastr.error('Question Template add failed.', '', {
          timeOut: 3000,
        });
        this.spinner = false;
        this.loaderService.hide();
      }
    });
  }

  getNLPTemplates() {
    var ReqModel = {
      templateType: this.categoryType, // For My Template
      categoryID: this.selectedcategoryIDForQuestion,
      isAll: true,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
    };
    this.formsService.getNLPTemplates(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (
          this.responseHolder.status == this.statusConst.statusSuccess &&
          this.responseHolder.data != null
        ) {
          this.NLPTemplatesList = response.data;
          this.NLPTemplatesListFilter = response.data;
          if (this.NLPTemplatesList.length > 0) {
            this.ShowNoRecordFoundQuestionTemplate = false;
          } else {
            this.ShowNoRecordFoundQuestionTemplate = true;
          }
        } else {
          this.NLPTemplatesList = [];
          this.NLPTemplatesListFilter = [];
        }
      } else {
        this.NLPTemplatesList = [];
        this.NLPTemplatesListFilter = [];
      }
    });
  }

  updateNLPTemplateData() {
    if (this.queryBlocks.length == 0) {
      this.toastr.warning('Please add question.', '', {
        timeOut: 3000,
      });
      return;
    }
    var checkquestion = [];
    checkquestion = this.queryBlocks.filter((x) => x.askQAquery != '' || x.systemPromptID > 0);
    if (checkquestion.length == 0) {
      this.toastr.warning('Please add question.', '', {
        timeOut: 3000,
      });
      return;
    }

    var questionQuery = [];
    if (this.queryBlocks.length > 0) {
      for (let i = 0; i < this.queryBlocks.length; i++) {
        var obj = {
          queryID: this.queryBlocks[i].nlpTemplateID,
          query: this.queryBlocks[i].askQAquery,
          isNTA: this.queryBlocks[i].isNta,
          isMedication: this.queryBlocks[i].isMedication,
          isAllergy: this.queryBlocks[i].isAllergy,
          isImmunization: this.queryBlocks[i].isImmunization,
          isCondition: this.queryBlocks[i].isCondition,
          isObservation: this.queryBlocks[i].isObservation,
          isMedicationSaved: this.queryBlocks[i].isMedicationSaved,
          title: this.queryBlocks[i].title,
          position: this.queryBlocks[i].position,
          ChoosenPromptID: this.queryBlocks[i].choosenPromptID,
          staticTitleForChoosenID: this.queryBlocks[i].staticTitleForChoosenID ? this.queryBlocks[i].staticTitleForChoosenID : this.queryBlocks[i].title,
          systemPromptID: this.queryBlocks[i].systemPromptID != undefined ? this.queryBlocks[i].systemPromptID : 0
        };
        questionQuery.push(obj);
      }
    }

    var deletedQueryCheck = [];
    this.deletedQuery = this.deletedQuery.filter((x: any) => x.nlpTemplateID != 0);
    if (this.deletedQuery.length > 0) {
      for (let i = 0; i < this.deletedQuery.length; i++) {
        deletedQueryCheck.push(this.deletedQuery[i].nlpTemplateID);
      }
    }
    var ReqModel = {
      nlpTemplateID: this.nlpTemplateID,
      templateType: this.categoryType, // For My Template
      categoryID: this.selectedcategoryIDForUpdate,
      queries: questionQuery,
      deleteQueries: deletedQueryCheck,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
    };
    this.spinner = true;
    this.loaderService.show();
    this.formsService.updateNLPTemplate(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.deletedQuery = [];
          this.spinner = false;
          this.loaderService.hide();
          this.toastr.success('Template update successfully.', '', {
            timeOut: 3000,
          });
          this.closeSaveAsTemplateForQuestionTemplate();
        } else {
          this.toastr.error('Template update failed.', '', {
            timeOut: 3000,
          });
          this.spinner = false;
          this.loaderService.hide();
        }
      } else {
        this.toastr.error('Question Template update failed.', '', {
          timeOut: 3000,
        });
        this.spinner = false;
        this.loaderService.hide();
      }
    });
  }

  //========== Import Question Template ============ //

  OpenImportQuestionTemplate(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef, {
      panelClass: 'saveTemplatePopup',
    });
    this.categoryType = 0;
    this.QuestionTemplateIDImportTask = 0;
    this.selectedcategoryIDForQuestion = 0;
    this.currentIndex = 0;
    this.getActiveQuestionTemplateAfterAdd('');
    this.getNLPTemplates();
  }

  officeIdForImportPromptTemp: number = 0;
  organizationIdForImportPromptTemp: number = 0;

  SelectTemplateQuestionTempForImport(data: any) {
    this.officeIdForImportPromptTemp = data.officeID;
    this.organizationIdForImportPromptTemp = data.organizationID;
    this.QuestionTemplateIDImportTask = data.templateID;
  }

  closeImportQuestionTemplate() {
    this.dialog.closeAll();
  }

  getThroughCategoryForQuestionTempImport(e: any, i: any) {
    this.QuestionTemplateIDImportTask = 0;
    this.currentIndex = i;
    this.selectedcategoryIDForQuestion = e;
    this.getNLPTemplates();
  }
  newQuestionsTOUpdate: any = [];

  importQuestionTemplates() {
    var ReqModel = {
      nlpTemplateID: this.QuestionTemplateIDImportTask,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationIdForImportPromptTemp),
      //organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.officeIdForImportPromptTemp,
      //officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
    };
    this.loaderService.show();
    this.formsService.getNLPQueries(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.loaderService.hide();
          if (this.responseHolder.data.length > 0) {
            this.newQuestionsTOUpdate = [];
            this.responseHolder.data.forEach((e: any) => {
              if (e.query != '' || e.systemPromptID > 0) {
                var obj = {
                  nlpTemplateID: 0,
                  askQAquery: e.query,
                  title: e.title,
                  apiResponseTextArea: '',
                  isNta: e.isNTA,
                  isMedication: e.isMedication,
                  isAllergy: e.isAllergy,
                  isCondition: e.isCondition,
                  isImmunization: e.isImmunization,
                  isObservation: e.isObservation,
                  isMedicationSaved: e.isMedicationSaved == undefined ? false : e.isMedicationSaved,
                  position: e.position,
                  choosenAnswer: '',
                  choosenPromptID: e.choosenPromptID == undefined ? "" : e.choosenPromptID,
                  staticTitleForChoosenID: e.staticTitleForChoosenID,
                  isEditing: false,
                  systemPromptID: e.systemPromptID
                };
                let NewQAReqModel = {
                  documentID: this.documentId,
                  promptID: 0, //this.nlpTemplateID,//this.queryBlocks[index].nlpTemplateID,
                  prompt: e.query, //this.queryBlocks[index].askQAquery,
                  reply: '', //this.queryBlocks[index].apiResponseTextArea,
                  title: e.title,
                  userID: this.currentUser.UID,
                  officeID: this.myOfficeID,
                  officeIDList: this.OfficeIDList,
                  organizationID: Number(this.organizationId),
                  databaseID: Number(this.databaseId),
                  isNta: e.isNTA,
                  isMedication: e.isMedication,
                  isAllergy: e.isAllergy,
                  isCondition: e.isCondition,
                  isImmunization: e.isImmunization,
                  isObservation: e.isObservation,
                  isMedicationSaved: e.isMedicationSaved == undefined ? false : e.isMedicationSaved,
                  position: e.position,
                  choosenAnswer: '',
                  choosenPromptID: e.choosenPromptID == undefined ? "" : e.choosenPromptID,
                  staticTitleForChoosenID: e.staticTitleForChoosenID,
                  isEditing: false,
                  systemPromptID: e.systemPromptID
                };
                this.newQuestionsTOUpdate.push(NewQAReqModel);
                this.queryBlocks.push(obj);
              }
            });
            this.addQuestionsListFromTemplate(this.newQuestionsTOUpdate);
          }
          this.toastr.success('Template Import successfully.', '', {
            timeOut: 3000,
          });
          this.closeImportQuestionTemplate();
        } else {
          this.toastr.error('Template Import failed.', '', {
            timeOut: 3000,
          });
          this.loaderService.hide();
        }
      } else {
        this.toastr.error('Template Import failed.', '', {
          timeOut: 3000,
        });
        this.loaderService.hide();
      }
    });
  }

  deleteQuery(block: any, removeIndex: any) {
    this.deletedQuery.push(block);
    if (removeIndex !== -1) this.queryBlocks.splice(removeIndex, 1);
  }

  getDeletedQuery(result: any) {
    var ReqModel = {
      documentID: this.documentId,
      promptID: result[0].nlpTemplateID,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
    };
    this.formsService.removeFileAIPrompts(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (
          this.responseHolder.status == this.statusConst.statusSuccess &&
          this.responseHolder.data != null
        ) {
          this.toastr.success('Query deleted successfully.', '', {
            timeOut: 3000,
          });

          // this.getQueryList(true);
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  getSystemPromptTemplateList() {
    var ReqModel = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: Number(this.myOfficeID),
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId)
    }
    this.loaderService.show();
    this.formsService.GetAllSystemPrompt().subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.sysPromptList = this.responseHolder.data;
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  OnSelectCategoryImportTemp($event: any) {
    this.selectedTemplate = [];
    this.QuestionTemplateIDImportTask = 0;
    //this.selectedTaskCategoryID = 0;
    const textLabel = $event.value;
    const categoryValue = textLabel == 'My Template' ? 0 : textLabel == 'Organization' ? 2 : 1;
    this.categoryType = categoryValue;
    this.getActiveQuestionTemplateAfterAdd('');
    this.getNLPTemplates();
  }

  OnSelectCategoryImportFieldTemp($event: any) {
    this.selectedTemplate = [];
    this.selectedcategoryIDForImportTemp = 0;
    this.TemplateIDImportTask = 0;
    this.currentIndex = 0;
    this.showImportTemplate = true;
    this.updateSelectedField = false;
    //this.selectedTaskCategoryID = 0;
    const textLabel = $event.value;
    const categoryValue = textLabel == 'My Template' ? 0 : textLabel == 'Organization' ? 2 : 1;
    this.categoryType = categoryValue;
    this.getActiveTemplateCategoriesAfterAdd();
    this.getOCRTemplate();
  }

  OnChangeChooseAnswer(e: any, block: any, index: any) {
    if (e.checked) {
      this.choosenPromptID = this.choosenPromptID
        ? this.choosenPromptID + ',' + this.queryBlocks[index].nlpTemplateID
        : this.queryBlocks[index].nlpTemplateID;
    } else {
      let nlpTemplateID = this.queryBlocks[index].nlpTemplateID.toString();

      // Remove the unchecked nlpTemplateID from choosenPromptID
      let currentValue = this.choosenPromptID;

      // Split by commas, filter out the unchecked nlpTemplateID, and join back
      this.choosenPromptID = currentValue
        .split(',')
        .filter((id: any) => id !== nlpTemplateID)
        .join(',');
    }
  }
  formatApiResponse(responseText: any) {
    if (!responseText) {
      return "No data available";
    }

    const trimmedText = responseText.trim();
    let jsonData;

    // Attempt to parse JSON only if it looks like JSON
    if ((trimmedText.startsWith("{") && trimmedText.endsWith("}")) ||
      (trimmedText.startsWith("[") && trimmedText.endsWith("]"))) {
      try {
        jsonData = JSON.parse(trimmedText);
      } catch (e) {
        // Invalid JSON, return as plain text
        return responseText;
      }
    } else {
      // Not JSON, return as plain text
      return responseText;
    }

    // If parsed JSON is an array with items
    if (Array.isArray(jsonData) && jsonData.length > 0) {
      const firstItem = jsonData[0];

      // Allergy array or outliers
      if (firstItem.allergy || firstItem.outliers) {
        return this.formatAllergies(jsonData);
      }


      // Immunization array
      if (firstItem.immunization) {
        return this.formatImmunizations(jsonData);
      }

      // Condition array
      if (firstItem.identifier?.coding) {
        return this.formatConditions(jsonData);
      }

      // Observation array
      if (firstItem.observation || firstItem.category) {
        return this.formatObservations(jsonData);
      }
    }

    // JSON parsed but doesn't match known patterns → return formatted JSON string
    return responseText;
  }

  // Your existing formatting functions (slightly modified for consistency)
  formatAllergies(allergiesJson: any) {
    if (!Array.isArray(allergiesJson)) return "Invalid allergies data";
    if (allergiesJson.length === 0) return "No allergies recorded";
    if (allergiesJson.some(item => item.outliers)) {
      return "No Allergies information is available in the provided document.";
    }
    return allergiesJson.map((item, index) => {
      const allergy = item.allergy;
      if (!allergy) return `${index + 1}. Invalid allergies data`;


      const lines = [
        `${index + 1}. ${allergy.allergen?.display || 'Unknown allergen'}`,
        `   Category: ${allergy.category || 'Unknown'}`,
        `   Type: ${allergy.type || 'Unknown'}`,
        `   Status: ${allergy.clinicalStatus || 'Unknown'}`,
        `   Severity: ${allergy.severity || 'Unknown'}`
      ];

      if (allergy.onsetDate) lines.push(`   Onset Date: ${allergy.onsetDate}`);
      if (allergy.reactionType) {
        let reactionLine = `   Reaction: ${allergy.reactionType}`;
        if (allergy.reactionSubType) reactionLine += ` (${allergy.reactionSubType})`;
        lines.push(reactionLine);
      }
      if (allergy.reactionNote) lines.push(`   Notes: ${allergy.reactionNote}`);

      return lines.join('\n');
    }).join('\n\n');
  }

  formatImmunizations(immunizationsJson: any) {
    if (!Array.isArray(immunizationsJson)) return "Invalid immunizations data";
    if (immunizationsJson.length === 0) return "No immunizations recorded";

    return immunizationsJson.map((item, index) => {
      const immunization = item.immunization;
      if (!immunization) return `${index + 1}. Invalid immunization data`;

      const vaccineName = immunization.immunizationProduct?.coding?.[0]?.display || 'Unknown vaccine';
      const adminDate = immunization.administrationDateTime ?
        new Date(immunization.administrationDateTime).toLocaleDateString() : 'Unknown date';

      const lines = [
        `${index + 1}. ${vaccineName}`,
        `   Administered: ${adminDate}`
      ];

      if (immunization.notes) lines.push(`   Status: ${immunization.notes}`);

      return lines.join('\n');
    }).join('\n\n');
  }

  formatConditions(conditionsJson: any) {
    if (!Array.isArray(conditionsJson)) return "Invalid conditions data";
    if (conditionsJson.length === 0) return "No conditions recorded";

    return conditionsJson.map((item, index) => {
      const conditionName = item.identifier?.coding?.[0]?.display || 'Unknown condition';
      const onsetDate = item.onsetDate ? new Date(item.onsetDate).toLocaleDateString() : 'Unknown onset';

      const lines = [
        `${index + 1}. ${conditionName}`,
        `   Status: ${item.clinicalStatus || 'Unknown'}`,
        `   Type: ${item.rank || 'Unknown'}`
      ];

      if (item.onsetDate) lines.push(`   Onset: ${onsetDate}`);
      if (item.additionalInformation) lines.push(`   Details: ${item.additionalInformation}`);

      return lines.join('\n');
    }).join('\n\n');
  }

  formatObservations(observationsJson: any) {
    if (!Array.isArray(observationsJson)) return "Invalid observations data";
    if (observationsJson.length === 0) return "No observations recorded";

    let formattedText = '';

    observationsJson.forEach((item, index) => {
      if (item.observation && Array.isArray(item.observation)) {
        if (index > 0) formattedText += '\n\n';

        formattedText += `Observation Set ${index + 1}:\n`;

        const observationText = item.observation.map((obs: any, obsIndex: any) => {
          const observationName = obs.identifier?.coding?.[0]?.display || 'Unknown observation';
          const obsDate = obs.effectiveDateTime ?
            new Date(obs.effectiveDateTime).toLocaleDateString() : 'Unknown date';

          const lines = [
            `  ${obsIndex + 1}. ${observationName}`,
            `     Value: ${obs.value || 'N/A'}${obs.unit ? ` ${obs.unit}` : ''}`,
            `     Date: ${obsDate}`
          ];

          if (obs.interpretation) lines.push(`     Interpretation: ${obs.interpretation}`);
          if (obs.category) lines.push(`     Category: ${obs.category}`);
          if (obs.method?.coding?.[0]?.display) lines.push(`     Method: ${obs.method.coding[0].display}`);

          return lines.join('\n');
        }).join('\n\n');

        formattedText += observationText;
      } else if (item.category) {
        // Handle single observation objects
        if (index > 0) formattedText += '\n\n';

        const observationName = item.identifier?.coding?.[0]?.display || 'Unknown observation';
        const obsDate = item.effectiveDateTime ?
          new Date(item.effectiveDateTime).toLocaleDateString() : 'Unknown date';

        const lines = [
          `${index + 1}. ${observationName}`,
          `   Value: ${item.value || 'N/A'}${item.unit ? ` ${item.unit}` : ''}`,
          `   Date: ${obsDate}`
        ];

        if (item.interpretation) lines.push(`   Interpretation: ${item.interpretation}`);
        if (item.category) lines.push(`   Category: ${item.category}`);
        if (item.method?.coding?.[0]?.display) lines.push(`   Method: ${item.method.coding[0].display}`);

        formattedText += lines.join('\n');
      }
    });

    return formattedText || "No valid observations found";
  }


  formatNtaSummary(jsonString: any) {
    try {
      // Attempt to parse the string into a JavaScript object.
      const data = JSON.parse(jsonString);

      // Check for the mandatory keys to ensure it has the correct structure.
      if (!data.summary || !Array.isArray(data.ntaSummary)) {
        throw new Error("Invalid JSON structure");
      }

      // --- Start building the human-readable text ---
      let formattedText = "PDPM NTA Opportunity Summary\n";
      formattedText += "=============================\n\n";

      // Format the main summary section
      const summary = data.summary;
      formattedText += `Overall Summary:\n`;
      formattedText += `  - NTA Points: ${summary.ntaPoints}\n`;
      formattedText += `  - NTA CMG: ${summary.ntaCmg}\n`;
      formattedText += `  - HIPPS Character: ${summary.hippsCharacter}\n`;
      formattedText += `  - NTA CMI: ${summary.ntaCmi}\n`;
      formattedText += `  - Step-Up Potential: ${summary.stepUpPotential}\n`;
      formattedText += `  - Over-Coding Risk: ${summary.overCodingRisk}\n`;
      formattedText += `  - Optimization Score: ${summary.optimizationScore}\n`;
      formattedText += `  - Payer: ${summary.payer}\n\n`;

      formattedText += "Detailed NTA Conditions:\n";
      formattedText += "------------------------\n\n";

      // Loop through each item in the ntaSummary array and format it
      data.ntaSummary.forEach((item: any, index: any) => {
        formattedText += `Item ${index + 1}: ${item.diagnosis || item.ntaCondition}\n`;
        formattedText += `  - Status: ${item.status}\n`;
        if (item.icd10) {
          formattedText += `  - ICD-10 Code: ${item.icd10}\n`;
        }
        if (item.proposed) {
          formattedText += `  - Proposed ICD-10: ${item.proposed}\n`;
        }
        formattedText += `  - NTA Points: ${item.points}\n`;
        if (item.potential) {
          formattedText += `  - Potential Points: ${item.potential}\n`;
        }
        if (item.risk) {
          formattedText += `  - Risk: ${item.risk}\n`;
        }
        formattedText += `\n  - Description: ${item.detailedDescription}\n`;
        formattedText += `  - Evidence Location: ${item.location_in_patient_Document}\n`;
        if (item.step_Up_Reason) {
          formattedText += `  - Step-Up Rationale: ${item.step_Up_Reason}\n`;
        }
        if (item.needed_To_Qualify) {
          formattedText += `  - Action Required: ${item.needed_To_Qualify}\n`;
        }
        formattedText += "\n";
      });

      return formattedText;

    } catch (error) {
      // If parsing fails or the structure is wrong, return the original text.
      return jsonString;
    }
  }


  getQueryList1(result: any) {
    var ReqModel = {
      documentID: this.documentId,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
    };
    this.formsService.getFileAIPrompt(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        this.queryBlocks = [];
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          //  this.queryBlocks=[];
          if (this.responseHolder.data.length > 0) {
            for (let i = 0; i < this.responseHolder.data.length; i++) {
              var obj = {
                nlpTemplateID: this.responseHolder.data[i].promptID,
                askQAquery: this.responseHolder.data[i].prompt,
                apiResponseTextArea: this.responseHolder.data[i].reply,
                apiResponseTextAreaNew: this.responseHolder.data[i].reply
                  .replace(/\n\n/g, '<br><br>')
                  .replace(/\n/g, '<br>'), //this.responseHolder.data[i].reply,
                // apiResponseTextAreaNew: this.responseHolder.data[i].reply.replace(/\[p\.(\d+)]/g, (match, pageNum) => {
                //   return <a href="#/page/${pageNum}" (click)="goToPage(${pageNum})">p.${pageNum}</a>;
                // });
                title: this.responseHolder.data[i].title,
                isNta: this.responseHolder.data[i].isNta,
                isMedication: this.responseHolder.data[i].isMedication,
                isAllergy: this.responseHolder.data[i].isAllergy,
                isCondition: this.responseHolder.data[i].isCondition,
                isImmunization: this.responseHolder.data[i].isImmunization,
                isObservation: this.responseHolder.data[i].isObservation,
                isMedicationSaved: this.responseHolder.data[i].isMedicationSaved,
                position: this.responseHolder.data[i].position,
                choosenAnswer: '',
                choosenPromptID: this.responseHolder.data[i].choosenPromptID,
                staticTitleForChoosenID: this.responseHolder.data[i].staticTitleForChoosenID,
                isEditing: false
              };
              // this.queryBlocks.push(obj);
            }
          } else {
            //this.queryBlocks.push({nlpTemplateID:0, askQAquery: '', apiResponseTextArea: '' ,title:e.title,});
          }
        } else {
          this.queryBlocks = [];
          this.loaderService.hide();
        }
      } else {
        this.queryBlocks = [];
        this.loaderService.hide();
      }
    });
  }

  // isContentProcessed:boolean=false;
  // isFieldProcessed:boolean=false;
  // isPromptProcessed:boolean=false;
  // aiAutomationProcessStatus:number=0;
  // showAIQuestionTickMark:boolean=false;
  // showAIQuestionLoader:string="";

  async getQueryList(result: any) {
    //this.loaderService.show();
    const ReqModel = {
      documentID: this.documentId,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
    };

    try {
      const response = await this.formsService.getFileAIPrompt(ReqModel).toPromise();
      if (response) {
        this.responseHolder = response;
        //this.loaderService.hide();
        this.queryBlocks = [];

        if (this.responseHolder.status === this.statusConst.statusSuccess && this.responseHolder.data) {

          //this.showAIQuestionLoader="";
          //this.currentNavigation = NAVIGATION.QUESTIONS;
          this.isFieldProcessed = this.responseHolder.data.isFieldProcessed;
          this.isPromptProcessed = this.responseHolder.data.isPromptProcessed;
          this.isContentProcessed = this.responseHolder.data.isContentProcessed;
          this.aiAutomationProcessStatus = this.responseHolder.data.aiAutomationProcessStatus;

          if (this.aiAutomationProcessStatus == 1) {
            if (this.isPromptProcessed == true) {
              this.showAIQuestionTickMark = true;
            }
            if (this.isPromptProcessed == false) {
              this.showAIQuestionTickMark = false;
              this.showAIQuestionLoader = "1";
            }
          }
          if (this.aiAutomationProcessStatus == 2) {
            if (this.isPromptProcessed == true) {
              this.showAIQuestionTickMark = true;
            }
          }
          if (this.responseHolder.data.prompts == null) {
            this.responseHolder.data.prompts = [];
          }

          if (this.responseHolder.data.prompts.length > 0) {
            //this.showAIQuestionLoader="";
            for (let i = 0; i < this.responseHolder.data.prompts.length; i++) {
              var text = this.responseHolder.data.prompts[i].isNta == true ? this.formatNtaSummary(this.responseHolder.data.prompts[i].reply) : this.formatApiResponse(this.responseHolder.data.prompts[i].reply);
              const obj = {
                nlpTemplateID: this.responseHolder.data.prompts[i].promptID,
                askQAquery: this.responseHolder.data.prompts[i].prompt,
                apiResponseTextArea: text,
                rawJson: this.responseHolder.data.prompts[i].reply,
                apiResponseTextAreaNew: (text || '').replace(/\n\n/g, '<br><br>').replace(/\n/g, '<br>'),
                // apiResponseTextAreaNew: this.responseHolder.data[i].reply
                //   .replace(/\n\n/g, '<br><br>')
                //   .replace(/\n/g, '<br>'),
                title: this.responseHolder.data.prompts[i].title,
                isNta: this.responseHolder.data.prompts[i].isNta,
                isMedication: this.responseHolder.data.prompts[i].isMedication,
                isAllergy: this.responseHolder.data.prompts[i].isAllergy,
                isCondition: this.responseHolder.data.prompts[i].isCondition,
                isImmunization: this.responseHolder.data.prompts[i].isImmunization,
                isObservation: this.responseHolder.data.prompts[i].isObservation,
                isMedicationSaved: this.responseHolder.data.prompts[i].isMedicationSaved,
                position: this.responseHolder.data.prompts[i].position,
                choosenAnswer: '',
                choosenPromptID: this.responseHolder.data.prompts[i].choosenPromptID,
                staticTitleForChoosenID: this.responseHolder.data.prompts[i].staticTitleForChoosenID,
                isEditing: false,
                systemPromptID: this.responseHolder.data.prompts[i].systemPromptID
              };
              this.queryBlocks.push(obj);
            }
          }
        } else {
          this.queryBlocks = [];
        }
      } else {
        this.queryBlocks = [];
      }
    } catch (error) {
      console.error('Error in getQueryList:', error);
      this.queryBlocks = [];
    } finally {
      //this.loaderService.hide();
    }
  }


  @ViewChild('Input') InputFile: ElementRef;
  selectedFiles: FileList;
  selectedFile: File | null = null;
  fileBytes: Uint8Array | null = null;
  UploadedFiles: any = ([] = []);
  formData: FormData = new FormData();
  ResponseHolderDetails: any;
  IsNew: boolean = false;
  totalPDFPages: number = 0;
  documentNames: string = '';

  openPanelMergePDF(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef, {
      panelClass: 'saveTemplatePopup',
    });
    this.MergedFileHistoryList = [];
    this.UploadedFiles = [];
    this.IsNew = false;
    this.totalPDFPages = this.totalNumberPages;
    this.getMergedFileHistory();
  }

  selectFilesFromDragZone1(event: any) {
    // const input = event.target as HTMLInputElement;
    // if (input.files && input.files.length > 0) {
    //   this.selectedFile = input.files[0];
    // }
    // if (this.selectedFile) {
    //   const reader = new FileReader();
    //   reader.onload = (e: ProgressEvent<FileReader>) => {
    //     if (e.target && e.target.result) {
    //       const arrayBuffer = e.target.result as ArrayBuffer;
    //       this.fileBytes = new Uint8Array(arrayBuffer);
    //       // Here you can send the byte array to your API
    //     }
    //   };
    //   reader.readAsArrayBuffer(this.selectedFile);
    // }
    // this.selectedFiles = event.target.files;
    // for (let i = 0; i < this.selectedFiles.length; i++) {
    //   var ext = this.selectedFiles[i].name.split('.').pop();
    //   if (ext.toLowerCase() != 'pdf') {
    //     this.toastr.warning('please select only pdf file', '', {
    //       timeOut: 3000,
    //     });
    //     return;
    //   }
    //   const file = event.target.files[i];
    //   const reader = new FileReader();
    //   reader.readAsDataURL(file);
    //   reader.onload = () => {
    //     var FullPath = this.selectedFiles[i].name;
    //     var documentNameSplit = FullPath.split('.');
    //     var documentName = documentNameSplit[0];
    //     // var documenttype = documentNameSplit[1];
    //     var documenttype = this.selectedFiles[i].name.split('.').pop();
    //     var isCompressed = false;
    //     var dynamicDocumentId = 0;
    //     // var size = this.selectedFiles[i].size;
    //     // documentName = documentName.substring(0, 30);//get first 30 chars
    //     var base64String = reader.result;
    //    // var size = this.getReadableFileSizeString(this.selectedFiles[i].size);
    //     const checksizeFor1MB = Math.round((this.selectedFiles[i].size / 1024));
    //     // The size of the file.
    //     if (checksizeFor1MB >= 1024) {
    //       isCompressed = true;
    //       dynamicDocumentId = Math.floor(1000 + Math.random() * 9000);
    //     } else {
    //       isCompressed = false;
    //       dynamicDocumentId = 0;
    //     }
    //   };
    // }
  }

  selectFilesFromDragZone(event: any) {
    this.selectedFiles = event.target.files;

    for (let i = 0; i < this.selectedFiles.length; i++) {
      var ext = this.selectedFiles[i].name.split('.').pop();
      if (ext.toLowerCase() != 'pdf') {
        this.toastr.warning('Only PDF are allowed', '', {
          timeOut: 3000,
        });
        return;
      }

      const file = event.target.files[i];
      const files = event.target.files[i];

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        var FullPath = this.selectedFiles[i].name;
        var documentNameSplit = FullPath.split('.');
        var documentName = documentNameSplit[0];
        // var documenttype = documentNameSplit[1];
        var documenttype = this.selectedFiles[i].name.split('.').pop();
        // const typedArray = new Uint8Array(reader.result as ArrayBuffer);
        //var base64String = reader.result;
        var size = this.getReadableFileSizeString(this.selectedFiles[i].size);
        // var count = reader.result.match(/\/Type[\s]*\/Page[^s]/g).length;

        var ReqModel = {
          id: this.randomId(),
          fileName: documentName,
          // progress: 0,
          //  base64: base64String,
          documentType: documenttype,
          //action: 0,
          //isDeleted: false,
          //projectDocumeaddQuestionsntID: 0,
          file: this.selectedFiles[i],
          Totalsize: size,
          pageCount: 0,
        };
        this.UploadedFiles.push(ReqModel);

        if (files) {
          const fileReader = new FileReader();
          fileReader.onload = (e) => {
            const typedArray = new Uint8Array(fileReader.result as ArrayBuffer);
            this.loadPdf(typedArray, ReqModel.id);
          };
          fileReader.readAsArrayBuffer(file);
        }
      };
    }
  }

  async loadPdf(data: Uint8Array, id: any): Promise<void> {
    const pdf = await (window as any).pdfjsLib.getDocument(data).promise;
    var totalUploadedPages = pdf.numPages;
    this.UploadedFiles.find((item: any) => item.id == id).pageCount =
      totalUploadedPages;
    this.totalPDFPages += totalUploadedPages;
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(
      this.UploadedFiles,
      event.previousIndex,
      event.currentIndex
    );
  }

  getReadableFileSizeString(fileSizeInBytes: any) {
    var i = -1;
    var byteUnits = [' KB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB'];
    do {
      fileSizeInBytes = fileSizeInBytes / 1024;
      i++;
    } while (fileSizeInBytes > 1024);

    return Math.max(fileSizeInBytes).toFixed(3) + byteUnits[i];
  }

  deleteFileFromUploaded(file: any, removeIndex: any) {
    if (removeIndex !== -1) this.UploadedFiles.splice(removeIndex, 1);
    this.totalPDFPages -= file.pageCount;
  }

  closeMergPDF() {
    this.MergedFileHistoryList = [];
    this.UploadedFiles = [];
    this.dialog.closeAll();
  }


  async mergePdf() {

    this.formData = new FormData();

    const maxFileSize = 20 * 1024 * 1024; // 20 MB
    let isNewFile = '';

    if (this.IsNew) {

      isNewFile = 'true';

      if (!this.documentNames || this.documentNames.trim() === '') {
        this.toastr.warning(
          'Please add document name.',
          '',
          { timeOut: 3000 }
        );
        return;
      }

    } else {

      isNewFile = 'false';
      this.documentNames = this.documentName;

    }

    this.loaderService.show();

    try {

      // ======================================================
      // VALIDATE & CLEAN FILES
      // ======================================================
      const cleanedFiles: any[] = [];

      for (let i = 0; i < this.UploadedFiles.length; i++) {

        const file = this.UploadedFiles[i].file;

        if (!file) {
          continue;
        }

        // ======================================================
        // FILE SIZE VALIDATION
        // ======================================================
        if (file.size > maxFileSize) {

          const sizeInMB = (file.size / (1024 * 1024)).toFixed(2);

          this.toastr.warning(
            `"${file.name}" is ${sizeInMB} MB. Maximum allowed file size is 20 MB.`,
            '',
            {
              timeOut: 9000
            }
          );

          return;
        }

        // ======================================================
        // PDF PASSWORD VALIDATION
        // ======================================================
        if (file.type === 'application/pdf') {

          const isPasswordProtected = await new Promise<boolean>((resolve) => {

            const reader = new FileReader();

            reader.onload = (e: any) => {

              try {

                const uint8Array = new Uint8Array(e.target.result);

                // Convert PDF binary to text
                const pdfText = new TextDecoder().decode(uint8Array);

                // Detect encryption
                resolve(pdfText.includes('/Encrypt'));

              } catch {

                resolve(false);

              }
            };

            reader.onerror = () => resolve(false);

            reader.readAsArrayBuffer(file);
          });

          if (isPasswordProtected) {

            this.toastr.warning(
              `"${file.name}" is password protected and cannot be processed. Please upload a new file without a password.`,
              '',
              {
                timeOut: 9000
              }
            );

            return;
          }
        }

        // ======================================================
        // FILE NAME VALIDATION
        // ======================================================
        const originalFileName = file.name;

        const lastDotIndex = originalFileName.lastIndexOf('.');

        if (lastDotIndex === -1) {

          this.toastr.warning(
            `Invalid file format: "${originalFileName}".`,
            '',
            {
              timeOut: 3000
            }
          );

          return;
        }

        let nameWithoutExt = originalFileName.substring(0, lastDotIndex);
        const extension = originalFileName.substring(lastDotIndex + 1).toLowerCase();

        const invalidCharsRegex = /[ #?%+&:;@="<>\\|^`{}\[\]]/g;

        let cleanedName = nameWithoutExt.replace(invalidCharsRegex, '');

        // Remove spaces
        cleanedName = cleanedName.replace(/\s+/g, '');

        if (!cleanedName) {

          this.toastr.warning(
            `Invalid file name after cleanup: "${originalFileName}".`,
            '',
            {
              timeOut: 3000
            }
          );

          return;
        }

        if (cleanedName.length > 120) {

          this.toastr.warning(
            'File name upto 120 characters only supported, please rename file.',
            '',
            {
              timeOut: 3000
            }
          );

          return;
        }

        // ======================================================
        // CREATE CLEAN FILE
        // ======================================================
        const cleanedFile = new File(
          [file],
          `${cleanedName}.${extension}`,
          {
            type: file.type
          }
        );

        cleanedFiles.push({
          file: cleanedFile,
          documentName: cleanedName,
          documenttype: extension
        });
      }

      // ======================================================
      // APPEND FILES
      // ======================================================
      cleanedFiles.forEach(file => {

        this.formData.append('Files', file.file);

        this.formData.append(
          'FileDetailList',
          `${file.documentName}|${file.documenttype}`
        );

      });

      // ======================================================
      // OTHER PARAMETERS
      // ======================================================
      this.formData.append(
        'FolderID',
        this.parentIDForAddFiles || '0'
      );

      this.formData.append('FileManagerID', this.documentId);
      this.formData.append('FilePath', this.pdfURL);
      this.formData.append('FileName', this.documentNames);
      this.formData.append('IsNew', isNewFile);
      this.formData.append('UserID', this.currentUser.UID);
      this.formData.append('OrganizationID', this.organizationId);
      this.formData.append('OfficeID', this.myOfficeID);
      this.formData.append('DatabaseID', this.databaseId);

      // ======================================================
      // API CALL
      // ======================================================
      this.formsService.mergePdfFiles(this.formData).subscribe({

        next: (response: any) => {

          if (response) {

            this.ResponseHolderDetails = response;

            if (this.ResponseHolderDetails.status === this.statusConst.statusSuccess) {

              this.toastr.success(
                'File merged successfully.',
                '',
                {
                  timeOut: 3000
                }
              );

              if (this.ResponseHolderDetails.data.fileManagerItemID > 0) {
                this.documentId = this.ResponseHolderDetails.data.fileManagerItemID;
              }

              if (this.ResponseHolderDetails.data.mergedFilePath) {
                this.pdfURL = this.ResponseHolderDetails.data.mergedFilePath;
                this.documentPath = this.ResponseHolderDetails.data.mergedFilePath;
              }

              this.closeMergPDF();
              this.fetchnew();

            } else {

              this.toastr.error(
                'File merge failed.',
                '',
                {
                  timeOut: 3000
                }
              );
            }
          }
        },

        error: () => {

          this.toastr.error(
            'Something went wrong while merging files.',
            '',
            {
              timeOut: 3000
            }
          );
        },

        complete: () => {
          this.loaderService.hide();
        }

      });

    } catch {

      this.toastr.error(
        'Unable to process the selected files.',
        '',
        {
          timeOut: 3000
        }
      );

      this.loaderService.hide();
    }
  }

  // async mergePdf() {
  //   this.formData = new FormData();
  //   let isNewFile: string = '';

  //   if (this.IsNew == true) {
  //     isNewFile = 'true';
  //     if (this.documentNames == '') {
  //       this.toastr.warning('Please add document name.', '', { timeOut: 3000 });
  //       return;
  //     }
  //   } else {
  //     isNewFile = 'false';
  //     this.documentNames = this.documentName;
  //   }

  //   //  STEP 1: Validate + Clean Files
  //   let cleanedFiles: any[] = [];

  //   for (let i = 0; i < this.UploadedFiles.length; i++) {
  //     let file = this.UploadedFiles[i].file;

  //     if (!file) continue;
  //     this.loaderService.show();

  //     //  PASSWORD CHECK
  //     if (file.type === 'application/pdf') {
  //       try {
  //         const pdfCheck = await this.checkpdfPasswordProtected(file).toPromise();

  //         if (!pdfCheck?.data) {
  //           this.toastr.warning(
  //             `"${file.name}" is password protected and cannot be processed. Please upload a new file without a password.`,
  //             '',
  //             { timeOut: 7000 }
  //           );
  //           this.loaderService.hide();
  //           return;
  //         }
  //       } catch (err) {
  //         this.toastr.warning(
  //                 '<b>Almost There — Your File Is Still Over 5MB</b><br/><br/>' +
  //                 'We ran a compression, but the document is still over the upload limit.<br/><br/>' +
  //                 '<a href="https://smallpdf.com/compress-pdf" target="_blank" style="color:#fff; text-decoration:underline;">Click here to compress your file</a><br/><br/>' +
  //                 '1) Choose "Basic Compression"<br/>' +
  //                 '2) Re-upload it here',
  //                 '',
  //                 { timeOut: 10000, enableHtml: true }
  //               );
  //         this.loaderService.hide();
  //         return;
  //       }
  //     }

  //     //  FILE NAME CLEANING
  //     const originalFileName = file.name;
  //     const lastDotIndex = originalFileName.lastIndexOf('.');

  //     if (lastDotIndex === -1) {
  //       this.toastr.warning(`Invalid file format: "${originalFileName}".`, '', { timeOut: 3000 });
  //       this.loaderService.hide();
  //       return;
  //     }

  //     let nameWithoutExt = originalFileName.substring(0, lastDotIndex);
  //     let extension = originalFileName.substring(lastDotIndex + 1).toLowerCase();

  //     //  Remove special characters
  //     const invalidCharsRegex = /[ #?%+&:;@="<>\\|^`{}\[\]]/g;
  //     let cleanedName = nameWithoutExt.replace(invalidCharsRegex, '');
  //     // Remove spaces
  //     cleanedName = cleanedName.replace(/\s+/g, '');
  //     // //  Format name
  //     // cleanedName = cleanedName.replace(/\s+/g, '_').trim();
  //     // cleanedName = cleanedName.replace(/_+/g, '_');
  //     // cleanedName = cleanedName.replace(/^_+|_+$/g, '');

  //     if (!cleanedName) {
  //       this.toastr.warning(`Invalid file name after cleanup: "${originalFileName}".`, '', { timeOut: 3000 });
  //       this.loaderService.hide();
  //       return;
  //     }

  //     if (cleanedName.length > 120) {
  //       this.toastr.warning(
  //         'File name upto 120 characters only supported, please rename file.',
  //         '',
  //         { timeOut: 3000 }
  //       );
  //       this.loaderService.hide();
  //       return;
  //     }

  //     //  Create cleaned file
  //     let cleanedFile = new File([file], `${cleanedName}.${extension}`, {
  //       type: file.type
  //     });

  //     cleanedFiles.push({
  //       file: cleanedFile,
  //       documentName: cleanedName,
  //       documenttype: extension
  //     });
  //   }

  //   //  STEP 2: Append cleaned files
  //   for (let i = 0; i < cleanedFiles.length; i++) {
  //     this.formData.append('Files', cleanedFiles[i].file);
  //     this.formData.append('FileDetailList', cleanedFiles[i].documentName + '|' + cleanedFiles[i].documenttype);
  //   }

  //   //  STEP 3: Append other data
  //   if (!this.parentIDForAddFiles) {
  //     this.parentIDForAddFiles = "0";
  //   }

  //   this.formData.append('FolderID', this.parentIDForAddFiles);
  //   this.formData.append('FileManagerID', this.documentId);
  //   this.formData.append('FilePath', this.pdfURL);
  //   this.formData.append('FileName', this.documentNames);
  //   this.formData.append('IsNew', isNewFile);
  //   this.formData.append('UserID', this.currentUser.UID);
  //   this.formData.append('OrganizationID', this.organizationId);
  //   this.formData.append('OfficeID', this.myOfficeID);
  //   this.formData.append('DatabaseID', this.databaseId);

  //   this.loaderService.show();

  //   //  STEP 4: API Call
  //   this.formsService.mergePdfFiles(this.formData).subscribe({
  //     next: (response) => {
  //       this.loaderService.hide();

  //       if (response) {
  //         this.ResponseHolderDetails = response;

  //         if (this.ResponseHolderDetails.status == this.statusConst.statusSuccess) {
  //           this.toastr.success('File Merged successfully.', '', { timeOut: 3000 });

  //           if (this.ResponseHolderDetails.data.fileManagerItemID > 0) {
  //             this.documentId = this.ResponseHolderDetails.data.fileManagerItemID;
  //           }

  //           if (this.ResponseHolderDetails.data.mergedFilePath) {
  //             this.pdfURL = this.ResponseHolderDetails.data.mergedFilePath;
  //             this.documentPath = this.ResponseHolderDetails.data.mergedFilePath;
  //           }

  //           this.closeMergPDF();
  //           this.fetchnew();
  //         }
  //       }
  //     },
  //     error: () => {
  //       this.loaderService.hide();
  //       this.toastr.error('Something went wrong while merging files.', '', {
  //         timeOut: 3000
  //       });
  //     }
  //   });
  // }


  checkpdfPasswordProtected(file: File): Observable<any> {
    const reader = new FileReader();
    return new Observable(observer => {
      reader.onload = () => {
        const arrayBuffer = reader.result as ArrayBuffer;
        const byteArray = Array.from(new Uint8Array(arrayBuffer));
        this.formsService.canThisPdfOpenforModifyByBytes(byteArray).subscribe({
          next: (res) => {
            observer.next(res);
            observer.complete();
          },
          error: (err) => observer.error(err)
        });
      };

      reader.onerror = (err) => observer.error(err);

      reader.readAsArrayBuffer(file);
    });
  }


  // mergePdf() {
  //   this.formData = new FormData();
  //   var isNewFile: string = '';
  //   if (this.IsNew == true) {
  //     isNewFile = 'true';
  //     if (this.documentNames == '') {
  //       this.toastr.warning('Please add document name.', '', {
  //         timeOut: 3000,
  //       });
  //       return;
  //     }
  //   }
  //   if (this.IsNew == false) {
  //     isNewFile = 'false';
  //     this.documentNames = this.documentName;
  //   }

  //   for (let i = 0; i < this.UploadedFiles.length; i++) {
  //     if (this.UploadedFiles[i].file !== '') {
  //       var documenttype = "";
  //       var documentName = "";
  //       var FullPath = this.UploadedFiles[i].file.name;
  //       var newfilename = FullPath.replace(/(_\d+(\.\d+)*|\.\d+)+(?=\.pdf$)/g, '');
  //       var documentNameSplit = newfilename.split('.');
  //       documentName = documentNameSplit[0];
  //       documenttype = documentNameSplit[1];

  //       this.formData.append('Files', this.UploadedFiles[i].file);
  //       this.formData.append('FileDetailList', documentName + '|' + documenttype);
  //     }
  //   }
  //   if (this.parentIDForAddFiles == undefined) {
  //     this.parentIDForAddFiles = "0";
  //   }
  //   this.formData.append('FolderID', this.parentIDForAddFiles);
  //   this.formData.append('FileManagerID', this.documentId);
  //   this.formData.append('FilePath', this.pdfURL);
  //   this.formData.append('FileName', this.documentNames);
  //   this.formData.append('IsNew', isNewFile);
  //   this.formData.append('UserID', this.currentUser.UID);
  //   this.formData.append('OrganizationID', this.organizationId);
  //   this.formData.append('OfficeID', this.myOfficeID);
  //   this.formData.append('DatabaseID', this.databaseId);
  //   this.loaderService.show();
  //   this.formsService.mergePdfFiles(this.formData).subscribe((response) => {
  //     if (response != undefined) {
  //       this.loaderService.hide();
  //       this.ResponseHolderDetails = response;
  //       if (
  //         this.ResponseHolderDetails.status == this.statusConst.statusSuccess
  //       ) {
  //         this.toastr.success('File Merged successfully.', '', {
  //           timeOut: 3000,
  //         });
  //         if (this.ResponseHolderDetails.data.fileManagerItemID > 0) {
  //           this.documentId = this.ResponseHolderDetails.data.fileManagerItemID;
  //         }
  //         if (this.ResponseHolderDetails.data.mergedFilePath != null) {
  //           this.pdfURL = this.ResponseHolderDetails.data.mergedFilePath;
  //           this.documentPath = this.ResponseHolderDetails.data.mergedFilePath;
  //         }
  //         this.loaderService.hide();
  //         this.closeMergPDF();
  //         this.fetchnew();
  //       } else {
  //         this.loaderService.hide();
  //       }
  //     } else {
  //       this.loaderService.hide();
  //     }
  //   });
  // }

  async fetchnew(): Promise<void> {
    await this.loadPdfJs(
      'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.10.377/pdf.min.js'
    );
  }

  isNewToggle(event: any) {
    if (event.checked == true) {
      this.IsNew = true;
      this.documentNames = this.documentName + '_new';
    }
    if (event.checked == false) {
      this.IsNew = false;
      this.documentNames = this.documentName;
    }
  }

  //============= Import Forms =============//

  menuHeader: any = ([] = []);
  activeNode: string = '';
  hierarchyList: any;
  breadCrumMenu: any = ([] = []);
  FormsubFolderFolderList: any;
  FormFolderListMiddleSection: any = ([] = []);
  FormFolderList: any = ([] = []);
  SharedWithMeactive: boolean = false;
  SharedWithMeMyDriveactive: boolean = false;
  selectButtonShow: boolean = false;
  isShowForm: any = true;
  isSharedWithMe: any = false;
  isShowMyDrive: any = false;
  isSharedWithMeMyDrive: any = false;
  menuHeaderMyDrive: any = ([] = []);
  parentID: number = 0;
  SharedWithMeFormFolderList: any = ([] = []);
  TypeId: number = 0;
  PlaceholderNameFound: boolean = false;
  PlaceholderName: string = '';
  PlaceholderID: string = '';
  FormID: number = 0;
  projectGroups: any = ([] = []);
  ProjectIdForEdit: string = '';

  selectForm(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef, {
      panelClass: 'selectTemplate',
    });
    this.FormID = 0;
    this.activeNode = '';
    this.dataSource.data = [];
    this.selectButtonShow = false;
    this.isShowForm = true;
    this.isSharedWithMe = false;
    this.SharedWithMeactive = false;
    this.menuHeaderMyDrive = [];
    this.menuHeader = [];
    this.getFormFolderListLeftPanel();
    this.getFormFolderListMiddlePanel();
  }

  closeFormImports() {
    // For Import Template //
    this.menuHeader = [];
    this.FormFolderListMiddleSection = [];
    this.FormFolderList = [];
    this.activeNode = '';
    this.SharedWithMeactive = false;
    this.selectButtonShow = false;
    this.dialog.closeAll();
  }

  GetAllForms() {
    this.activeNode = '';
    this.dataSource.data = [];
    this.selectButtonShow = false;
    this.isShowForm = true;
    this.isSharedWithMe = false;
    this.isShowMyDrive = false;
    this.isSharedWithMeMyDrive = false;
    this.SharedWithMeactive = false;
    this.menuHeader = [];
    this.menuHeaderMyDrive = [];
    this.getFormFolderListLeftPanel();
    this.getFormFolderListMiddlePanel();
  }

  // ======= Middle Panel FormFolderList Quick Form and Import Form ========//

  getFormFolderListLeftPanel() {
    var ReqModel = {
      formFolderID: 0,
      formFolderName: '',
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      OfficeID: this.myOfficeID,
      databaseID: Number(this.databaseId),
    };
    this.loaderService.show();
    this.formsService.getFormFolderList(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (
          this.responseHolder.status == this.statusConst.statusSuccess &&
          this.responseHolder.data != null
        ) {
          this.FormFolderList = this.responseHolder.data;
          if (this.FormFolderList.length > 0) {
            this.dataSource.data = this.FormFolderList;
          }
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  getFormFolderListMiddlePanel() {
    var ReqModel = {
      formFolderID: 0,
      formFolderName: '',
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      OfficeID: this.myOfficeID,
      databaseID: Number(this.databaseId),
    };
    this.formsService
      .getFormFolderWithFormTemplates(ReqModel)
      .subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (
            this.responseHolder.status == this.statusConst.statusSuccess &&
            this.responseHolder.data != null
          ) {
            this.FormFolderListMiddleSection = this.responseHolder.data;
            this.FormFolderListMiddleSection.forEach((e: any) => {
              e.isChecked = false;
            });
          } else {
          }
        } else {
        }
      });
  }

  // ======= Left Panel FormFolderList Quick Form and Import Form ========//

  getFormFolderWithTemplatesLeftPanel(form: any) {
    this.selectButtonShow = false;
    this.activeNode = form.formFolderID;
    var ReqModel = {
      formFolderID: form.formFolderID,
      formFolderName: '',
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      OfficeID: this.myOfficeID,
      databaseID: Number(this.databaseId),
    };
    this.formsService
      .getFormFolderWithFormTemplates(ReqModel)
      .subscribe((res) => {
        if (res != undefined) {
          this.responseHolder = res;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.FormsubFolderFolderList = this.responseHolder.data;
            this.formsService
              .GetParentFormFolderHierarchy(ReqModel)
              .subscribe((response) => {
                if (response != undefined) {
                  if (response.status == this.statusConst.statusSuccess) {
                    this.hierarchyList = response.data.hierarchy;
                    if (
                      this.hierarchyList == null ||
                      this.hierarchyList == undefined
                    ) {
                      this.breadCrumMenu = [];
                      this.menuHeader = this.breadCrumMenu;
                      this.FormFolderListMiddleSection =
                        this.FormsubFolderFolderList;
                      this.parentID = form.parentID;
                    } else {
                      this.breadCrumMenu = [];
                      this.hierarchyList.forEach((e: any) => {
                        this.breadCrumMenu.push({
                          label: e.formFolderName,
                          id: e.formFolderID,
                          icon: 'navigate_next',
                        });
                      });
                      this.menuHeader = this.breadCrumMenu;
                      this.FormFolderListMiddleSection =
                        this.FormsubFolderFolderList;
                      this.parentID = form.parentID;
                      this.isShowForm = true;
                      this.isSharedWithMe = false;
                      this.SharedWithMeactive = false;
                    }
                  }
                }
              });
          } else {
          }
        } else {
        }
      });
  }

  breadCrumb(menu: any, index: any) {
    this.menuHeader.splice(index + 1, this.menuHeader.length - 1);
    if (menu[index] && menu[index].items && menu[index].items.length) {
      this.FormFolderList = menu[index].items;
    }
    var data = this.menuHeader[index];
    this.getformnavigate(data);
    this.selectButtonShow = false;
    this.parentID = data.id;
  }

  getformnavigate(form: any) {
    this.selectButtonShow = false;
    this.activeNode = form.id;
    var ReqModel = {
      formFolderID: form.id,
      formFolderName: '',
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      OfficeID: this.myOfficeID,
      databaseID: Number(this.databaseId),
    };
    this.formsService
      .getFormFolderWithFormTemplates(ReqModel)
      .subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.FormFolderListMiddleSection = this.responseHolder.data;
          } else {
          }
        } else {
        }
      });
  }

  breadCrumbMainClick() {
    this.FormFolderListMiddleSection = [];
    this.getFormFolderListMiddlePanel();
    this.menuHeader = [];
    this.TypeId = 0;
    this.parentID = 0;
    this.selectButtonShow = false;
    this.activeNode = '';
  }

  radioChange(form: any, FormOrShared: any) {
    if (FormOrShared == 'SharedWithMe') {
      this.activeNode = '';
      this.SharedWithMeFormFolderList.forEach((e: any) => {
        e.isChecked = false;
      });
    }
    if (FormOrShared == 'MyForm') {
      this.FormFolderListMiddleSection.forEach((e: any) => {
        e.isChecked = false;
      });
    }

    if (form.type == 1 && FormOrShared == 'MyForm') {
      this.selectButtonShow = false;
      this.getform(form, FormOrShared);
    }

    if (form.type == 2) {
      if (this.PlaceholderNameFound == true) {
        this.PlaceholderName = form.name;
        if (this.PlaceholderID == undefined) this.PlaceholderID = '0';
      }
      this.FormID = form.id;
      this.selectButtonShow = true;
      if (FormOrShared == 'MyForm') {
        this.FormFolderListMiddleSection.forEach((e: any) => {
          if (e.id == form.id) {
            e.isChecked = true;
          }
        });
      }
      if (FormOrShared == 'SharedWithMe') {
        this.SharedWithMeFormFolderList.forEach((e: any) => {
          if (e.id == form.id) {
            e.isChecked = true;
          }
        });
      }
    }
  }

  getform(form: any, FormOrSharedWithMe: any) {
    if (FormOrSharedWithMe == 'MyForm') {
      this.activeNode = form.id;
    }
    if (FormOrSharedWithMe == 'SharedWithMe') {
      this.activeNode = '';
    }
    this.TypeId = form.type;
    var type = form.type;
    //{ 1- Folder, 2- Form}
    if (type == 1) {
      var ReqModel = {
        formFolderID: form.id,
        formFolderName: '',
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        OfficeID: this.myOfficeID,
        databaseID: Number(this.databaseId),
      };
      this.formsService
        .getFormFolderWithFormTemplates(ReqModel)
        .subscribe((response) => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.FormFolderListMiddleSection = this.responseHolder.data;
              this.parentID = form.id;

              this.menuHeader.push({
                label: form.name,
                id: form.id,
                icon: 'navigate_next',
              });

              this.menuHeader = this.menuHeader.filter(
                (thing: any, i: any, arr: any) => arr.findIndex((t: any) => t.id === thing.id) === i
              );
            } else {
            }
          } else {
          }
        });
    } else {
    }
  }

  getIsFavorite(isFavorite: any) {
    isFavorite = isFavorite.isFavorite;
    return isFavorite;
  }

  // =========== For Shared with me  =========//

  getSharedWithMe() {
    var ReqModel = {
      formFolderID: 0,
      formFolderName: '',
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      OfficeID: this.myOfficeID,
      databaseID: Number(this.databaseId),
    };
    this.formsService
      .getFormFolderSharedWithMeList(ReqModel)
      .subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (
            this.responseHolder.status == this.statusConst.statusSuccess &&
            this.responseHolder.data != null
          ) {
            this.SharedWithMeFormFolderList = this.responseHolder.data;
            if (this.SharedWithMeFormFolderList == null) {
              this.SharedWithMeFormFolderList = [];
            }
            this.SharedWithMeFormFolderList.forEach((e: any) => {
              e.isChecked = false;
            });
            if (this.SharedWithMeFormFolderList != null) {
              this.SharedWithMeFormFolderList.map((res: any) => {
                if (res.sharedbyFirstName != null) {
                  res.sharedbyFirstName = this.encryptionAlgo.get(
                    this.reusableClass.decryptionKey,
                    res.sharedbyFirstName
                  );
                }
                if (res.sharedbyLastName != null) {
                  res.sharedbyLastName = this.encryptionAlgo.get(
                    this.reusableClass.decryptionKey,
                    res.sharedbyLastName
                  );
                }
                return res;
              });
            }

            this.selectButtonShow = false;
            this.isShowForm = false;
            this.isSharedWithMe = true;
            this.SharedWithMeactive = true;
            this.SharedWithMeMyDriveactive = false;
            this.isShowMyDrive = false;
            this.isSharedWithMeMyDrive = false;
            this.activeNode = '';
            this.menuHeader = [];
            this.parentID = 0;
          } else {
            this.SharedWithMeFormFolderList = [];
            this.selectButtonShow = false;
            this.isShowForm = false;
            this.isSharedWithMe = true;
            this.SharedWithMeactive = true;
            this.SharedWithMeMyDriveactive = false;
            this.isShowMyDrive = false;
            this.isSharedWithMeMyDrive = false;
            this.activeNode = '';
            this.menuHeader = [];
            this.parentID = 0;
          }
        } else {
        }
      });
  }

  breadCrumbMainSHaredWithMeClick() {
    this.selectButtonShow = false;
    this.getSharedWithMe();
    this.menuHeader = [];
    this.parentID = 0;
  }

  getFormFolderWithFormTemplatesSharedWithMe(form: any) {
    this.TypeId = form.type;
    var type = form.type;
    //{ 1- Folder, 2- Form}
    if (type == 1) {
      var ReqModel = {
        formFolderID: form.id,
        formFolderName: '',
        permissionType: form.permissionType,
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        OfficeID: this.myOfficeID,
        databaseID: Number(this.databaseId),
      };
      this.formsService
        .getFormFolderWithFormTemplatesSharedWithMe(ReqModel)
        .subscribe((response) => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.SharedWithMeFormFolderList = this.responseHolder.data;
              if (this.SharedWithMeFormFolderList == null) {
                this.SharedWithMeFormFolderList = [];
              }
              if (this.SharedWithMeFormFolderList != null) {
                this.SharedWithMeFormFolderList.map((res: any) => {
                  if (res.sharedbyFirstName != null) {
                    res.sharedbyFirstName = this.encryptionAlgo.get(
                      this.reusableClass.decryptionKey,
                      res.sharedbyFirstName
                    );
                  }
                  if (res.sharedbyLastName != null) {
                    res.sharedbyLastName = this.encryptionAlgo.get(
                      this.reusableClass.decryptionKey,
                      res.sharedbyLastName
                    );
                  }
                  return res;
                });
              }
              this.parentID = form.id;
              this.menuHeader.push({
                label: form.name,
                id: form.id,
                icon: 'navigate_next',
                permissionType: form.permissionType,
              });

              this.menuHeader = this.menuHeader.filter(
                (thing: any, i: any, arr: any) => arr.findIndex((t: any) => t.id === thing.id) === i
              );
            } else {
            }
          } else {
          }
        });
    } else {
    }
  }

  SelectFormSubmit() {
    // return;
    if (this.transactionID > 0) {
      //== For Core====//
      if (this.typeForAddCategory == 1) {
        this.AddCreateProjectforPlaceholderForCore();
      }
      //== For Contact====//
      if (this.typeForAddCategory == 2) {
        this.AddCreateProjectforPlaceholderForContact();
      }
      //== For Company====//
      if (this.typeForAddCategory == 3) {
        this.AddCreateProjectforPlaceholderForCompany();
      }
    } else {
      this.UseFormsTemplateForProject();
    }
  }

  AddCreateProjectforPlaceholderForCore() {
    var ReqModel = {
      transactionID: this.transactionID,
      documentFolderID: 0,
      formID: this.FormID,
      fileID: this.documentId,
      formType: FormAuditType.NormalForm,
      placeholderID: 0,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      OfficeID: this.myOfficeID,
      taskID: 0,
    };
    this.loaderService.show();
    this.formsService
      .AddCreateProjectforPlaceholderCore(ReqModel)
      .subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          this.loaderService.hide();
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            if (this.responseHolder.data.projectID > 0) {
              this.ProjectIdForEdit = this.responseHolder.data.projectID;
              this.openProject();
            }
          } else {
            this.loaderService.hide();
            this.dialog.closeAll();
          }
        } else {
          this.loaderService.hide();
          this.dialog.closeAll();
        }
      });
  }

  AddCreateProjectforPlaceholderForContact() {
    var ReqModel = {
      transactionID: this.transactionID,
      documentFolderID: 0,
      formID: this.FormID,
      fileID: this.documentId,
      formType: FormAuditType.NormalForm,
      placeholderID: 0,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      OfficeID: this.myOfficeID,
      taskID: 0,
    };
    this.loaderService.show();
    this.formsService
      .AddCreateProjectforPlaceholderContact(ReqModel)
      .subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          this.loaderService.hide();
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            if (this.responseHolder.data.projectID > 0) {
              this.ProjectIdForEdit = this.responseHolder.data.projectID;
              this.openProject();
            }
          } else {
            this.loaderService.hide();
            this.dialog.closeAll();
          }
        } else {
          this.loaderService.hide();
          this.dialog.closeAll();
        }
      });
  }

  AddCreateProjectforPlaceholderForCompany() {
    var ReqModel = {
      transactionID: this.transactionID,
      documentFolderID: 0,
      formID: this.FormID,
      fileID: this.documentId,
      formType: FormAuditType.NormalForm,
      placeholderID: 0,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      OfficeID: this.myOfficeID,
      taskID: 0,
    };
    this.loaderService.show();
    this.formsService.AddCreateProjectforPlaceholderCompany(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          if (this.responseHolder.data.projectID > 0) {
            this.ProjectIdForEdit = this.responseHolder.data.projectID;
            this.openProject();
          }
        } else {
          this.loaderService.hide();
          this.dialog.closeAll();
        }
      } else {
        this.loaderService.hide();
        this.dialog.closeAll();
      }
    });
  }

  UseFormsTemplateForProject() {
    var ReqModel = {
      formFolderId: 0,
      formId: this.FormID,
      formName: this.PlaceholderName,
      fileID: this.documentId,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      OfficeIDList: this.OfficeIDList,
      officeID: this.myOfficeID,
    };
    this.loaderService.show();
    this.formsService.UseFormsTemplateForProject(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          if (response.data.projectID > 0) {
            this.ProjectIdForEdit = response.data.projectID;
            this.openProject();
          }
        } else {
          this.loaderService.hide();
          this.dialog.closeAll();
        }
      } else {
        this.loaderService.hide();
        this.dialog.closeAll();
      }
    });
  }

  openProject() {
    this.dialog.closeAll();
    sessionStorage.setItem('projectID', this.ProjectIdForEdit);
    sessionStorage.setItem('type', ProjectTempType.Project.toString()); // 1 for Project and 2 for Template
    sessionStorage.setItem('ImportTemplateShow', 'true');
    sessionStorage.setItem('MasterTemplatePDFForm', 'false');
    sessionStorage.setItem('MasterTemplateTabularForm', 'false');
    sessionStorage.setItem('MasterOrgTemplatePDFForm', 'false');
    sessionStorage.setItem('MasterTemplateWebForm', 'false');
    this._dataSharingService.sendSelectedProjectName('');
    //this.router.navigate(['/esignature/second']);
    sessionStorage.setItem('HeaderModuleName', 'Forms');
    this._dataSharingService.sendSelectedModuleName('Forms');
    this._dataSharingService.sendSelectedFolderContentFromLeftMenu(null);
    window.open('/esignature/second', '_blank');
  }

  //   getLinkedText(): string {
  //     // Match and replace page numbers
  //     return this.text.replace(/\[p\.(\d+)]/g, (match, pageNum) => {
  //         return `<a href="#" onclick="goToPage(${pageNum})">p.${pageNum}</a>`;
  //     });
  // }


  goToPage(pageNum: number): void {
    // Logic for navigating to the page
    // Add navigation logic here (e.g., Router navigation)
  }

  getPageNumber(pageNumber: number) {
    this.CurrentPage = (pageNumber);
    this.ChangePage(pageNumber);
  }

  payChekSubmittedResult: any;
  isReCreate: boolean = false;
  paycheckErrorList: any = [] = [];
  associatedAPIs: any = [] = [];

  SendtoPendingPatientPCC() {
    //== For Core====//
    if (this.typeForAddCategory == 1) {
      this.associatedAPIs = JSON.parse(sessionStorage.getItem("associatedAPIs") || '[]');
      if (this.associatedAPIs.length > 0) {
        var checkPayCheck = [];
        var checkPCC = [];

        // checkPayCheck = this.associatedAPIs.filter((x:any) => x.apiName == 'Paychex' && x.isCoreMapped == true);
        // if (checkPayCheck.length > 0) {
        //   this.showPaycheck = true;
        // } else {
        //   this.showPaycheck = false;
        // }

        checkPCC = this.associatedAPIs.filter((x: any) => x.apiName == 'PointClickCare' && x.isCoreMapped == true);
        if (checkPCC.length > 0) {
          this.showPCC = true;
        } else {
          this.showPCC = false;
        }
      }
      if (this.typeId == undefined) {
        this.typeId = 0;
      }

      this.payChekSubmittedResult = [];
      var result: any = [] = [];
      var objs = {
        name: this.name,
        coreID: Number(this.transactionID),
        subFolderID: this.typeId
      }
      result.push(objs);

      this.payChekSubmittedResult = result;
      this.paycheckErrorList = [];
      if (result.length > 0 && result != "" && result != undefined) {

        var coreListForPaychex = [];
        var thirdPartyApiID = 0;
        var officeThirdPartyApiID = 0;

        if (this.associatedAPIs.find((x: any) => x.apiName == 'PointClickCare' && x.isCoreMapped == true)) {
          thirdPartyApiID = this.associatedAPIs.find((x: any) => x.apiName == 'PointClickCare' && x.isCoreMapped == true).thirdPartyApiID;
          officeThirdPartyApiID = this.associatedAPIs.find((x: any) => x.apiName == 'PointClickCare' && x.isCoreMapped == true).officeThirdPartyApiID;
        }

        for (let i = 0; i < result.length; i++) {
          var obj = {
            coreID: result[i].coreID,
            subFolderID: result[i].subFolderID,
          }
          coreListForPaychex.push(obj);
        }
        var ReqModel = {
          coreList: coreListForPaychex,
          folderID: this.folderID,
          thirdPartyApiID: thirdPartyApiID,
          officeThirdPartyApiID: officeThirdPartyApiID,
          userID: this.currentUser.UID,
          organizationID: Number(this.organizationId),
          officeID: this.myOfficeID,
          isrecreate: this.isReCreate
        }
        //return;  
        this.loaderService.show();
        this.coreService.sendToPendingPatientPCC(ReqModel).subscribe((response) => {
          if (response != undefined) {
            this.isReCreate = false;
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.loaderService.hide();
              var check: any = [];
              var checkError: any = [];
              check = this.responseHolder.data;
              check = check.pccResponses;

              let quotaExusted: any;
              let quotaExustedMessage = "";
              if (check.length > 0) {
                checkError = check.filter((x: any) => x.errors != null);
                checkError.forEach((ne: any) => {
                  ne.errors.forEach((ee: any) => {
                    if (ee.code == '100') {
                      quotaExusted = ee.code;
                      quotaExustedMessage = ee.detail;
                      var obj = {
                        name: "Temporary API Service Unavailability",
                        code: "API will start functioning at " + new Date(ee.xQuotaTimeToResetDateTime),
                        description: ee.detail,
                      }
                      this.paycheckErrorList.push(obj);
                      this.showPaycheckError("PointClickCare warning(s), please correct and submit again");
                    }
                  });
                  ne.errors = ne.errors.filter((m: any) => m.type == 0);
                });
                if (quotaExusted == '100') {
                  return;
                }
                checkError = checkError.filter((x: any) => x.errors.length != 0);
                if (checkError.length == 0) {
                  this.toastr.success('Record added in Pending Patient successfully.', '', {
                    timeOut: 3000,
                  });
                } else {

                  for (var i = 0, len = checkError.length; i < len; ++i) {

                    let list = [];
                    let name = "";
                    list = result.filter((x: any) => x.coreID == Number(checkError[i].coreID));
                    if (list.length > 0) {
                      name = list[0].name;
                    }
                    if (checkError[i].errors != null) {
                      checkError[i].errors.forEach((eelement: any) => {

                        var obj = {
                          name: name,
                          code: eelement.code,
                          description: eelement.detail,
                        }
                        this.paycheckErrorList.push(obj);
                      });
                    }
                  }
                  this.showPaycheckError("PointClickCare warning(s), please correct and submit again");
                }
              }
            }
          } else {
            this.loaderService.hide();
          }
        });
      }
    }
    //== For Contact====//
    if (this.typeForAddCategory == 2) {
      this.associatedAPIs = JSON.parse(sessionStorage.getItem('associatedAPIs') || '[]');
      if (this.associatedAPIs.length > 0) {
        var checkPayCheck = [];
        var checkPCC = [];

        // checkPayCheck = this.associatedAPIs.filter((x:any) => x.apiName == 'Paychex' && x.isContactMapped == true);
        // if (checkPayCheck.length > 0) {
        //   this.showPaycheck = true;
        // } else {
        //   this.showPaycheck = false;
        // }

        checkPCC = this.associatedAPIs.filter((x: any) => x.apiName == 'PointClickCare' && x.isContactMapped == true);
        if (checkPCC.length > 0) {
          this.showPCC = true;
        } else {
          this.showPCC = false;
        }
      }

      if (this.typeId == undefined) {
        this.typeId = 0;
      }

      this.payChekSubmittedResult = [];
      var result: any = [] = [];
      var objs1 = {
        name: this.name,
        contactID: Number(this.transactionID),
        subFolderID: this.typeId
      }
      result.push(objs1);

      this.payChekSubmittedResult = result;
      if (result.length > 0 && result != "" && result != undefined) {

        var contactListForPaychex = [];
        var thirdPartyApiID = 0;
        var officeThirdPartyApiID = 0;

        if (this.associatedAPIs.find((x: any) => x.apiName == 'PointClickCare' && x.isContactMapped == true)) {
          thirdPartyApiID = this.associatedAPIs.find((x: any) => x.apiName == 'PointClickCare' && x.isContactMapped == true).thirdPartyApiID;
          officeThirdPartyApiID = this.associatedAPIs.find((x: any) => x.apiName == 'PointClickCare' && x.isContactMapped == true).officeThirdPartyApiID;
        }

        for (let i = 0; i < result.length; i++) {
          var objj = {
            contactID: result[i].contactID,
            subFolderID: result[i].subFolderID,
          }
          contactListForPaychex.push(objj);
        }
        var ReqModels = {
          contactList: contactListForPaychex,
          folderID: this.folderID,
          thirdPartyApiID: thirdPartyApiID,
          officeThirdPartyApiID: officeThirdPartyApiID,
          userID: this.currentUser.UID,
          organizationID: Number(this.organizationId),
          officeID: this.myOfficeID,
          isrecreate: this.isReCreate
        }
        // return;   
        this.loaderService.show();
        this.coreService.sendToPCC(ReqModels).subscribe((response) => {
          if (response != undefined) {
            this.isReCreate = false;
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.loaderService.hide();
              var check: any = [];
              var checkError: any = [];
              check = this.responseHolder.data.response;
              if (check.length > 0) {
                checkError = check.filter((x: any) => x.status != this.statusConst.statusSuccess);
                if (checkError.length == 0) {
                  this.toastr.success('Record added in Paychex successfully.', '', {
                    timeOut: 3000,
                  });
                } else {
                  let list = [];
                  let name = "";
                  list = result.filter((x: any) => x.contactID == Number(checkError[0].data.content[0].employeeId));
                  if (list.length > 0) {
                    name = list[0].name;
                  }
                  for (var i = 0, len = checkError[0].data.errors.length; i < len; ++i) {
                    var obj = {
                      name: name,
                      code: checkError[0].data.errors[i].code,
                      description: checkError[0].data.errors[i].description,
                    }
                    this.paycheckErrorList.push(obj);
                  }
                  this.showPaycheckError();
                }
              }
            }
          } else {
            this.loaderService.hide();
          }
        });
      }
    }
    //== For Company====//
    if (this.typeForAddCategory == 3) {

      this.associatedAPIs = JSON.parse(sessionStorage.getItem("associatedAPIs") || '[]');
      if (this.associatedAPIs.length > 0) {
        var checkPayCheck = [];
        var checkPCC = [];

        // checkPayCheck = this.associatedAPIs.filter((x:any) => x.apiName == 'Paychex' && x.isCompanyMapped == true);
        // if (checkPayCheck.length > 0) {
        //   this.showPaycheck = true;
        // } else {
        //   this.showPaycheck = false;
        // }

        checkPCC = this.associatedAPIs.filter((x: any) => x.apiName == 'PointClickCare' && x.isCompanyMapped == true);
        if (checkPCC.length > 0) {
          this.showPCC = true;
        } else {
          this.showPCC = false;
        }
      }

      if (this.typeId == undefined) {
        this.typeId = 0;
      }

      this.payChekSubmittedResult = [];
      var result: any = [] = [];
      var objs11 = {
        name: this.name,
        companyID: Number(this.transactionID),
        subFolderID: this.typeId
      }
      result.push(objs11);

      this.payChekSubmittedResult = result;
      if (result.length > 0 && result != "" && result != undefined) {

        var companyListForPaychex = [];
        var thirdPartyApiID = 0;
        var officeThirdPartyApiID = 0;

        if (this.associatedAPIs.find((x: any) => x.apiName == 'PointClickCare' && x.isCompanyMapped == true)) {
          thirdPartyApiID = this.associatedAPIs.find((x: any) => x.apiName == 'PointClickCare' && x.isCompanyMapped == true).thirdPartyApiID;
          officeThirdPartyApiID = this.associatedAPIs.find((x: any) => x.apiName == 'PointClickCare' && x.isCompanyMapped == true).officeThirdPartyApiID;
        }

        for (let i = 0; i < result.length; i++) {
          var objq = {
            companyID: result[i].companyID,
            subFolderID: result[i].subFolderID,
          }
          companyListForPaychex.push(objq);
        }
        var ReqModelq = {
          companyList: companyListForPaychex,
          folderID: this.folderID,
          thirdPartyApiID: thirdPartyApiID,
          officeThirdPartyApiID: officeThirdPartyApiID,
          userID: this.currentUser.UID,
          organizationID: Number(this.organizationId),
          officeID: this.myOfficeID,
          isrecreate: this.isReCreate
        }
        // return;     
        this.loaderService.show();
        this.coreService.sendToPCCCompnay(ReqModelq).subscribe((response) => {
          if (response != undefined) {
            this.isReCreate = false;
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.loaderService.hide();
              var check: any = [];
              var checkError: any = [];
              check = this.responseHolder.data.response;
              if (check.length > 0) {
                checkError = check.filter((x: any) => x.status != this.statusConst.statusSuccess);
                if (checkError.length == 0) {
                  this.toastr.success('Record added in Paychex successfully.', '', {
                    timeOut: 3000,
                  });
                } else {
                  let list = [];
                  let name = "";
                  list = result.filter((x: any) => x.companyID == Number(checkError[0].data.content[0].employeeId));
                  if (list.length > 0) {
                    name = list[0].name;
                  }
                  for (var i = 0, len = checkError[0].data.errors.length; i < len; ++i) {
                    var obj = {
                      name: name,
                      code: checkError[0].data.errors[i].code,
                      description: checkError[0].data.errors[i].description,
                    }
                    this.paycheckErrorList.push(obj);
                  }
                  this.showPaycheckError();
                }
              }
            }
          } else {
            this.loaderService.hide();
          }
        });
      }
    }
  }


  showPaycheckError(title: any = null) {
    const dialogRef = this.dialog.open(PaycheckErrorComponent, {
      data: {
        list: this.paycheckErrorList,
        title: title,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.isReCreate = result;
        this.SendtoPaychexRecordForCore(this.payChekSubmittedResult);
      }
    });
  }

  SendtoPaychexRecordForCore(result: any) {
    this.payChekSubmittedResult = result;
    this.paycheckErrorList = [];
    if (result.length > 0 && result != "" && result != undefined) {

      var coreListForPaychex = [];
      var thirdPartyApiID = 0;
      var officeThirdPartyApiID = 0;

      if (this.associatedAPIs.find((x: any) => x.apiName == 'Paychex' && x.isCoreMapped == true)) {
        thirdPartyApiID = this.associatedAPIs.find((x: any) => x.apiName == 'Paychex' && x.isCoreMapped == true).thirdPartyApiID;
        officeThirdPartyApiID = this.associatedAPIs.find((x: any) => x.apiName == 'Paychex' && x.isCoreMapped == true).officeThirdPartyApiID;
      }

      for (let i = 0; i < result.length; i++) {
        var obj = {
          coreID: result[i].selectedRecord,
          subFolderID: result[i].subFolderID,
        }
        coreListForPaychex.push(obj);
      }
      var ReqModel = {
        coreList: coreListForPaychex,
        folderID: this.folderID,
        thirdPartyApiID: thirdPartyApiID,
        officeThirdPartyApiID: officeThirdPartyApiID,
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        officeID: this.myOfficeID,
        isrecreate: this.isReCreate
      }
      //return;  
      this.loaderService.show();
      this.coreService.sendToPaychex(ReqModel).subscribe((response) => {
        if (response != undefined) {
          this.isReCreate = false;
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.loaderService.hide();
            var check: any = [];
            var checkError: any = [];
            check = this.responseHolder.data.response;
            if (check.length > 0) {
              checkError = check.filter((x: any) => x.status != this.statusConst.statusSuccess);
              if (checkError.length == 0) {
                this.toastr.success('Record added in Paychex successfully.', '', {
                  timeOut: 3000,
                });
              } else {
                let list = [];
                let name = "";
                list = result.filter((x: any) => x.selectedRecord == Number(checkError[0].data.content[0].employeeId));
                if (list.length > 0) {
                  name = list[0].name;
                }
                for (var i = 0, len = checkError[0].data.errors.length; i < len; ++i) {
                  var obj = {
                    name: name,
                    code: checkError[0].data.errors[i].code,
                    description: checkError[0].data.errors[i].description,
                  }
                  this.paycheckErrorList.push(obj);
                }
                this.showPaycheckError();
              }
            }
          }
        } else {
          this.loaderService.hide();
        }
      });
    }
  }

  update3C() {
    // For Update Core Data
    if (this.typeForAddCategory == 1) {
      if (this.transactionID > 0) {
        this.getCoreUserDetailsforSubFolderId();
        //this.getCoreUserDetail();
      }
    }
    // For Update Contact Data
    if (this.typeForAddCategory == 2) {
      if (this.transactionID > 0) {
        this.getContactUserDetail();
      }
    }
    // For Update Company Data
    if (this.typeForAddCategory == 3) {
      if (this.transactionID > 0) {
        this.getCompanyUserDetail();
      }
    }
  }

  getTooltipText(): string {
    // Logic to determine which value to display
    if (this.typeForAddCategory == 1) {
      return "Update " + this.CoreShowName;
    }
    if (this.typeForAddCategory == 2) {
      return "Update " + this.ContactShowName;
    }
    if (this.typeForAddCategory == 3) {
      return "Update " + this.CompanyShowName;
    }
    return 'No information available';
  }

  getTooltipTextUpdate(): string {
    // Logic to determine which value to display
    if (this.typeForAddCategory == 1) {
      return "Update " + this.CoreShowName;
    }
    if (this.typeForAddCategory == 2) {
      return "Update " + this.ContactShowName;
    }
    if (this.typeForAddCategory == 3) {
      return "Update " + this.CompanyShowName;
    }
    return 'No information available';
  }

  getTooltipTextView(): string {
    if (this.typeForAddCategory == 1) {
      return "View " + this.CoreShowName;
    }
    if (this.typeForAddCategory == 2) {
      return "View " + this.ContactShowName;
    }
    if (this.typeForAddCategory == 3) {
      return "View " + this.CompanyShowName;
    }
    return 'No information available';
  }

  viewRecord() {
    if (this.typeForAddCategory == 1) {
      this.mainModuleNameForDetails = "Core";
    }
    if (this.typeForAddCategory == 2) {
      this.mainModuleNameForDetails = "Contact";
    }
    if (this.typeForAddCategory == 3) {
      this.mainModuleNameForDetails = "Company";
    }
    this.vieworUpdate = "View";
    this.showDetail = !this.showDetail;
  }

  updateRecord() {
    if (this.typeForAddCategory == 1) {
      this.mainModuleNameForDetails = "Core";
    }
    if (this.typeForAddCategory == 2) {
      this.mainModuleNameForDetails = "Contact";
    }
    if (this.typeForAddCategory == 3) {
      this.mainModuleNameForDetails = "Company";
    }
    this.vieworUpdate = "Update";
    this.showDetail = !this.showDetail;
  }

  showDetail: boolean = false;
  vieworUpdate: string = "";

  getCloseDetails(message: any) {
    this.showDetail = false;
  }

  pushMergedDocumentsTo3C() {
    var ReqModel = {
      cType: Number(this.typeForAddCategory),
      cid: Number(this.transactionID),
      fileID: Number(this.documentId),
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
    };
    this.loaderService.show();
    this.formsService.pushMergedDocumentsTo3C(ReqModel).subscribe(async (response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.toastr.success('Document pushed successfully.', '', {
            timeOut: 3000,
          });
        } else {
          this.loaderService.hide();
          this.toastr.error('Document pushed failed.', '', {
            timeOut: 3000,
          });
        }
      } else {
        this.toastr.error('Document pushed failed.', '', {
          timeOut: 3000,
        });
        this.loaderService.hide();
      }

    });
  }

  MergedFileHistoryList: any = [] = [];

  getMergedFileHistory() {
    var ReqModel = {
      fileID: Number(this.documentId),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId)
    }
    this.formsService.getMergedFileHistory(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.MergedFileHistoryList = this.responseHolder.data;
          if (this.MergedFileHistoryList == null) {
            this.MergedFileHistoryList = [];
          }
          if (this.MergedFileHistoryList.length > 0) {
            //this.ShowNoRecordFound=false;
          } else {
            // this.ShowNoRecordFound=true;
          }
        }
        else {
          // this.ShowNoRecordFound=true;
          this.MergedFileHistoryList = [];
        }
      }
      else {
        this.MergedFileHistoryList = [];
        //this.ShowNoRecordFound=true;        
      }
    });
  }

  show3cCancel: boolean = false;

  close3c() {
    this.toggleChange3c = false;
    this.show3cCancel = false;
  }

  open3cRecordInNewTab() {
    // if (this.typeForAddCategory == 1) {
    //   this.ShowAttchedToCore = true;
    // }
    // if (this.typeForAddCategory == 2) {
    //   this.ShowAttchedToContact = true;
    // }
    // if (this.typeForAddCategory == 3) {
    //   this.ShowAttchedToCompany = true;
    // }
    var TypeIdDrp = 0;
    if (this.typeForAddCategory == 1) {
      if (this.TypeIdDrp == undefined) {
        TypeIdDrp = 0;
      } else {
        TypeIdDrp = this.TypeIdDrp;
      }
      const id = this.transactionID.toString();
      sessionStorage.setItem('transactionID', id);
      sessionStorage.setItem('TypeID', (TypeIdDrp).toString());
      sessionStorage.setItem('moduleName', 'Core');
      window.open('/core/documents', '_blank');
    }

    if (this.typeForAddCategory == 2) {
      if (this.TypeIdDrp == undefined) {
        TypeIdDrp = 0;
      } else {
        TypeIdDrp = this.TypeIdDrp;
      }
      const id = this.transactionID.toString();
      sessionStorage.setItem('transactionID', id);
      sessionStorage.setItem('TypeID', (TypeIdDrp).toString());
      sessionStorage.setItem('moduleName', 'Contact');
      window.open('/contact/documents', '_blank');
    }

    if (this.typeForAddCategory == 3) {
      if (this.TypeIdDrp == undefined) {
        TypeIdDrp = 0;
      } else {
        TypeIdDrp = this.TypeIdDrp;
      }
      const id = this.transactionID.toString();
      sessionStorage.setItem('transactionID', id);
      sessionStorage.setItem('TypeID', (TypeIdDrp).toString());
      sessionStorage.setItem('moduleName', 'Company');
      window.open('/company/documents', '_blank');
    }

  }

  searchKeyValueData: string = "";
  showpdfbox: boolean = true;
  TitleForBox: string = "Hide/Show Boxes"

  searchKeyValueRecord(val: any) {
    if (val.length >= 1) {
      if (val != '') {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.allKeyValueDataListFilterForFormFeild = this.allKeyValueDataListFilterForFormFeildFilter.filter((i: any) =>
            (i.key && i.key.toLowerCase().includes(val.toLowerCase())) || (i.value && i.value.toLowerCase().includes(val.toLowerCase())));
        }, 500);
      } else {
        this.allKeyValueDataListFilterForFormFeild = this.allKeyValueDataListFilterForFormFeildFilter;
      }
    } else {
      this.allKeyValueDataListFilterForFormFeild = this.allKeyValueDataListFilterForFormFeildFilter;
    }
  }

  LoadFirstTime: boolean = true;

  async showPDFboxes(event: MatSlideToggleChange) {
    if (event.checked == false) {
      this.showpdfbox = false;
      this.LoadFirstTime = false;
      //this.TitleForBox="Hide Boxes";
      // this.clearPdfViewer();
      // this.clearPdfThumbnailViewer();
      // this.getFileManagerDetails();
      // await this.renderPDFWithBoundingBox();
      this.LoadPDFViewerData();
    } else {
      this.showpdfbox = true;
      this.LoadFirstTime = false;
      // this.TitleForBox="Show Boxes";
      //await this.renderPDFWithBoundingBox();
      // this.clearPdfViewer();
      // this.clearPdfThumbnailViewer();
      // this.getFileManagerDetails();
      this.LoadPDFViewerData();
    }

  }



  async LoadPDFViewerData() {
    if (this.ocrData != null) {
      // this.ocrData = this.responseHolder.data.ocrData;
      this.BoundingBoxKeyValueData = JSON.parse(this.ocrData);
      this.BoundingBoxKeyValueData = this.BoundingBoxKeyValueData.KeyValuePairs;
      await this.renderPDFWithBoundingBox();
      if (this.LoadFirstTime == true) {
        await this.renderPDFThumbnails(this.pdfarray);
      }
    } else {
      await this.renderPDFByURL(this.pdfarray);
      if (this.LoadFirstTime == true) {
        await this.renderPDFThumbnails(this.pdfarray);
      }
    }
  }


  @Output() documentViewers = new EventEmitter<boolean>();
  documentPath: string = "";
  fileType: string = "pdf";
  documentname: string = "";
  isRendering: boolean = false;

  openDocumentViewer(templateRef: TemplateRef<any>) {
    this.documentPath = this.documentPath;
    //  this.fileType = document.fileType;
    //  this.documentname =document.documentName;
    this.documentViewers.emit(true);
    this.dialog.open(templateRef);
  }

  getCloseDocumentViewer(_message: boolean) {
    this.documentViewers.emit(false);
    this.dialog.closeAll();
  }

  TitleDocs: string = "Zoom View";

  showDocs(event: MatSlideToggleChange) {
    if (event.checked == false) {
      this.showPdfViewer = false;
      this.TitleDocs = "Field View";
    } else {
      this.TitleDocs = "Zoom View";
      this.showPdfViewer = true;
    }

  }

  dropSytemFields(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.systemFeildsList, event.previousIndex, event.currentIndex);
    // ===  Save OCR Data =====//
    if (this.currentNavigation == NAVIGATION.AIData || this.currentNavigation == NAVIGATION.Qualifying) {
      this.saveMappedKeyValueData();
    }
  }

  showNewSaveFieldTemplate: boolean = false;
  ShowExistingSaveFieldTemplate: boolean = false;
  updateSelectedField: boolean = false;

  getTabDetailFieldTemplate(event: any) {
    this.showNewSaveFieldTemplate = true;
    this.ShowExistingSaveFieldTemplate = false;

    if (event.tab.textLabel == 'New' || event.index == 0) {
      let group = {};
      this.categoryType = 0;
      this.addTemplateForm = new FormGroup(group);
      this.createSaveAsTaskTemplate();
      this.getActiveTemplateCategoriesAfterAdd();
      this.showSaveTemplate = true;
      this.showNewSaveFieldTemplate = true;
      this.ShowExistingSaveFieldTemplate = false;
      this.updateSelectedField = false;
    }
    if (event.tab.textLabel == 'Update Existing' || event.index == 1) {
      this.showNewSaveFieldTemplate = false;
      this.ShowExistingSaveFieldTemplate = true;
      this.updateSelectedField = false;
      this.categoryType = 0;
      this.getActiveTemplateCategoriesAfterAdd();
      this.selectedcategoryIDForImportTemp = 0;
      this.TemplateIDImportTask = 0;
      this.currentIndex = 0;
      this.getOCRTemplate();
    }
  }

  updateSelectedRecord: any;

  SelectFieldTemplate(data: any) {
    this.updateSelectedField = true;
    this.updateSelectedRecord = data;
  }

  UpdateFieldTemplate() {
    // if (this.systemFeildsList.length == 0) {
    //   this.toastr.warning('Please add system fields.', '', {
    //     timeOut: 3000,
    //   });
    //   return;
    // }
    var systemFeilds = [];
    if (this.systemFeildsList.length > 0) {
      for (let i = 0; i < this.systemFeildsList.length; i++) {
        var obj = {
          position: i + 1,
          // fieldName: this.systemFeildsList[i].fieldName,
          fieldID: this.systemFeildsList[i].fieldID,
        };
        systemFeilds.push(obj);
      }
    }
    this.loaderService.show();
    var ReqModel = {
      templateID: this.updateSelectedRecord.templateID,
      templateName: this.updateSelectedRecord.tempalteName,
      templateType: this.categoryType, // For My Template
      cType: this.updateSelectedRecord.cType,//this.typeForAddCategory,
      categoryID: this.updateSelectedRecord.categoryID,
      templateFields: systemFeilds,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
    };
    this.spinner = true;
    this.addTemplateForm.markAsPristine();
    this.formsService.addOcrTemplates(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.spinner = false;
          this.loaderService.hide();
          this.toastr.success('Selected Template update successfully.', '', {
            timeOut: 3000,
          });
          this.closeSaveAsTemplate();
        } else {
          this.toastr.error('Selected Template update failed.', '', {
            timeOut: 3000,
          });
          this.spinner = false;
          this.loaderService.hide();
        }
      } else {
        this.toastr.error('Selected Template update failed.', '', {
          timeOut: 3000,
        });
        this.spinner = false;
        this.loaderService.hide();
      }
    });

  }

  showProceed3c = false;
  proceed3c() {
    this.showProceed3c = true;
  }


  //=========== Qualifying  =======================//

  ThresholdList: any = [] = [];
  activeTab: 'questions' | 'scoring' | 'threshold' = 'questions';
  gridsize: number = 0;

  onQualifyingTabChange(tab: 'questions' | 'scoring' | 'threshold') {
    this.activeTab = tab;
    if (tab == "threshold") {
      this.getThresholdRules();
    }
  }

  addAIQualificationTemp() {
    if (this.rules.length >= 20) {
      this.toastr.warning('A maximum of 20 AI Qualifying Questions is allowed.', '', {
        timeOut: 6000,
      });
      return;
    }
    const dialogRef = this.dialog.open(AddAIQualificationTemplateComponent, {
      data: {
        questionID: 0,
        coreId: this.transactionID,
        documentId: this.documentId,
        referralID: this.referralID,
        // total:this.rules.length
      },
      width: '45vw',
      height: 'auto',
      panelClass: 'custom-dialog-container'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {
        this.getThresholdRules();
      }
    });
  }

  TotalThresholdValue: number = 0;
  HalfThresholdValue: number = 0;

  getThresholdRules() {
    var ReqModel = {
      coreID: this.transactionID,
      documentID: this.documentId,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
    };
    this.formsService.getReferralQuestionAnswers(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.referralID = this.responseHolder.data.referralID;
          this.ThresholdList = this.responseHolder.data.questions;
          this.rules = this.ThresholdList;
          this.rulesCount = this.ThresholdList.filter((x: any) => x.mandatoryRule == true);

          if (this.ThresholdList.length > 0) {
            //if(this.updateThresholdValues==false){            
            this.TotalThresholdValue = this.responseHolder.data.totalThresholdValue;//(this.ThresholdList.length)*10;//this.ThresholdList.reduce((sum, item) => sum + item.weight,0);
            this.HalfThresholdValue = this.responseHolder.data.thresholdValue;//this.TotalThresholdValue / 2;
            this.gridsize = this.HalfThresholdValue;
            //}
          }
        } else {
          this.rules = [];
        }
      } else {
        this.rules = [];
      }
    });
  }



  getDeletedRule(result: any) {
    var ReqModel = {
      quetionID: result[0].quetionID,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
    };
    this.formsService.removeThresholdRules(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.toastr.success('Record deleted successfully.', '', {
            timeOut: 3000,
          });
          this.getThresholdRules();
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  saveUpdateTemplateQualifying() {
    const dialogRef = this.dialog.open(SaveUpdateQualifyingTemplate, {
      data: {
        thresholdValue: this.gridsize,
        transactionID: this.transactionID,
        documentId: this.documentId,
        thresholdRulesList: this.rules,
        total: this.rules.length,
      },
      width: '45vw',
      height: 'auto',
      panelClass: 'custom-dialog-container'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {

      }
    });
  }

  importReferralTemplate() {
    const dialogRef = this.dialog.open(ImportQualifyingTemplateComponent, {
      data: {
        From: "AITools",
        transactionID: this.transactionID,
        documentId: this.documentId,
        total: this.rules.length,
      },
      width: '45vw',
      height: 'auto',
      panelClass: 'custom-dialog-container'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {
        this.getThresholdRules();
      }
    });
  }



  rules: any = [] = [];
  rulesCount: any = [] = [];

  selectedType: string = "";
  isMandatoryPass: boolean = false;
  isMandatoryRule: boolean = false;

  onTypeSelect(type: any, rule: any) {
    this.selectedType = type;

    if (this.selectedType == "PASS") {
      this.isMandatoryPass = true;
    }
    if (this.selectedType == "FAIL") {
      this.isMandatoryPass = false;
    }
    rule.isMandatoryPass = this.isMandatoryPass;
  }

  onMandatoryChange(event: MatCheckboxChange, rule: any) {
    this.isMandatoryRule = event.checked;
    if (this.isMandatoryRule == true) {
      this.selectedType = "PASS";
    }
    rule.mandatoryRule = event.checked;
  }

  deleteRule(rule: any, removeIndex: any) {
    this.deletedQuery = [];
    var message = `Are you sure you want to delete?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData
    });
    dialogRef.beforeClosed().subscribe(async dialogResult => {
      if (dialogResult) {
        this.deletedQuery.push(rule);
        this.getDeletedRule(this.deletedQuery);
      }
    });
  }

  editRule(rule: any, removeIndex: any) {
    const dialogRef = this.dialog.open(AddAIQualificationTemplateComponent, {
      data: {
        allrecords:this.rules,
        records: rule,
        questionID: rule.quetionID,
        coreId: this.transactionID,
        documentId: this.documentId,
        referralID: this.referralID
      },
      width: '45vw',
      height: 'auto',
      panelClass: 'custom-dialog-container'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {
        this.getThresholdRules();
      }
    });
  }

  UpdateThresholdRules() {
    var tempQuery = [];
    if (this.rules.length > 0) {
      for (let i = 0; i < this.rules.length; i++) {
        if (this.rules[i].mandatoryRule == false) {
          this.rules[i].isMandatoryPass = false;
        }
        var obj = {
          questionID: this.rules[i].quetionID,
          questionTitle: this.rules[i].questionTitle,
          weight: this.rules[i].weight,
          position: this.rules[i].position,
          isMandatoryPass: this.rules[i].isMandatoryPass,
          mandatoryRule: this.rules[i].mandatoryRule,
          isFollowUpFlag: this.rules[i].isFollowUpFlag
        };
        tempQuery.push(obj);
      }
    }
    var ReqModel = {
      referrralID: this.referralID,
      updateReferralQueueQuetion: tempQuery,
      userID: this.currentUser.UID,
      thresholdValue: this.gridsize,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
    };
    this.loaderService.show();
    this.formsService.updateThresholdRules(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.toastr.success('Record update successfully.', '', {
            timeOut: 3000,
          });
          this.getThresholdRules();
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  updateThresholdValues: boolean = false;

  updateThresholdValue() {
    var ReqModel = {
      referrralID: this.referralID,
      thresholdValue: this.gridsize,
      updateReferralQueueQuetion: null,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
    };
    this.loaderService.show();
    this.formsService.updateThresholdRules(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.toastr.success('Threshold Value update successfully.', '', {
            timeOut: 3000,
          });
          this.updateThresholdValues = true;
          this.getThresholdRules();
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }


  dropRule(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.rules, event.previousIndex, event.currentIndex);
    var record: any = [] = [];
    var reOrdersList: any = [] = [];
    record = this.rules;
    if (record.length > 0) {
      reOrdersList = [];
      for (let i = 0; i < record.length; i++) {
        var obj = {
          quetionID: record[i].quetionID,
          position: i + 1
        }
        reOrdersList.push(obj);
      }

      var reqModel = {
        referralID: this.referralID,
        rules: reOrdersList,
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        officeID: this.myOfficeID,
        databaseID: Number(this.databaseId)
      }
      this.loaderService.show();
      this.formsService.reorderThresholdRules(reqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          this.loaderService.hide();
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.getThresholdRules();
          } else {
            this.loaderService.hide();
          }
        } else {
          this.loaderService.hide();
        }
      });
    }
  }

  importMemoryCard(item: any) {
    const dialogRef = this.dialog.open(ImportMemoryTemplateComponent, {
      data: {
        questionsData: item,
        referralID: this.referralID,
        // documentId: this.documentId,
        // thresholdRulesList: this.rules
      },
      width: '45vw',
      height: 'auto',
      panelClass: 'custom-dialog-container'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {
        this.getThresholdRules();
      }
    });
  }

  addMemoryCard(item: any) {
    const dialogRef = this.dialog.open(SaveUpdateMemoryCardTemplateComponent, {
      data: {
        questionsData: item,
        referralID: this.referralID,
        // documentId: this.documentId,
        // thresholdRulesList: this.rules
      },
      width: '45vw',
      height: 'auto',
      panelClass: 'custom-dialog-container'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {
        this.getThresholdRules();
      }
    });
  }

  viewMemoryCard(item: any) {
    const dialogRef = this.dialog.open(MemoryCardDetailsComponent, {
      data: {
        memoryCardName: item.memoryCard.memoryCardName,
        memoryDescription: item.memoryCard.memoryDescription,
      },
      width: '45vw',
      height: 'auto',
      panelClass: 'custom-dialog-container'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {

      }
    });
  }

  RemoveMemoryCard(rule: any) {
    var message = `Are you sure you want to remove selected memory card?`;
    const title = `Confirm Remove`;
    const confirm = `Remove`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData
    });
    dialogRef.beforeClosed().subscribe(async dialogResult => {
      if (dialogResult) {
        var ReqModel = {
          referralQuestionMemoryCardID: Number(rule.memoryCard.referralQuetionMemoryCardID),
          userID: this.currentUser.UID,
          officeID: this.myOfficeID,
          officeIDList: this.OfficeIDList,
          organizationID: Number(this.organizationId),
          databaseID: Number(this.databaseId),
        };
        this.formsService.removeMemoryCardFromReferralQuestion(ReqModel).subscribe((response) => {
          if (response != undefined) {
            this.responseHolder = response;
            this.loaderService.hide();
            if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
              this.toastr.success('Record deleted successfully.', '', {
                timeOut: 3000,
              });
              this.getThresholdRules();
            } else {
              this.loaderService.hide();
            }
          } else {
            this.loaderService.hide();
          }
        });
      }
    });
  }

  addNotes() {
    const dialogRef = this.dialog.open(AddAIDocumentNotesComponent, {
      data: {
        referralID: this.referralID,
        documentId: this.documentId,
        noteID: this.noteID,
        noteTitle: this.noteTitle,
        noteDescription: this.noteDescription
      },
      width: '45vw',
      height: 'auto',
      panelClass: 'custom-dialog-container'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {
        this.getFileManagerDetailsForNotes();
      }
    });
  }

  openlinks() {
    const dialogRef = this.dialog.open(AddAIDocumentLinksComponent, {
      data: {
        referralID: this.referralID,
        // documentId: this.documentId,
        // thresholdRulesList: this.rules
      },
      width: '45vw',
      height: 'auto',
      panelClass: 'custom-dialog-container'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {
        // this.getThresholdRules();
      }
    });
  }


  ReRunAutomationForAITool() {
    var ReqModel = {
      aiAutomationID: this.aiAutomationID,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId)
    }
    this.toastr.success('The automation process may take a few minutes. You can continue other tasks on Flowtrics and refresh the list later to check the status.', '', {
      timeOut: 9000,
    });
    this.formsService.reRunAutomationForAITool(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
      }
      else {
        this.loaderService.hide();
      }
    });
  }

  ReRunAutomationForQualifying() {
    var ReqModel = {
      aiAutomationID: this.aiAutomationID,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId)
    }
    this.toastr.success('The automation process may take a few minutes. You can continue other tasks on Flowtrics and refresh the list later to check the status.', '', {
      timeOut: 9000,
    });
    this.formsService.reRunAutomationForQualifying(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
      }
      else {
        this.loaderService.hide();
      }
    });
  }

  isFollowUpFlag:boolean=false;

   onFollowUpFlagChange(event: MatCheckboxChange, rule: any) {
    this.isFollowUpFlag = event.checked;    
    rule.isFollowUpFlag = event.checked;
  }  

  copiedValue: any = null;

 copyExtractedValue(value: string, item: any): void {
  if (!value) {
    return;
  }

  navigator.clipboard.writeText(value).then(() => {

    this.copiedValue = item;

    this.toastr.success('Value copied successfully.', '', {
      timeOut: 1000
    });

    // Change icon back after 2 seconds
    setTimeout(() => {
      if (this.copiedValue === item) {
        this.copiedValue = null;
      }
    }, 1000);

  }).catch(() => {
    this.toastr.error('Unable to copy value');
  });
}

}

interface FoodNode {
  formFolderName: string;
  children?: FoodNode[];
  formFolderID: number;
  parentID: number;
  isShared: boolean;
}

/** Flat node with expandable and level information */
interface ExampleFlatNode {
  expandable: boolean;
  formFolderName: string;
  level: number;
  formFolderID: number;
  parentID: number;
  isShared: boolean;
}

